//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    validatePassword(password: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Account/ValidatePassword?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processValidatePassword(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processValidatePassword(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidatePassword(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    validatePasswordV2(password: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Account/ValidatePasswordV2?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processValidatePasswordV2(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processValidatePasswordV2(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidatePasswordV2(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getPasswordRequirements(): Observable<{ [key: string]: string; }>
    {
        let url_ = this.baseUrl + "/Account/GetPasswordRequirements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetPasswordRequirements(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetPasswordRequirements(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetPasswordRequirements(response: HttpResponseBase): Observable<{ [key: string]: string; }>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return OK
     */
    getPasswordRequirementsV2(): Observable<{ [key: string]: string; }>
    {
        let url_ = this.baseUrl + "/Account/GetPasswordRequirementsV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetPasswordRequirementsV2(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetPasswordRequirementsV2(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetPasswordRequirementsV2(response: HttpResponseBase): Observable<{ [key: string]: string; }>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param model_isCustomer (optional) 
     * @param model_username (optional) 
     * @param model_custID (optional) 
     * @param model_dataLogical (optional) 
     * @param model_password (optional) 
     * @param company_webDisplayTransactions (optional) 
     * @param company_webDisplayEquipment (optional) 
     * @param company_webDisplayCompanyName (optional) 
     * @param company_webSwoDlvs (optional) 
     * @param company_webSwoOnly (optional) 
     * @param company_webDlvOnly (optional) 
     * @param company_webMagtekScanner (optional) 
     * @param company_webCharts (optional) 
     * @param company_webNoLegalPymts (optional) 
     * @param company_webApsSignUpAvailable (optional) 
     * @param company_keyName (optional) 
     * @param company_keyUsrOrPrg (optional) 
     * @param company_desc (optional) 
     * @param company_prtNo1 (optional) 
     * @param company_pauseBefore (optional) 
     * @param company_pauseAfter (optional) 
     * @param company_ntVersion (optional) 
     * @param company_passwordReq (optional) 
     * @param company_secureOverride (optional) 
     * @param company_corpEmail (optional) 
     * @param company_webEmail (optional) 
     * @param company_webSiteAddr (optional) 
     * @param company_mailServer (optional) 
     * @param company_corpLanguage (optional) 
     * @param company_corpDateFormat (optional) 
     * @param company_mapModule (optional) 
     * @param company_imgModule (optional) 
     * @param company_calModule (optional) 
     * @param company_ecomModule (optional) 
     * @param company_terabyte (optional) 
     * @param company_webHits (optional) 
     * @param company_batchMode (optional) 
     * @param company_chartModule (optional) 
     * @param company_currRevision (optional) 
     * @param company_webinqModule (optional) 
     * @param company_smtpUsername (optional) 
     * @param company_smtpPassword (optional) 
     * @param company_smtpSsl (optional) 
     * @param company_nextSeq (optional) 
     * @param company_apsToken (optional) 
     * @param company_apsCpayRecNo (optional) 
     * @param company_apsCmstRecNo1 (optional) 
     * @param company_apsCpayRecNoAlt (optional) 
     * @param company_apsCmstRecNoAlt (optional) 
     * @param company_apsServer (optional) 
     * @param company_apsAvail (optional) 
     * @param company_apsCardAvailable1 (optional) 
     * @param company_apsBankAvailable1 (optional) 
     * @param company_apsCachRecNo1 (optional) 
     * @param company_apsCachRecNoAlt1 (optional) 
     * @param company_apsProcessor (optional) 
     * @param company_version (optional) 
     * @param company_dataNumber (optional) 
     * @param company_dataDateTime (optional) 
     * @param company_corpId (optional) 
     * @param company_name (optional) 
     * @param company_phone (optional) 
     * @param company_address1 (optional) 
     * @param company_address2 (optional) 
     * @param company_address3 (optional) 
     * @param company_city (optional) 
     * @param company_state (optional) 
     * @param company_zip (optional) 
     * @param company_runCode (optional) 
     * @param company_gpsLat (optional) 
     * @param company_gpsLong (optional) 
     * @param company_gpsLatNS (optional) 
     * @param company_gpsLongEW (optional) 
     * @param company_decimalGpsLat (optional) 
     * @param company_decimalGpsLon (optional) 
     * @param company_branchNo (optional) 
     * @param company_rowState (optional) 
     * @param company_isChecked (optional) 
     * @param company_messageId (optional) 
     * @return OK
     */
    login(passwordMeetsRequirements: boolean, model_isCustomer?: boolean | null | undefined, model_username?: string | null | undefined, model_custID?: string | null | undefined, model_dataLogical?: string | null | undefined, model_password?: string | null | undefined, company_webDisplayTransactions?: boolean | null | undefined, company_webDisplayEquipment?: boolean | null | undefined, company_webDisplayCompanyName?: boolean | null | undefined, company_webSwoDlvs?: boolean | null | undefined, company_webSwoOnly?: boolean | null | undefined, company_webDlvOnly?: boolean | null | undefined, company_webMagtekScanner?: boolean | null | undefined, company_webCharts?: boolean | null | undefined, company_webNoLegalPymts?: boolean | null | undefined, company_webApsSignUpAvailable?: boolean | null | undefined, company_keyName?: string | null | undefined, company_keyUsrOrPrg?: string | null | undefined, company_desc?: string | null | undefined, company_prtNo1?: number | null | undefined, company_pauseBefore?: number | null | undefined, company_pauseAfter?: number | null | undefined, company_ntVersion?: number | null | undefined, company_passwordReq?: number | null | undefined, company_secureOverride?: number | null | undefined, company_corpEmail?: string | null | undefined, company_webEmail?: string | null | undefined, company_webSiteAddr?: string | null | undefined, company_mailServer?: string | null | undefined, company_corpLanguage?: number | null | undefined, company_corpDateFormat?: number | null | undefined, company_mapModule?: number | null | undefined, company_imgModule?: number | null | undefined, company_calModule?: number | null | undefined, company_ecomModule?: number | null | undefined, company_terabyte?: number | null | undefined, company_webHits?: number | null | undefined, company_batchMode?: number | null | undefined, company_chartModule?: number | null | undefined, company_currRevision?: string | null | undefined, company_webinqModule?: number | null | undefined, company_smtpUsername?: string | null | undefined, company_smtpPassword?: string | null | undefined, company_smtpSsl?: number | null | undefined, company_nextSeq?: number | null | undefined, company_apsToken?: string | null | undefined, company_apsCpayRecNo?: number | null | undefined, company_apsCmstRecNo1?: number | null | undefined, company_apsCpayRecNoAlt?: number | null | undefined, company_apsCmstRecNoAlt?: number | null | undefined, company_apsServer?: number | null | undefined, company_apsAvail?: boolean | null | undefined, company_apsCardAvailable1?: number | null | undefined, company_apsBankAvailable1?: number | null | undefined, company_apsCachRecNo1?: number | null | undefined, company_apsCachRecNoAlt1?: number | null | undefined, company_apsProcessor?: number | null | undefined, company_version?: string | null | undefined, company_dataNumber?: number | null | undefined, company_dataDateTime?: Date | null | undefined, company_corpId?: string | null | undefined, company_name?: string | null | undefined, company_phone?: string | null | undefined, company_address1?: string | null | undefined, company_address2?: string | null | undefined, company_address3?: string | null | undefined, company_city?: string | null | undefined, company_state?: string | null | undefined, company_zip?: string | null | undefined, company_runCode?: number | null | undefined, company_gpsLat?: number | null | undefined, company_gpsLong?: number | null | undefined, company_gpsLatNS?: string | null | undefined, company_gpsLongEW?: string | null | undefined, company_decimalGpsLat?: number | null | undefined, company_decimalGpsLon?: number | null | undefined, company_branchNo?: number | null | undefined, company_rowState?: RowState | null | undefined, company_isChecked?: boolean | null | undefined, company_messageId?: string | null | undefined): Observable<any>
    {
        let url_ = this.baseUrl + "/Account/Login?";
        if (passwordMeetsRequirements === undefined || passwordMeetsRequirements === null)
            throw new Error("The parameter 'passwordMeetsRequirements' must be defined and cannot be null.");
        else
            url_ += "passwordMeetsRequirements=" + encodeURIComponent("" + passwordMeetsRequirements) + "&";
        if (model_isCustomer !== undefined && model_isCustomer !== null)
            url_ += "model.isCustomer=" + encodeURIComponent("" + model_isCustomer) + "&";
        if (model_username !== undefined && model_username !== null)
            url_ += "model.username=" + encodeURIComponent("" + model_username) + "&";
        if (model_custID !== undefined && model_custID !== null)
            url_ += "model.custID=" + encodeURIComponent("" + model_custID) + "&";
        if (model_dataLogical !== undefined && model_dataLogical !== null)
            url_ += "model.dataLogical=" + encodeURIComponent("" + model_dataLogical) + "&";
        if (model_password !== undefined && model_password !== null)
            url_ += "model.password=" + encodeURIComponent("" + model_password) + "&";
        if (company_webDisplayTransactions !== undefined && company_webDisplayTransactions !== null)
            url_ += "company.webDisplayTransactions=" + encodeURIComponent("" + company_webDisplayTransactions) + "&";
        if (company_webDisplayEquipment !== undefined && company_webDisplayEquipment !== null)
            url_ += "company.webDisplayEquipment=" + encodeURIComponent("" + company_webDisplayEquipment) + "&";
        if (company_webDisplayCompanyName !== undefined && company_webDisplayCompanyName !== null)
            url_ += "company.webDisplayCompanyName=" + encodeURIComponent("" + company_webDisplayCompanyName) + "&";
        if (company_webSwoDlvs !== undefined && company_webSwoDlvs !== null)
            url_ += "company.webSwoDlvs=" + encodeURIComponent("" + company_webSwoDlvs) + "&";
        if (company_webSwoOnly !== undefined && company_webSwoOnly !== null)
            url_ += "company.webSwoOnly=" + encodeURIComponent("" + company_webSwoOnly) + "&";
        if (company_webDlvOnly !== undefined && company_webDlvOnly !== null)
            url_ += "company.webDlvOnly=" + encodeURIComponent("" + company_webDlvOnly) + "&";
        if (company_webMagtekScanner !== undefined && company_webMagtekScanner !== null)
            url_ += "company.webMagtekScanner=" + encodeURIComponent("" + company_webMagtekScanner) + "&";
        if (company_webCharts !== undefined && company_webCharts !== null)
            url_ += "company.webCharts=" + encodeURIComponent("" + company_webCharts) + "&";
        if (company_webNoLegalPymts !== undefined && company_webNoLegalPymts !== null)
            url_ += "company.webNoLegalPymts=" + encodeURIComponent("" + company_webNoLegalPymts) + "&";
        if (company_webApsSignUpAvailable !== undefined && company_webApsSignUpAvailable !== null)
            url_ += "company.webApsSignUpAvailable=" + encodeURIComponent("" + company_webApsSignUpAvailable) + "&";
        if (company_keyName !== undefined && company_keyName !== null)
            url_ += "company.keyName=" + encodeURIComponent("" + company_keyName) + "&";
        if (company_keyUsrOrPrg !== undefined && company_keyUsrOrPrg !== null)
            url_ += "company.keyUsrOrPrg=" + encodeURIComponent("" + company_keyUsrOrPrg) + "&";
        if (company_desc !== undefined && company_desc !== null)
            url_ += "company.desc=" + encodeURIComponent("" + company_desc) + "&";
        if (company_prtNo1 !== undefined && company_prtNo1 !== null)
            url_ += "company.prtNo1=" + encodeURIComponent("" + company_prtNo1) + "&";
        if (company_pauseBefore !== undefined && company_pauseBefore !== null)
            url_ += "company.pauseBefore=" + encodeURIComponent("" + company_pauseBefore) + "&";
        if (company_pauseAfter !== undefined && company_pauseAfter !== null)
            url_ += "company.pauseAfter=" + encodeURIComponent("" + company_pauseAfter) + "&";
        if (company_ntVersion !== undefined && company_ntVersion !== null)
            url_ += "company.ntVersion=" + encodeURIComponent("" + company_ntVersion) + "&";
        if (company_passwordReq !== undefined && company_passwordReq !== null)
            url_ += "company.passwordReq=" + encodeURIComponent("" + company_passwordReq) + "&";
        if (company_secureOverride !== undefined && company_secureOverride !== null)
            url_ += "company.secureOverride=" + encodeURIComponent("" + company_secureOverride) + "&";
        if (company_corpEmail !== undefined && company_corpEmail !== null)
            url_ += "company.corpEmail=" + encodeURIComponent("" + company_corpEmail) + "&";
        if (company_webEmail !== undefined && company_webEmail !== null)
            url_ += "company.webEmail=" + encodeURIComponent("" + company_webEmail) + "&";
        if (company_webSiteAddr !== undefined && company_webSiteAddr !== null)
            url_ += "company.webSiteAddr=" + encodeURIComponent("" + company_webSiteAddr) + "&";
        if (company_mailServer !== undefined && company_mailServer !== null)
            url_ += "company.mailServer=" + encodeURIComponent("" + company_mailServer) + "&";
        if (company_corpLanguage !== undefined && company_corpLanguage !== null)
            url_ += "company.corpLanguage=" + encodeURIComponent("" + company_corpLanguage) + "&";
        if (company_corpDateFormat !== undefined && company_corpDateFormat !== null)
            url_ += "company.corpDateFormat=" + encodeURIComponent("" + company_corpDateFormat) + "&";
        if (company_mapModule !== undefined && company_mapModule !== null)
            url_ += "company.mapModule=" + encodeURIComponent("" + company_mapModule) + "&";
        if (company_imgModule !== undefined && company_imgModule !== null)
            url_ += "company.imgModule=" + encodeURIComponent("" + company_imgModule) + "&";
        if (company_calModule !== undefined && company_calModule !== null)
            url_ += "company.calModule=" + encodeURIComponent("" + company_calModule) + "&";
        if (company_ecomModule !== undefined && company_ecomModule !== null)
            url_ += "company.ecomModule=" + encodeURIComponent("" + company_ecomModule) + "&";
        if (company_terabyte !== undefined && company_terabyte !== null)
            url_ += "company.terabyte=" + encodeURIComponent("" + company_terabyte) + "&";
        if (company_webHits !== undefined && company_webHits !== null)
            url_ += "company.webHits=" + encodeURIComponent("" + company_webHits) + "&";
        if (company_batchMode !== undefined && company_batchMode !== null)
            url_ += "company.batchMode=" + encodeURIComponent("" + company_batchMode) + "&";
        if (company_chartModule !== undefined && company_chartModule !== null)
            url_ += "company.chartModule=" + encodeURIComponent("" + company_chartModule) + "&";
        if (company_currRevision !== undefined && company_currRevision !== null)
            url_ += "company.currRevision=" + encodeURIComponent("" + company_currRevision) + "&";
        if (company_webinqModule !== undefined && company_webinqModule !== null)
            url_ += "company.webinqModule=" + encodeURIComponent("" + company_webinqModule) + "&";
        if (company_smtpUsername !== undefined && company_smtpUsername !== null)
            url_ += "company.smtpUsername=" + encodeURIComponent("" + company_smtpUsername) + "&";
        if (company_smtpPassword !== undefined && company_smtpPassword !== null)
            url_ += "company.smtpPassword=" + encodeURIComponent("" + company_smtpPassword) + "&";
        if (company_smtpSsl !== undefined && company_smtpSsl !== null)
            url_ += "company.smtpSsl=" + encodeURIComponent("" + company_smtpSsl) + "&";
        if (company_nextSeq !== undefined && company_nextSeq !== null)
            url_ += "company.nextSeq=" + encodeURIComponent("" + company_nextSeq) + "&";
        if (company_apsToken !== undefined && company_apsToken !== null)
            url_ += "company.apsToken=" + encodeURIComponent("" + company_apsToken) + "&";
        if (company_apsCpayRecNo !== undefined && company_apsCpayRecNo !== null)
            url_ += "company.apsCpayRecNo=" + encodeURIComponent("" + company_apsCpayRecNo) + "&";
        if (company_apsCmstRecNo1 !== undefined && company_apsCmstRecNo1 !== null)
            url_ += "company.apsCmstRecNo1=" + encodeURIComponent("" + company_apsCmstRecNo1) + "&";
        if (company_apsCpayRecNoAlt !== undefined && company_apsCpayRecNoAlt !== null)
            url_ += "company.apsCpayRecNoAlt=" + encodeURIComponent("" + company_apsCpayRecNoAlt) + "&";
        if (company_apsCmstRecNoAlt !== undefined && company_apsCmstRecNoAlt !== null)
            url_ += "company.apsCmstRecNoAlt=" + encodeURIComponent("" + company_apsCmstRecNoAlt) + "&";
        if (company_apsServer !== undefined && company_apsServer !== null)
            url_ += "company.apsServer=" + encodeURIComponent("" + company_apsServer) + "&";
        if (company_apsAvail !== undefined && company_apsAvail !== null)
            url_ += "company.apsAvail=" + encodeURIComponent("" + company_apsAvail) + "&";
        if (company_apsCardAvailable1 !== undefined && company_apsCardAvailable1 !== null)
            url_ += "company.apsCardAvailable1=" + encodeURIComponent("" + company_apsCardAvailable1) + "&";
        if (company_apsBankAvailable1 !== undefined && company_apsBankAvailable1 !== null)
            url_ += "company.apsBankAvailable1=" + encodeURIComponent("" + company_apsBankAvailable1) + "&";
        if (company_apsCachRecNo1 !== undefined && company_apsCachRecNo1 !== null)
            url_ += "company.apsCachRecNo1=" + encodeURIComponent("" + company_apsCachRecNo1) + "&";
        if (company_apsCachRecNoAlt1 !== undefined && company_apsCachRecNoAlt1 !== null)
            url_ += "company.apsCachRecNoAlt1=" + encodeURIComponent("" + company_apsCachRecNoAlt1) + "&";
        if (company_apsProcessor !== undefined && company_apsProcessor !== null)
            url_ += "company.apsProcessor=" + encodeURIComponent("" + company_apsProcessor) + "&";
        if (company_version !== undefined && company_version !== null)
            url_ += "company.version=" + encodeURIComponent("" + company_version) + "&";
        if (company_dataNumber !== undefined && company_dataNumber !== null)
            url_ += "company.dataNumber=" + encodeURIComponent("" + company_dataNumber) + "&";
        if (company_dataDateTime !== undefined && company_dataDateTime !== null)
            url_ += "company.dataDateTime=" + encodeURIComponent(company_dataDateTime ? "" + company_dataDateTime.toISOString() : "") + "&";
        if (company_corpId !== undefined && company_corpId !== null)
            url_ += "company.corpId=" + encodeURIComponent("" + company_corpId) + "&";
        if (company_name !== undefined && company_name !== null)
            url_ += "company.name=" + encodeURIComponent("" + company_name) + "&";
        if (company_phone !== undefined && company_phone !== null)
            url_ += "company.phone=" + encodeURIComponent("" + company_phone) + "&";
        if (company_address1 !== undefined && company_address1 !== null)
            url_ += "company.address1=" + encodeURIComponent("" + company_address1) + "&";
        if (company_address2 !== undefined && company_address2 !== null)
            url_ += "company.address2=" + encodeURIComponent("" + company_address2) + "&";
        if (company_address3 !== undefined && company_address3 !== null)
            url_ += "company.address3=" + encodeURIComponent("" + company_address3) + "&";
        if (company_city !== undefined && company_city !== null)
            url_ += "company.city=" + encodeURIComponent("" + company_city) + "&";
        if (company_state !== undefined && company_state !== null)
            url_ += "company.state=" + encodeURIComponent("" + company_state) + "&";
        if (company_zip !== undefined && company_zip !== null)
            url_ += "company.zip=" + encodeURIComponent("" + company_zip) + "&";
        if (company_runCode !== undefined && company_runCode !== null)
            url_ += "company.runCode=" + encodeURIComponent("" + company_runCode) + "&";
        if (company_gpsLat !== undefined && company_gpsLat !== null)
            url_ += "company.gpsLat=" + encodeURIComponent("" + company_gpsLat) + "&";
        if (company_gpsLong !== undefined && company_gpsLong !== null)
            url_ += "company.gpsLong=" + encodeURIComponent("" + company_gpsLong) + "&";
        if (company_gpsLatNS !== undefined && company_gpsLatNS !== null)
            url_ += "company.gpsLatNS=" + encodeURIComponent("" + company_gpsLatNS) + "&";
        if (company_gpsLongEW !== undefined && company_gpsLongEW !== null)
            url_ += "company.gpsLongEW=" + encodeURIComponent("" + company_gpsLongEW) + "&";
        if (company_decimalGpsLat !== undefined && company_decimalGpsLat !== null)
            url_ += "company.decimalGpsLat=" + encodeURIComponent("" + company_decimalGpsLat) + "&";
        if (company_decimalGpsLon !== undefined && company_decimalGpsLon !== null)
            url_ += "company.decimalGpsLon=" + encodeURIComponent("" + company_decimalGpsLon) + "&";
        if (company_branchNo !== undefined && company_branchNo !== null)
            url_ += "company.branchNo=" + encodeURIComponent("" + company_branchNo) + "&";
        if (company_rowState !== undefined && company_rowState !== null)
            url_ += "company.rowState=" + encodeURIComponent("" + company_rowState) + "&";
        if (company_isChecked !== undefined && company_isChecked !== null)
            url_ += "company.isChecked=" + encodeURIComponent("" + company_isChecked) + "&";
        if (company_messageId !== undefined && company_messageId !== null)
            url_ += "company.messageId=" + encodeURIComponent("" + company_messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processLogin(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<any>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    webLogin(model: LoginModel): Observable<any>
    {
        let url_ = this.baseUrl + "/Account/WebLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWebLogin(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWebLogin(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processWebLogin(response: HttpResponseBase): Observable<any>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    mobileLogin(model: LoginModel): Observable<any>
    {
        let url_ = this.baseUrl + "/Account/MobileLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processMobileLogin(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processMobileLogin(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMobileLogin(response: HttpResponseBase): Observable<any>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    logout(): Observable<any>
    {
        let url_ = this.baseUrl + "/Account/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processLogout(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<any>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getLogicals(custId: string): Observable<string[]>
    {
        let url_ = this.baseUrl + "/Account/GetLogicals?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLogicals(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLogicals(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLogicals(response: HttpResponseBase): Observable<string[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @return OK
     */
    getLogicalsWithDetail(custId: string): Observable<LogicalWithDetail[]>
    {
        let url_ = this.baseUrl + "/Account/GetLogicalsWithDetail?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLogicalsWithDetail(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLogicalsWithDetail(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<LogicalWithDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogicalWithDetail[]>;
        }));
    }

    protected processGetLogicalsWithDetail(response: HttpResponseBase): Observable<LogicalWithDetail[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogicalWithDetail[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LogicalWithDetail[]>(null as any);
    }

    /**
     * @return OK
     */
    test(): Observable<string>
    {
        let url_ = this.baseUrl + "/Account/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processTest(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<string>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class Client
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    account(password: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Account?";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processAccount(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processAccount(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAccount(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param payment_application (optional) 
     * @param payment_sourceNo (optional) 
     * @param payment_paymentMethod (optional) 
     * @param payment_branchNo (optional) 
     * @param payment_dataLogical (optional) 
     * @param payment_id (optional) 
     * @param payment_employeeId (optional) 
     * @param payment_companyName (optional) 
     * @param payment_nameFirst (optional) 
     * @param payment_nameLast (optional) 
     * @param payment_address1 (optional) 
     * @param payment_address2 (optional) 
     * @param payment_city (optional) 
     * @param payment_state (optional) 
     * @param payment_zip (optional) 
     * @param payment_countryCode (optional) 
     * @param payment_cardNo (optional) 
     * @param payment_securityCode (optional) 
     * @param payment_cardExprMonth (optional) 
     * @param payment_cardExprYear (optional) 
     * @param payment_cardType (optional) 
     * @param payment_bankAccountNumber (optional) 
     * @param payment_bankRoutingNumber (optional) 
     * @param payment_bankName (optional) 
     * @param payment_bankAccountType (optional) 
     * @param payment_amount (optional) 
     * @param payment_message1 (optional) 
     * @param payment_message2 (optional) 
     * @param payment_message3 (optional) 
     * @param payment_totalAmount (optional) 
     * @param payment_contractAmount (optional) 
     * @param payment_contractPayment (optional) 
     * @param payment_budgetPayment (optional) 
     * @param payment_fromReceipts (optional) 
     * @param payment_fromSales (optional) 
     * @param payment_isAutoPay (optional) 
     * @param payment_isWebPayment (optional) 
     * @param payment_isProcessImmediatelyPayment (optional) 
     * @param payment_failed (optional) 
     * @param payment_isProcessed (optional) 
     * @param payment_convenienceFee (optional) 
     * @param payment_convenienceFeeDescription (optional) 
     * @param payment_convenienceFeeTax (optional) 
     * @param payment_runCode (optional) 
     * @param payment_accountNumber (optional) 
     * @param payment_authCode (optional) 
     * @param payment_refNo (optional) 
     * @param payment_respMsg (optional) 
     * @param payment_errorMsg (optional) 
     * @param payment_recNo (optional) 
     * @param payment_autoPayRecNo (optional) 
     * @param payment_creationDateTime (optional) 
     * @param payment_successful (optional) 
     * @param payment_rccVersion (optional) 
     * @param payment_computerName (optional) 
     * @param payment_ipAddress (optional) 
     * @param payment_checkType (optional) 
     * @param payment_traceNumber (optional) 
     * @param payment_processedThrough (optional) 
     * @param payment_processDate (optional) 
     * @param payment_rowState (optional) 
     * @param payment_isChecked (optional) 
     * @param payment_messageId (optional) 
     * @param autoPaySettings_autoPaySettingsId (optional) 
     * @param autoPaySettings_dataLogical (optional) 
     * @param autoPaySettings_branchNo (optional) 
     * @param autoPaySettings_isAutoPayActive (optional) 
     * @param autoPaySettings_defaultExcludeBalanceFrom (optional) 
     * @param autoPaySettings_defaultExcludeBalanceThrough (optional) 
     * @param autoPaySettings_isWarnUsersRunCodeActive (optional) 
     * @param autoPaySettings_bankAccountProcessorName (optional) 
     * @param autoPaySettings_creditCardProcessorName (optional) 
     * @param autoPaySettings_paymentTypes (optional) 
     * @param autoPaySettings_rowState (optional) 
     * @param autoPaySettings_isChecked (optional) 
     * @param autoPaySettings_messageId (optional) 
     * @return OK
     */
    aPS(payment_application?: string | null | undefined, payment_sourceNo?: number | null | undefined, payment_paymentMethod?: string | null | undefined, payment_branchNo?: string | null | undefined, payment_dataLogical?: string | null | undefined, payment_id?: string | null | undefined, payment_employeeId?: string | null | undefined, payment_companyName?: string | null | undefined, payment_nameFirst?: string | null | undefined, payment_nameLast?: string | null | undefined, payment_address1?: string | null | undefined, payment_address2?: string | null | undefined, payment_city?: string | null | undefined, payment_state?: string | null | undefined, payment_zip?: string | null | undefined, payment_countryCode?: string | null | undefined, payment_cardNo?: number | null | undefined, payment_securityCode?: string | null | undefined, payment_cardExprMonth?: number | null | undefined, payment_cardExprYear?: number | null | undefined, payment_cardType?: string | null | undefined, payment_bankAccountNumber?: string | null | undefined, payment_bankRoutingNumber?: number | null | undefined, payment_bankName?: string | null | undefined, payment_bankAccountType?: string | null | undefined, payment_amount?: number | null | undefined, payment_message1?: string | null | undefined, payment_message2?: string | null | undefined, payment_message3?: string | null | undefined, payment_totalAmount?: number | null | undefined, payment_contractAmount?: number | null | undefined, payment_contractPayment?: boolean | null | undefined, payment_budgetPayment?: boolean | null | undefined, payment_fromReceipts?: boolean | null | undefined, payment_fromSales?: boolean | null | undefined, payment_isAutoPay?: boolean | null | undefined, payment_isWebPayment?: boolean | null | undefined, payment_isProcessImmediatelyPayment?: boolean | null | undefined, payment_failed?: boolean | null | undefined, payment_isProcessed?: boolean | null | undefined, payment_convenienceFee?: number | null | undefined, payment_convenienceFeeDescription?: string | null | undefined, payment_convenienceFeeTax?: number | null | undefined, payment_runCode?: number | null | undefined, payment_accountNumber?: number | null | undefined, payment_authCode?: string | null | undefined, payment_refNo?: string | null | undefined, payment_respMsg?: string | null | undefined, payment_errorMsg?: string | null | undefined, payment_recNo?: number | null | undefined, payment_autoPayRecNo?: number | null | undefined, payment_creationDateTime?: Date | null | undefined, payment_successful?: boolean | null | undefined, payment_rccVersion?: string | null | undefined, payment_computerName?: string | null | undefined, payment_ipAddress?: string | null | undefined, payment_checkType?: number | null | undefined, payment_traceNumber?: number | null | undefined, payment_processedThrough?: string | null | undefined, payment_processDate?: Date | null | undefined, payment_rowState?: RowState2 | null | undefined, payment_isChecked?: boolean | null | undefined, payment_messageId?: string | null | undefined, autoPaySettings_autoPaySettingsId?: number | null | undefined, autoPaySettings_dataLogical?: string | null | undefined, autoPaySettings_branchNo?: string | null | undefined, autoPaySettings_isAutoPayActive?: boolean | null | undefined, autoPaySettings_defaultExcludeBalanceFrom?: number | null | undefined, autoPaySettings_defaultExcludeBalanceThrough?: number | null | undefined, autoPaySettings_isWarnUsersRunCodeActive?: boolean | null | undefined, autoPaySettings_bankAccountProcessorName?: BankAccountProcessorName | null | undefined, autoPaySettings_creditCardProcessorName?: CreditCardProcessorName | null | undefined, autoPaySettings_paymentTypes?: any[] | null | undefined, autoPaySettings_rowState?: RowState3 | null | undefined, autoPaySettings_isChecked?: boolean | null | undefined, autoPaySettings_messageId?: string | null | undefined): Observable<APSResponse>
    {
        let url_ = this.baseUrl + "/APS?";
        if (payment_application !== undefined && payment_application !== null)
            url_ += "payment.application=" + encodeURIComponent("" + payment_application) + "&";
        if (payment_sourceNo !== undefined && payment_sourceNo !== null)
            url_ += "payment.sourceNo=" + encodeURIComponent("" + payment_sourceNo) + "&";
        if (payment_paymentMethod !== undefined && payment_paymentMethod !== null)
            url_ += "payment.paymentMethod=" + encodeURIComponent("" + payment_paymentMethod) + "&";
        if (payment_branchNo !== undefined && payment_branchNo !== null)
            url_ += "payment.branchNo=" + encodeURIComponent("" + payment_branchNo) + "&";
        if (payment_dataLogical !== undefined && payment_dataLogical !== null)
            url_ += "payment.dataLogical=" + encodeURIComponent("" + payment_dataLogical) + "&";
        if (payment_id !== undefined && payment_id !== null)
            url_ += "payment.id=" + encodeURIComponent("" + payment_id) + "&";
        if (payment_employeeId !== undefined && payment_employeeId !== null)
            url_ += "payment.employeeId=" + encodeURIComponent("" + payment_employeeId) + "&";
        if (payment_companyName !== undefined && payment_companyName !== null)
            url_ += "payment.companyName=" + encodeURIComponent("" + payment_companyName) + "&";
        if (payment_nameFirst !== undefined && payment_nameFirst !== null)
            url_ += "payment.nameFirst=" + encodeURIComponent("" + payment_nameFirst) + "&";
        if (payment_nameLast !== undefined && payment_nameLast !== null)
            url_ += "payment.nameLast=" + encodeURIComponent("" + payment_nameLast) + "&";
        if (payment_address1 !== undefined && payment_address1 !== null)
            url_ += "payment.address1=" + encodeURIComponent("" + payment_address1) + "&";
        if (payment_address2 !== undefined && payment_address2 !== null)
            url_ += "payment.address2=" + encodeURIComponent("" + payment_address2) + "&";
        if (payment_city !== undefined && payment_city !== null)
            url_ += "payment.city=" + encodeURIComponent("" + payment_city) + "&";
        if (payment_state !== undefined && payment_state !== null)
            url_ += "payment.state=" + encodeURIComponent("" + payment_state) + "&";
        if (payment_zip !== undefined && payment_zip !== null)
            url_ += "payment.zip=" + encodeURIComponent("" + payment_zip) + "&";
        if (payment_countryCode !== undefined && payment_countryCode !== null)
            url_ += "payment.countryCode=" + encodeURIComponent("" + payment_countryCode) + "&";
        if (payment_cardNo !== undefined && payment_cardNo !== null)
            url_ += "payment.cardNo=" + encodeURIComponent("" + payment_cardNo) + "&";
        if (payment_securityCode !== undefined && payment_securityCode !== null)
            url_ += "payment.securityCode=" + encodeURIComponent("" + payment_securityCode) + "&";
        if (payment_cardExprMonth !== undefined && payment_cardExprMonth !== null)
            url_ += "payment.cardExprMonth=" + encodeURIComponent("" + payment_cardExprMonth) + "&";
        if (payment_cardExprYear !== undefined && payment_cardExprYear !== null)
            url_ += "payment.cardExprYear=" + encodeURIComponent("" + payment_cardExprYear) + "&";
        if (payment_cardType !== undefined && payment_cardType !== null)
            url_ += "payment.cardType=" + encodeURIComponent("" + payment_cardType) + "&";
        if (payment_bankAccountNumber !== undefined && payment_bankAccountNumber !== null)
            url_ += "payment.bankAccountNumber=" + encodeURIComponent("" + payment_bankAccountNumber) + "&";
        if (payment_bankRoutingNumber !== undefined && payment_bankRoutingNumber !== null)
            url_ += "payment.bankRoutingNumber=" + encodeURIComponent("" + payment_bankRoutingNumber) + "&";
        if (payment_bankName !== undefined && payment_bankName !== null)
            url_ += "payment.bankName=" + encodeURIComponent("" + payment_bankName) + "&";
        if (payment_bankAccountType !== undefined && payment_bankAccountType !== null)
            url_ += "payment.bankAccountType=" + encodeURIComponent("" + payment_bankAccountType) + "&";
        if (payment_amount !== undefined && payment_amount !== null)
            url_ += "payment.amount=" + encodeURIComponent("" + payment_amount) + "&";
        if (payment_message1 !== undefined && payment_message1 !== null)
            url_ += "payment.message1=" + encodeURIComponent("" + payment_message1) + "&";
        if (payment_message2 !== undefined && payment_message2 !== null)
            url_ += "payment.message2=" + encodeURIComponent("" + payment_message2) + "&";
        if (payment_message3 !== undefined && payment_message3 !== null)
            url_ += "payment.message3=" + encodeURIComponent("" + payment_message3) + "&";
        if (payment_totalAmount !== undefined && payment_totalAmount !== null)
            url_ += "payment.totalAmount=" + encodeURIComponent("" + payment_totalAmount) + "&";
        if (payment_contractAmount !== undefined && payment_contractAmount !== null)
            url_ += "payment.contractAmount=" + encodeURIComponent("" + payment_contractAmount) + "&";
        if (payment_contractPayment !== undefined && payment_contractPayment !== null)
            url_ += "payment.contractPayment=" + encodeURIComponent("" + payment_contractPayment) + "&";
        if (payment_budgetPayment !== undefined && payment_budgetPayment !== null)
            url_ += "payment.budgetPayment=" + encodeURIComponent("" + payment_budgetPayment) + "&";
        if (payment_fromReceipts !== undefined && payment_fromReceipts !== null)
            url_ += "payment.fromReceipts=" + encodeURIComponent("" + payment_fromReceipts) + "&";
        if (payment_fromSales !== undefined && payment_fromSales !== null)
            url_ += "payment.fromSales=" + encodeURIComponent("" + payment_fromSales) + "&";
        if (payment_isAutoPay !== undefined && payment_isAutoPay !== null)
            url_ += "payment.isAutoPay=" + encodeURIComponent("" + payment_isAutoPay) + "&";
        if (payment_isWebPayment !== undefined && payment_isWebPayment !== null)
            url_ += "payment.isWebPayment=" + encodeURIComponent("" + payment_isWebPayment) + "&";
        if (payment_isProcessImmediatelyPayment !== undefined && payment_isProcessImmediatelyPayment !== null)
            url_ += "payment.isProcessImmediatelyPayment=" + encodeURIComponent("" + payment_isProcessImmediatelyPayment) + "&";
        if (payment_failed !== undefined && payment_failed !== null)
            url_ += "payment.failed=" + encodeURIComponent("" + payment_failed) + "&";
        if (payment_isProcessed !== undefined && payment_isProcessed !== null)
            url_ += "payment.isProcessed=" + encodeURIComponent("" + payment_isProcessed) + "&";
        if (payment_convenienceFee !== undefined && payment_convenienceFee !== null)
            url_ += "payment.convenienceFee=" + encodeURIComponent("" + payment_convenienceFee) + "&";
        if (payment_convenienceFeeDescription !== undefined && payment_convenienceFeeDescription !== null)
            url_ += "payment.convenienceFeeDescription=" + encodeURIComponent("" + payment_convenienceFeeDescription) + "&";
        if (payment_convenienceFeeTax !== undefined && payment_convenienceFeeTax !== null)
            url_ += "payment.convenienceFeeTax=" + encodeURIComponent("" + payment_convenienceFeeTax) + "&";
        if (payment_runCode !== undefined && payment_runCode !== null)
            url_ += "payment.runCode=" + encodeURIComponent("" + payment_runCode) + "&";
        if (payment_accountNumber !== undefined && payment_accountNumber !== null)
            url_ += "payment.accountNumber=" + encodeURIComponent("" + payment_accountNumber) + "&";
        if (payment_authCode !== undefined && payment_authCode !== null)
            url_ += "payment.authCode=" + encodeURIComponent("" + payment_authCode) + "&";
        if (payment_refNo !== undefined && payment_refNo !== null)
            url_ += "payment.refNo=" + encodeURIComponent("" + payment_refNo) + "&";
        if (payment_respMsg !== undefined && payment_respMsg !== null)
            url_ += "payment.respMsg=" + encodeURIComponent("" + payment_respMsg) + "&";
        if (payment_errorMsg !== undefined && payment_errorMsg !== null)
            url_ += "payment.errorMsg=" + encodeURIComponent("" + payment_errorMsg) + "&";
        if (payment_recNo !== undefined && payment_recNo !== null)
            url_ += "payment.recNo=" + encodeURIComponent("" + payment_recNo) + "&";
        if (payment_autoPayRecNo !== undefined && payment_autoPayRecNo !== null)
            url_ += "payment.autoPayRecNo=" + encodeURIComponent("" + payment_autoPayRecNo) + "&";
        if (payment_creationDateTime !== undefined && payment_creationDateTime !== null)
            url_ += "payment.creationDateTime=" + encodeURIComponent(payment_creationDateTime ? "" + payment_creationDateTime.toISOString() : "") + "&";
        if (payment_successful !== undefined && payment_successful !== null)
            url_ += "payment.successful=" + encodeURIComponent("" + payment_successful) + "&";
        if (payment_rccVersion !== undefined && payment_rccVersion !== null)
            url_ += "payment.rccVersion=" + encodeURIComponent("" + payment_rccVersion) + "&";
        if (payment_computerName !== undefined && payment_computerName !== null)
            url_ += "payment.computerName=" + encodeURIComponent("" + payment_computerName) + "&";
        if (payment_ipAddress !== undefined && payment_ipAddress !== null)
            url_ += "payment.ipAddress=" + encodeURIComponent("" + payment_ipAddress) + "&";
        if (payment_checkType !== undefined && payment_checkType !== null)
            url_ += "payment.checkType=" + encodeURIComponent("" + payment_checkType) + "&";
        if (payment_traceNumber !== undefined && payment_traceNumber !== null)
            url_ += "payment.traceNumber=" + encodeURIComponent("" + payment_traceNumber) + "&";
        if (payment_processedThrough !== undefined && payment_processedThrough !== null)
            url_ += "payment.processedThrough=" + encodeURIComponent("" + payment_processedThrough) + "&";
        if (payment_processDate !== undefined && payment_processDate !== null)
            url_ += "payment.processDate=" + encodeURIComponent(payment_processDate ? "" + payment_processDate.toISOString() : "") + "&";
        if (payment_rowState !== undefined && payment_rowState !== null)
            url_ += "payment.rowState=" + encodeURIComponent("" + payment_rowState) + "&";
        if (payment_isChecked !== undefined && payment_isChecked !== null)
            url_ += "payment.isChecked=" + encodeURIComponent("" + payment_isChecked) + "&";
        if (payment_messageId !== undefined && payment_messageId !== null)
            url_ += "payment.messageId=" + encodeURIComponent("" + payment_messageId) + "&";
        if (autoPaySettings_autoPaySettingsId !== undefined && autoPaySettings_autoPaySettingsId !== null)
            url_ += "autoPaySettings.autoPaySettingsId=" + encodeURIComponent("" + autoPaySettings_autoPaySettingsId) + "&";
        if (autoPaySettings_dataLogical !== undefined && autoPaySettings_dataLogical !== null)
            url_ += "autoPaySettings.dataLogical=" + encodeURIComponent("" + autoPaySettings_dataLogical) + "&";
        if (autoPaySettings_branchNo !== undefined && autoPaySettings_branchNo !== null)
            url_ += "autoPaySettings.branchNo=" + encodeURIComponent("" + autoPaySettings_branchNo) + "&";
        if (autoPaySettings_isAutoPayActive !== undefined && autoPaySettings_isAutoPayActive !== null)
            url_ += "autoPaySettings.isAutoPayActive=" + encodeURIComponent("" + autoPaySettings_isAutoPayActive) + "&";
        if (autoPaySettings_defaultExcludeBalanceFrom !== undefined && autoPaySettings_defaultExcludeBalanceFrom !== null)
            url_ += "autoPaySettings.defaultExcludeBalanceFrom=" + encodeURIComponent("" + autoPaySettings_defaultExcludeBalanceFrom) + "&";
        if (autoPaySettings_defaultExcludeBalanceThrough !== undefined && autoPaySettings_defaultExcludeBalanceThrough !== null)
            url_ += "autoPaySettings.defaultExcludeBalanceThrough=" + encodeURIComponent("" + autoPaySettings_defaultExcludeBalanceThrough) + "&";
        if (autoPaySettings_isWarnUsersRunCodeActive !== undefined && autoPaySettings_isWarnUsersRunCodeActive !== null)
            url_ += "autoPaySettings.isWarnUsersRunCodeActive=" + encodeURIComponent("" + autoPaySettings_isWarnUsersRunCodeActive) + "&";
        if (autoPaySettings_bankAccountProcessorName !== undefined && autoPaySettings_bankAccountProcessorName !== null)
            url_ += "autoPaySettings.bankAccountProcessorName=" + encodeURIComponent("" + autoPaySettings_bankAccountProcessorName) + "&";
        if (autoPaySettings_creditCardProcessorName !== undefined && autoPaySettings_creditCardProcessorName !== null)
            url_ += "autoPaySettings.creditCardProcessorName=" + encodeURIComponent("" + autoPaySettings_creditCardProcessorName) + "&";
        if (autoPaySettings_paymentTypes !== undefined && autoPaySettings_paymentTypes !== null)
            autoPaySettings_paymentTypes && autoPaySettings_paymentTypes.forEach((item, index) =>
            {
                for (let attr in item)
                    if (item.hasOwnProperty(attr))
                    {
                        url_ += "autoPaySettings.paymentTypes[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (autoPaySettings_rowState !== undefined && autoPaySettings_rowState !== null)
            url_ += "autoPaySettings.rowState=" + encodeURIComponent("" + autoPaySettings_rowState) + "&";
        if (autoPaySettings_isChecked !== undefined && autoPaySettings_isChecked !== null)
            url_ += "autoPaySettings.isChecked=" + encodeURIComponent("" + autoPaySettings_isChecked) + "&";
        if (autoPaySettings_messageId !== undefined && autoPaySettings_messageId !== null)
            url_ += "autoPaySettings.messageId=" + encodeURIComponent("" + autoPaySettings_messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processAPS(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processAPS(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<APSResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APSResponse>;
        }));
    }

    protected processAPS(response: HttpResponseBase): Observable<APSResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as APSResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<APSResponse>(null as any);
    }

    /**
     * @return OK
     */
    company(): Observable<Company>
    {
        let url_ = this.baseUrl + "/Company";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processCompany(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processCompany(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Company>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company>;
        }));
    }

    protected processCompany(response: HttpResponseBase): Observable<Company>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Company;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Company>(null as any);
    }

    /**
     * @return OK
     */
    states(): Observable<UsState[]>
    {
        let url_ = this.baseUrl + "/States";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processStates(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processStates(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<UsState[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsState[]>;
        }));
    }

    protected processStates(response: HttpResponseBase): Observable<UsState[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsState[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UsState[]>(null as any);
    }

    /**
     * @return OK
     */
    utility(message: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility?";
        if (message === undefined || message === null)
            throw new Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processUtility(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processUtility(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUtility(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class APSClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @param branchNo (optional) 
     * @return OK
     */
    getApsStartup(branchNo?: string | null | undefined): Observable<AvailableTypes>
    {
        let url_ = this.baseUrl + "/APS/GetApsStartup?";
        if (branchNo !== undefined && branchNo !== null)
            url_ += "branchNo=" + encodeURIComponent("" + branchNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetApsStartup(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetApsStartup(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<AvailableTypes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableTypes>;
        }));
    }

    protected processGetApsStartup(response: HttpResponseBase): Observable<AvailableTypes>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableTypes;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableTypes>(null as any);
    }

    /**
     * @return OK
     */
    getApsMasterList(appl: string, sourceNo: number): Observable<APSMaster[]>
    {
        let url_ = this.baseUrl + "/APS/GetApsMasterList?";
        if (appl === undefined || appl === null)
            throw new Error("The parameter 'appl' must be defined and cannot be null.");
        else
            url_ += "appl=" + encodeURIComponent("" + appl) + "&";
        if (sourceNo === undefined || sourceNo === null)
            throw new Error("The parameter 'sourceNo' must be defined and cannot be null.");
        else
            url_ += "sourceNo=" + encodeURIComponent("" + sourceNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetApsMasterList(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetApsMasterList(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<APSMaster[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APSMaster[]>;
        }));
    }

    protected processGetApsMasterList(response: HttpResponseBase): Observable<APSMaster[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as APSMaster[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<APSMaster[]>(null as any);
    }

    /**
     * @return OK
     */
    isCreditCardEntryAllowed(): Observable<boolean>
    {
        let url_ = this.baseUrl + "/APS/IsCreditCardEntryAllowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processIsCreditCardEntryAllowed(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processIsCreditCardEntryAllowed(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCreditCardEntryAllowed(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    calculateConvenienceFee(otp: OneTimePaymentRequest): Observable<APSResponse>
    {
        let url_ = this.baseUrl + "/APS/CalculateConvenienceFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(otp);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processCalculateConvenienceFee(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processCalculateConvenienceFee(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<APSResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APSResponse>;
        }));
    }

    protected processCalculateConvenienceFee(response: HttpResponseBase): Observable<APSResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as APSResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<APSResponse>(null as any);
    }

    /**
     * @return OK
     */
    chaseRequestForm(request: OneTimePaymentRequest): Observable<string>
    {
        let url_ = this.baseUrl + "/APS/ChaseRequestForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processChaseRequestForm(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processChaseRequestForm(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChaseRequestForm(response: HttpResponseBase): Observable<string>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    logChasePayment(payment: APSPayment): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/APS/LogChasePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payment);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processLogChasePayment(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processLogChasePayment(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processLogChasePayment(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    chasePaymentLookup(dataLogical: string, uid: string): Observable<ChaseResponse>
    {
        let url_ = this.baseUrl + "/APS/ChasePaymentLookup?";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined and cannot be null.");
        else
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processChasePaymentLookup(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processChasePaymentLookup(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<ChaseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChaseResponse>;
        }));
    }

    protected processChasePaymentLookup(response: HttpResponseBase): Observable<ChaseResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChaseResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChaseResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendOneTimePaymentEmail(paymentReceiptItem: PaymentReceiptItem): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/APS/SendOneTimePaymentEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentReceiptItem);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendOneTimePaymentEmail(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendOneTimePaymentEmail(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSendOneTimePaymentEmail(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    writeApsMaster(apsMaster: APSMaster): Observable<APSResponse>
    {
        let url_ = this.baseUrl + "/APS/WriteApsMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apsMaster);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWriteApsMaster(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWriteApsMaster(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<APSResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APSResponse>;
        }));
    }

    protected processWriteApsMaster(response: HttpResponseBase): Observable<APSResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as APSResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<APSResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateApsMaster(apsMaster: APSMaster): Observable<APSResponse>
    {
        let url_ = this.baseUrl + "/APS/UpdateApsMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apsMaster);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processUpdateApsMaster(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processUpdateApsMaster(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<APSResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APSResponse>;
        }));
    }

    protected processUpdateApsMaster(response: HttpResponseBase): Observable<APSResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as APSResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<APSResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteApsMaster(apsMaster: APSMaster): Observable<APSResponse>
    {
        let url_ = this.baseUrl + "/APS/DeleteApsMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apsMaster);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processDeleteApsMaster(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processDeleteApsMaster(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<APSResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APSResponse>;
        }));
    }

    protected processDeleteApsMaster(response: HttpResponseBase): Observable<APSResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as APSResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<APSResponse>(null as any);
    }

    /**
     * @return OK
     */
    addCard(addApsRequest: AddAPSRequestOfCreditCardInfo): Observable<boolean>
    {
        let url_ = this.baseUrl + "/APS/AddCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addApsRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processAddCard(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processAddCard(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddCard(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    removeApsItem(removeApsItemRequest: RemoveAPSItemRequest): Observable<boolean>
    {
        let url_ = this.baseUrl + "/APS/RemoveApsItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeApsItemRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processRemoveApsItem(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processRemoveApsItem(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveApsItem(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    removeApsItemV2(apsMaster: APSMaster): Observable<boolean>
    {
        let url_ = this.baseUrl + "/APS/RemoveApsItemV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apsMaster);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processRemoveApsItemV2(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processRemoveApsItemV2(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveApsItemV2(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getBankName(aBankNo: string): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/APS/GetBankName?";
        if (aBankNo === undefined || aBankNo === null)
            throw new Error("The parameter 'aBankNo' must be defined and cannot be null.");
        else
            url_ += "aBankNo=" + encodeURIComponent("" + aBankNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetBankName(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetBankName(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processGetBankName(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    addBank(addApsRequest: AddAPSRequestOfBankInfo): Observable<boolean>
    {
        let url_ = this.baseUrl + "/APS/AddBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addApsRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processAddBank(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processAddBank(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddBank(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class V2Client
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    oneTimePayment(otp: OneTimePaymentRequest): Observable<OneTimePaymentResponse[]>
    {
        let url_ = this.baseUrl + "/APS/V2/OneTimePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(otp);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processOneTimePayment(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processOneTimePayment(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<OneTimePaymentResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneTimePaymentResponse[]>;
        }));
    }

    protected processOneTimePayment(response: HttpResponseBase): Observable<OneTimePaymentResponse[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OneTimePaymentResponse[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OneTimePaymentResponse[]>(null as any);
    }

    /**
     * @param email (optional) 
     * @param isReset (optional) 
     * @return OK
     */
    register(corpIdDataLogical: string, custId: string, acctNo: number, lastName: string, email?: string | null | undefined, isReset?: boolean | null | undefined): Observable<RegisterCustomerV2Result>
    {
        let url_ = this.baseUrl + "/Customer/V2/Register?";
        if (corpIdDataLogical === undefined || corpIdDataLogical === null)
            throw new Error("The parameter 'corpIdDataLogical' must be defined and cannot be null.");
        else
            url_ += "corpIdDataLogical=" + encodeURIComponent("" + corpIdDataLogical) + "&";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (acctNo === undefined || acctNo === null)
            throw new Error("The parameter 'acctNo' must be defined and cannot be null.");
        else
            url_ += "acctNo=" + encodeURIComponent("" + acctNo) + "&";
        if (lastName === undefined || lastName === null)
            throw new Error("The parameter 'lastName' must be defined and cannot be null.");
        else
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (isReset !== undefined && isReset !== null)
            url_ += "isReset=" + encodeURIComponent("" + isReset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processRegister(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<RegisterCustomerV2Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterCustomerV2Result>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterCustomerV2Result>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterCustomerV2Result;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterCustomerV2Result>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CompanyClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @param customerRunCode (optional) 
     * @return OK
     */
    getWebCompany(customerRunCode?: number | null | undefined): Observable<WebCompany>
    {
        let url_ = this.baseUrl + "/Company/GetWebCompany?";
        if (customerRunCode !== undefined && customerRunCode !== null)
            url_ += "customerRunCode=" + encodeURIComponent("" + customerRunCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCompany(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCompany(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCompany>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCompany>;
        }));
    }

    protected processGetWebCompany(response: HttpResponseBase): Observable<WebCompany>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCompany;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCompany>(null as any);
    }

    /**
     * @return OK
     */
    getWebCompanyUnauth(dataLogical: string): Observable<WebCompany>
    {
        let url_ = this.baseUrl + "/Company/GetWebCompanyUnauth?";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCompanyUnauth(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCompanyUnauth(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCompany>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCompany>;
        }));
    }

    protected processGetWebCompanyUnauth(response: HttpResponseBase): Observable<WebCompany>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCompany;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCompany>(null as any);
    }

    /**
     * @param branchNo (optional) 
     * @return OK
     */
    getAppStartup(dataLogical: string, branchNo?: string | null | undefined): Observable<AppStartup>
    {
        let url_ = this.baseUrl + "/Company/GetAppStartup?";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (branchNo !== undefined && branchNo !== null)
            url_ += "branchNo=" + encodeURIComponent("" + branchNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetAppStartup(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetAppStartup(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<AppStartup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppStartup>;
        }));
    }

    protected processGetAppStartup(response: HttpResponseBase): Observable<AppStartup>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppStartup;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppStartup>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContractClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getContractsByCustomer(branchCustId: string, filter: string): Observable<Contract[]>
    {
        let url_ = this.baseUrl + "/Contract/GetContractsByCustomer?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractsByCustomer(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractsByCustomer(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Contract[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Contract[]>;
        }));
    }

    protected processGetContractsByCustomer(response: HttpResponseBase): Observable<Contract[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Contract[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contract[]>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    getWebContractsByCustomer(branchCustId: string, filter: string): Observable<WebContract[]>
    {
        let url_ = this.baseUrl + "/Contract/GetWebContractsByCustomer?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebContractsByCustomer(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebContractsByCustomer(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebContract[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebContract[]>;
        }));
    }

    protected processGetWebContractsByCustomer(response: HttpResponseBase): Observable<WebContract[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebContract[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebContract[]>(null as any);
    }

    /**
     * @return OK
     */
    getContractsByLocation(branchCustId: string, locationNo: number, filter: string): Observable<Contract[]>
    {
        let url_ = this.baseUrl + "/Contract/GetContractsByLocation?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (locationNo === undefined || locationNo === null)
            throw new Error("The parameter 'locationNo' must be defined and cannot be null.");
        else
            url_ += "locationNo=" + encodeURIComponent("" + locationNo) + "&";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractsByLocation(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractsByLocation(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Contract[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Contract[]>;
        }));
    }

    protected processGetContractsByLocation(response: HttpResponseBase): Observable<Contract[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Contract[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contract[]>(null as any);
    }

    /**
     * @return OK
     */
    getContractById(custId: string, contractNo: string): Observable<Contract>
    {
        let url_ = this.baseUrl + "/Contract/GetContractById?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (contractNo === undefined || contractNo === null)
            throw new Error("The parameter 'contractNo' must be defined and cannot be null.");
        else
            url_ += "contractNo=" + encodeURIComponent("" + contractNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractById(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractById(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Contract>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Contract>;
        }));
    }

    protected processGetContractById(response: HttpResponseBase): Observable<Contract>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Contract;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contract>(null as any);
    }

    /**
     * @return OK
     */
    getContractsByCustomerWeb(branchCustId: string): Observable<ContractWeb[]>
    {
        let url_ = this.baseUrl + "/Contract/GetContractsByCustomerWeb?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractsByCustomerWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractsByCustomerWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<ContractWeb[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractWeb[]>;
        }));
    }

    protected processGetContractsByCustomerWeb(response: HttpResponseBase): Observable<ContractWeb[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractWeb[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractWeb[]>(null as any);
    }

    /**
     * @return OK
     */
    getContractLettersById(branchCustId: string): Observable<ContractLetter[]>
    {
        let url_ = this.baseUrl + "/Contract/GetContractLettersById?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractLettersById(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractLettersById(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<ContractLetter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractLetter[]>;
        }));
    }

    protected processGetContractLettersById(response: HttpResponseBase): Observable<ContractLetter[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractLetter[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractLetter[]>(null as any);
    }

    /**
     * @return OK
     */
    getContractLettersByIdWeb(branchCustId: string): Observable<WebContractLetter[]>
    {
        let url_ = this.baseUrl + "/Contract/GetContractLettersByIdWeb?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractLettersByIdWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractLettersByIdWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebContractLetter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebContractLetter[]>;
        }));
    }

    protected processGetContractLettersByIdWeb(response: HttpResponseBase): Observable<WebContractLetter[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebContractLetter[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebContractLetter[]>(null as any);
    }

    /**
     * @return OK
     */
    writeContractLetter(webContractAgreement: WebContractAgreement): Observable<ContractLetterResponse>
    {
        let url_ = this.baseUrl + "/Contract/WriteContractLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webContractAgreement);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWriteContractLetter(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWriteContractLetter(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<ContractLetterResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractLetterResponse>;
        }));
    }

    protected processWriteContractLetter(response: HttpResponseBase): Observable<ContractLetterResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractLetterResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractLetterResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getApiVersion(dataLogical: string, corpId: string): Observable<string>
    {
        let url_ = this.baseUrl + "/Customer/GetApiVersion?";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (corpId === undefined || corpId === null)
            throw new Error("The parameter 'corpId' must be defined and cannot be null.");
        else
            url_ += "corpId=" + encodeURIComponent("" + corpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetApiVersion(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetApiVersion(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetApiVersion(response: HttpResponseBase): Observable<string>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    isCommercialCustomer(custId: string, dataLogical: string, corpId: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/IsCommercialCustomer?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (corpId === undefined || corpId === null)
            throw new Error("The parameter 'corpId' must be defined and cannot be null.");
        else
            url_ += "corpId=" + encodeURIComponent("" + corpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processIsCommercialCustomer(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processIsCommercialCustomer(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCommercialCustomer(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    pendingDeliveries(branchCustIdKey: string, location: number): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/PendingDeliveries?";
        if (branchCustIdKey === undefined || branchCustIdKey === null)
            throw new Error("The parameter 'branchCustIdKey' must be defined and cannot be null.");
        else
            url_ += "branchCustIdKey=" + encodeURIComponent("" + branchCustIdKey) + "&";
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined and cannot be null.");
        else
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processPendingDeliveries(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processPendingDeliveries(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPendingDeliveries(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    doesLocationHavePendingSWO(branchCustIdKey: string, location: number): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/DoesLocationHavePendingSWO?";
        if (branchCustIdKey === undefined || branchCustIdKey === null)
            throw new Error("The parameter 'branchCustIdKey' must be defined and cannot be null.");
        else
            url_ += "branchCustIdKey=" + encodeURIComponent("" + branchCustIdKey) + "&";
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined and cannot be null.");
        else
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processDoesLocationHavePendingSWO(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processDoesLocationHavePendingSWO(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesLocationHavePendingSWO(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    getWebCustomerListItems(filterText: string): Observable<WebCustomer[]>
    {
        let url_ = this.baseUrl + "/Customer/GetWebCustomerListItems?";
        if (filterText === undefined || filterText === null)
            throw new Error("The parameter 'filterText' must be defined and cannot be null.");
        else
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCustomerListItems(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCustomerListItems(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCustomer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCustomer[]>;
        }));
    }

    protected processGetWebCustomerListItems(response: HttpResponseBase): Observable<WebCustomer[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCustomer[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCustomer[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebCustomerListItemsAdvanced(advancedSearchOptions: AdvancedSearchOptions): Observable<WebCustomer[]>
    {
        let url_ = this.baseUrl + "/Customer/GetWebCustomerListItemsAdvanced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedSearchOptions);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCustomerListItemsAdvanced(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCustomerListItemsAdvanced(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCustomer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCustomer[]>;
        }));
    }

    protected processGetWebCustomerListItemsAdvanced(response: HttpResponseBase): Observable<WebCustomer[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCustomer[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCustomer[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebCustomerComment(branchCustId: string): Observable<WebCustomerComment>
    {
        let url_ = this.baseUrl + "/Customer/GetWebCustomerComment?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCustomerComment(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCustomerComment(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCustomerComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCustomerComment>;
        }));
    }

    protected processGetWebCustomerComment(response: HttpResponseBase): Observable<WebCustomerComment>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCustomerComment;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCustomerComment>(null as any);
    }

    /**
     * @return OK
     */
    getWebCustomer(branchCustId: string): Observable<WebCustomer>
    {
        let url_ = this.baseUrl + "/Customer/GetWebCustomer?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCustomer(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCustomer(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCustomer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCustomer>;
        }));
    }

    protected processGetWebCustomer(response: HttpResponseBase): Observable<WebCustomer>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCustomer;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCustomer>(null as any);
    }

    /**
     * @return OK
     */
    getWebCustomerV2(branchCustId: string): Observable<WebCustomer>
    {
        let url_ = this.baseUrl + "/Customer/GetWebCustomerV2?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCustomerV2(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCustomerV2(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCustomer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCustomer>;
        }));
    }

    protected processGetWebCustomerV2(response: HttpResponseBase): Observable<WebCustomer>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCustomer;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCustomer>(null as any);
    }

    /**
     * @return OK
     */
    getWebContacts(branchCustId: string): Observable<ContactWeb[]>
    {
        let url_ = this.baseUrl + "/Customer/GetWebContacts?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebContacts(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebContacts(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<ContactWeb[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactWeb[]>;
        }));
    }

    protected processGetWebContacts(response: HttpResponseBase): Observable<ContactWeb[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactWeb[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactWeb[]>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerContacts(branchCustId: string): Observable<Contact[]>
    {
        let url_ = this.baseUrl + "/Customer/GetCustomerContacts?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetCustomerContacts(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetCustomerContacts(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Contact[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Contact[]>;
        }));
    }

    protected processGetCustomerContacts(response: HttpResponseBase): Observable<Contact[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Contact[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contact[]>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerAging(branchCustId: string): Observable<CustomerAgingVariables>
    {
        let url_ = this.baseUrl + "/Customer/GetCustomerAging?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetCustomerAging(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetCustomerAging(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<CustomerAgingVariables>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAgingVariables>;
        }));
    }

    protected processGetCustomerAging(response: HttpResponseBase): Observable<CustomerAgingVariables>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerAgingVariables;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgingVariables>(null as any);
    }

    /**
     * @return OK
     */
    getRecentHistory(branchCustId: string): Observable<History[]>
    {
        let url_ = this.baseUrl + "/Customer/GetRecentHistory?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetRecentHistory(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetRecentHistory(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<History[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<History[]>;
        }));
    }

    protected processGetRecentHistory(response: HttpResponseBase): Observable<History[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as History[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<History[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebCustomerAging(branchCustId: string): Observable<WebCustomerAgingVariables>
    {
        let url_ = this.baseUrl + "/Customer/GetWebCustomerAging?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebCustomerAging(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebCustomerAging(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebCustomerAgingVariables>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebCustomerAgingVariables>;
        }));
    }

    protected processGetWebCustomerAging(response: HttpResponseBase): Observable<WebCustomerAgingVariables>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebCustomerAgingVariables;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebCustomerAgingVariables>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword(customerPasswordUpdate: CustomerPasswordUpdate): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerPasswordUpdate);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processUpdatePassword(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePassword(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addCustomerPasswordHistory(passwordHistoryPayload: PasswordHistoryPayload): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/AddCustomerPasswordHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordHistoryPayload);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processAddCustomerPasswordHistory(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processAddCustomerPasswordHistory(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddCustomerPasswordHistory(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    isPasswordInCustomerPasswordHistory(passwordHistoryPayload: PasswordHistoryPayload): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/IsPasswordInCustomerPasswordHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordHistoryPayload);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processIsPasswordInCustomerPasswordHistory(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processIsPasswordInCustomerPasswordHistory(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPasswordInCustomerPasswordHistory(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    checkCustomerEmails(custId: string, dataLogical: string, corpId: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Customer/CheckCustomerEmails?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (corpId === undefined || corpId === null)
            throw new Error("The parameter 'corpId' must be defined and cannot be null.");
        else
            url_ += "corpId=" + encodeURIComponent("" + corpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processCheckCustomerEmails(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processCheckCustomerEmails(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCustomerEmails(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getResetPasswordEmails(custId: string, dataLogical: string, corpId: string): Observable<string[]>
    {
        let url_ = this.baseUrl + "/Customer/GetResetPasswordEmails?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (corpId === undefined || corpId === null)
            throw new Error("The parameter 'corpId' must be defined and cannot be null.");
        else
            url_ += "corpId=" + encodeURIComponent("" + corpId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetResetPasswordEmails(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetResetPasswordEmails(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetResetPasswordEmails(response: HttpResponseBase): Observable<string[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @return OK
     */
    checkForLockedAccount(custId: string, webDataLogical: string): Observable<string>
    {
        let url_ = this.baseUrl + "/Customer/CheckForLockedAccount?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        if (webDataLogical === undefined || webDataLogical === null)
            throw new Error("The parameter 'webDataLogical' must be defined and cannot be null.");
        else
            url_ += "webDataLogical=" + encodeURIComponent("" + webDataLogical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processCheckForLockedAccount(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processCheckForLockedAccount(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckForLockedAccount(response: HttpResponseBase): Observable<string>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    setTempPasswordSendEmail(request: TempPasswordRequest): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Customer/SetTempPasswordSendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSetTempPasswordSendEmail(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSetTempPasswordSendEmail(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSetTempPasswordSendEmail(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class V3Client
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    register(command: RegisterCustomerCommand): Observable<RegisterCustomerV2Result>
    {
        let url_ = this.baseUrl + "/Customer/V3/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processRegister(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<RegisterCustomerV2Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterCustomerV2Result>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterCustomerV2Result>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterCustomerV2Result;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterCustomerV2Result>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getEmployeeInfo(model: LoginModelV2): Observable<EmployeeInfo>
    {
        let url_ = this.baseUrl + "/Employee/GetEmployeeInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetEmployeeInfo(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetEmployeeInfo(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<EmployeeInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeInfo>;
        }));
    }

    protected processGetEmployeeInfo(response: HttpResponseBase): Observable<EmployeeInfo>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeInfo;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeInfo>(null as any);
    }

    /**
     * @return OK
     */
    getAndSendVerificationCode(request: TempPasswordOrVerificationCodeRequest): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Employee/GetAndSendVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetAndSendVerificationCode(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetAndSendVerificationCode(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processGetAndSendVerificationCode(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    validateVerificationCode(code: string, username: string, webDataLogical: string): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Employee/ValidateVerificationCode?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (webDataLogical === undefined || webDataLogical === null)
            throw new Error("The parameter 'webDataLogical' must be defined and cannot be null.");
        else
            url_ += "webDataLogical=" + encodeURIComponent("" + webDataLogical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processValidateVerificationCode(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processValidateVerificationCode(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processValidateVerificationCode(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EquipmentClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getEquipmentByCustId(custId: string): Observable<Equipment[]>
    {
        let url_ = this.baseUrl + "/Equipment/GetEquipmentByCustId?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetEquipmentByCustId(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetEquipmentByCustId(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Equipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Equipment[]>;
        }));
    }

    protected processGetEquipmentByCustId(response: HttpResponseBase): Observable<Equipment[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Equipment[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Equipment[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebEquipmentByCustId(custId: string): Observable<WebEquipment[]>
    {
        let url_ = this.baseUrl + "/Equipment/GetWebEquipmentByCustId?";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined and cannot be null.");
        else
            url_ += "custId=" + encodeURIComponent("" + custId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebEquipmentByCustId(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebEquipmentByCustId(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebEquipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebEquipment[]>;
        }));
    }

    protected processGetWebEquipmentByCustId(response: HttpResponseBase): Observable<WebEquipment[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebEquipment[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebEquipment[]>(null as any);
    }

    /**
     * @return OK
     */
    getEquipmentById(aId: string, branchNo: string): Observable<Equipment>
    {
        let url_ = this.baseUrl + "/Equipment/GetEquipmentById?";
        if (aId === undefined || aId === null)
            throw new Error("The parameter 'aId' must be defined and cannot be null.");
        else
            url_ += "aId=" + encodeURIComponent("" + aId) + "&";
        if (branchNo === undefined || branchNo === null)
            throw new Error("The parameter 'branchNo' must be defined and cannot be null.");
        else
            url_ += "branchNo=" + encodeURIComponent("" + branchNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetEquipmentById(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetEquipmentById(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Equipment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Equipment>;
        }));
    }

    protected processGetEquipmentById(response: HttpResponseBase): Observable<Equipment>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Equipment;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Equipment>(null as any);
    }

    /**
     * @return OK
     */
    getEquipmentList(filter: string): Observable<EquipmentListItem[]>
    {
        let url_ = this.baseUrl + "/Equipment/GetEquipmentList?";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetEquipmentList(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetEquipmentList(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<EquipmentListItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentListItem[]>;
        }));
    }

    protected processGetEquipmentList(response: HttpResponseBase): Observable<EquipmentListItem[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EquipmentListItem[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EquipmentListItem[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FuelClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getContractLetterSignup(): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Fuel/GetContractLetterSignup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetContractLetterSignup(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetContractLetterSignup(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetContractLetterSignup(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HistoryClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getRecentActivities(branchCustId: string): Observable<WebRecentActivity[]>
    {
        let url_ = this.baseUrl + "/History/GetRecentActivities?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetRecentActivities(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetRecentActivities(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebRecentActivity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebRecentActivity[]>;
        }));
    }

    protected processGetRecentActivities(response: HttpResponseBase): Observable<WebRecentActivity[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebRecentActivity[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebRecentActivity[]>(null as any);
    }

    /**
     * @return OK
     */
    searchHistoryWeb(branchCustId: string, filterText: string): Observable<WebTransaction[]>
    {
        let url_ = this.baseUrl + "/History/SearchHistoryWeb?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (filterText === undefined || filterText === null)
            throw new Error("The parameter 'filterText' must be defined and cannot be null.");
        else
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSearchHistoryWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSearchHistoryWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebTransaction[]>;
        }));
    }

    protected processSearchHistoryWeb(response: HttpResponseBase): Observable<WebTransaction[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebTransaction[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebTransaction[]>(null as any);
    }

    /**
     * @param numberOfRecords (optional) 
     * @param notesOption (optional) 
     * @return OK
     */
    getRecentHistoryWeb(branchCustId: string, numberOfRecords?: number | null | undefined, notesOption?: NotesOption | null | undefined): Observable<WebTransaction[]>
    {
        let url_ = this.baseUrl + "/History/GetRecentHistoryWeb?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (numberOfRecords !== undefined && numberOfRecords !== null)
            url_ += "numberOfRecords=" + encodeURIComponent("" + numberOfRecords) + "&";
        if (notesOption !== undefined && notesOption !== null)
            url_ += "notesOption=" + encodeURIComponent("" + notesOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetRecentHistoryWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetRecentHistoryWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebTransaction[]>;
        }));
    }

    protected processGetRecentHistoryWeb(response: HttpResponseBase): Observable<WebTransaction[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebTransaction[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebTransaction[]>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerHistoryDetail(branchCustId: string, refNum: string, date: Date, tran: string): Observable<WebTransaction[]>
    {
        let url_ = this.baseUrl + "/History/GetCustomerHistoryDetail?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (refNum === undefined || refNum === null)
            throw new Error("The parameter 'refNum' must be defined and cannot be null.");
        else
            url_ += "refNum=" + encodeURIComponent("" + refNum) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (tran === undefined || tran === null)
            throw new Error("The parameter 'tran' must be defined and cannot be null.");
        else
            url_ += "tran=" + encodeURIComponent("" + tran) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetCustomerHistoryDetail(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetCustomerHistoryDetail(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebTransaction[]>;
        }));
    }

    protected processGetCustomerHistoryDetail(response: HttpResponseBase): Observable<WebTransaction[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebTransaction[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebTransaction[]>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    getCustomerHistoryPaymentDetail(branchCustId: string, checkNum: string, date: Date, refNum: string): Observable<WebTransaction[]>
    {
        let url_ = this.baseUrl + "/History/GetCustomerHistoryPaymentDetail?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (checkNum === undefined || checkNum === null)
            throw new Error("The parameter 'checkNum' must be defined and cannot be null.");
        else
            url_ += "checkNum=" + encodeURIComponent("" + checkNum) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (refNum === undefined || refNum === null)
            throw new Error("The parameter 'refNum' must be defined and cannot be null.");
        else
            url_ += "refNum=" + encodeURIComponent("" + refNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetCustomerHistoryPaymentDetail(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetCustomerHistoryPaymentDetail(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebTransaction[]>;
        }));
    }

    protected processGetCustomerHistoryPaymentDetail(response: HttpResponseBase): Observable<WebTransaction[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebTransaction[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebTransaction[]>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerHistoryPaymentDetailV2(branchCustId: string, checkNum: string, date: Date, tran: string): Observable<WebTransaction[]>
    {
        let url_ = this.baseUrl + "/History/GetCustomerHistoryPaymentDetailV2?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (checkNum === undefined || checkNum === null)
            throw new Error("The parameter 'checkNum' must be defined and cannot be null.");
        else
            url_ += "checkNum=" + encodeURIComponent("" + checkNum) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (tran === undefined || tran === null)
            throw new Error("The parameter 'tran' must be defined and cannot be null.");
        else
            url_ += "tran=" + encodeURIComponent("" + tran) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetCustomerHistoryPaymentDetailV2(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetCustomerHistoryPaymentDetailV2(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebTransaction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebTransaction[]>;
        }));
    }

    protected processGetCustomerHistoryPaymentDetailV2(response: HttpResponseBase): Observable<WebTransaction[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebTransaction[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebTransaction[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ImagingClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getImageInfoForCustId(imageInfoRequest: WebImageInfoRequest): Observable<ImagingResponse>
    {
        let url_ = this.baseUrl + "/Imaging/GetImageInfoForCustId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageInfoRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetImageInfoForCustId(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetImageInfoForCustId(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<ImagingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImagingResponse>;
        }));
    }

    protected processGetImageInfoForCustId(response: HttpResponseBase): Observable<ImagingResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImagingResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImagingResponse>(null as any);
    }

    /**
     * @return OK
     */
    getImageInfoForDocument(document: ArchiveDocument, branchNo: string): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Imaging/GetImageInfoForDocument?";
        if (branchNo === undefined || branchNo === null)
            throw new Error("The parameter 'branchNo' must be defined and cannot be null.");
        else
            url_ += "branchNo=" + encodeURIComponent("" + branchNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(document);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetImageInfoForDocument(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetImageInfoForDocument(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processGetImageInfoForDocument(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getLocationListItems(filterText: string): Observable<LocationListItem[]>
    {
        let url_ = this.baseUrl + "/Location/GetLocationListItems?";
        if (filterText === undefined || filterText === null)
            throw new Error("The parameter 'filterText' must be defined and cannot be null.");
        else
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLocationListItems(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLocationListItems(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<LocationListItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationListItem[]>;
        }));
    }

    protected processGetLocationListItems(response: HttpResponseBase): Observable<LocationListItem[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationListItem[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationListItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getLocationListItemsByCustId(branchCustId: string): Observable<Location[]>
    {
        let url_ = this.baseUrl + "/Location/GetLocationListItemsByCustId?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLocationListItemsByCustId(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLocationListItemsByCustId(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Location[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Location[]>;
        }));
    }

    protected processGetLocationListItemsByCustId(response: HttpResponseBase): Observable<Location[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Location[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Location[]>(null as any);
    }

    /**
     * @return OK
     */
    getWebLocationListItemsByCustId(branchCustId: string): Observable<WebLocation[]>
    {
        let url_ = this.baseUrl + "/Location/GetWebLocationListItemsByCustId?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebLocationListItemsByCustId(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebLocationListItemsByCustId(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebLocation[]>;
        }));
    }

    protected processGetWebLocationListItemsByCustId(response: HttpResponseBase): Observable<WebLocation[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebLocation[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebLocation[]>(null as any);
    }

    /**
     * @return OK
     */
    getLocation(branchCustId: string, locId: number): Observable<Location>
    {
        let url_ = this.baseUrl + "/Location/GetLocation?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (locId === undefined || locId === null)
            throw new Error("The parameter 'locId' must be defined and cannot be null.");
        else
            url_ += "locId=" + encodeURIComponent("" + locId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLocation(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLocation(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Location>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Location>;
        }));
    }

    protected processGetLocation(response: HttpResponseBase): Observable<Location>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Location;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Location>(null as any);
    }

    /**
     * @return OK
     */
    getLocationByIdWeb(branchCustId: string, locId: number): Observable<Location>
    {
        let url_ = this.baseUrl + "/Location/GetLocationByIdWeb?";
        if (branchCustId === undefined || branchCustId === null)
            throw new Error("The parameter 'branchCustId' must be defined and cannot be null.");
        else
            url_ += "branchCustId=" + encodeURIComponent("" + branchCustId) + "&";
        if (locId === undefined || locId === null)
            throw new Error("The parameter 'locId' must be defined and cannot be null.");
        else
            url_ += "locId=" + encodeURIComponent("" + locId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLocationByIdWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLocationByIdWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<Location>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Location>;
        }));
    }

    protected processGetLocationByIdWeb(response: HttpResponseBase): Observable<Location>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Location;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Location>(null as any);
    }

    /**
     * @return OK
     */
    getLocationDescriptions(): Observable<SelectionItem[]>
    {
        let url_ = this.baseUrl + "/Location/GetLocationDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetLocationDescriptions(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetLocationDescriptions(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<SelectionItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectionItem[]>;
        }));
    }

    protected processGetLocationDescriptions(response: HttpResponseBase): Observable<SelectionItem[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectionItem[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectionItem[]>(null as any);
    }

    /**
     * @return OK
     */
    calculatePrices(webPriceCalculator: WebPriceCalculator): Observable<WebPriceCalculator>
    {
        let url_ = this.baseUrl + "/Location/CalculatePrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webPriceCalculator);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processCalculatePrices(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processCalculatePrices(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebPriceCalculator>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebPriceCalculator>;
        }));
    }

    protected processCalculatePrices(response: HttpResponseBase): Observable<WebPriceCalculator>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebPriceCalculator;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebPriceCalculator>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UtilityClient
{
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:50534";
    }

    /**
     * @return OK
     */
    getPriceCode(priceCode: number): Observable<PriceControl>
    {
        let url_ = this.baseUrl + "/Utility/GetPriceCode?";
        if (priceCode === undefined || priceCode === null)
            throw new Error("The parameter 'priceCode' must be defined and cannot be null.");
        else
            url_ += "priceCode=" + encodeURIComponent("" + priceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetPriceCode(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetPriceCode(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<PriceControl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriceControl>;
        }));
    }

    protected processGetPriceCode(response: HttpResponseBase): Observable<PriceControl>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PriceControl;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PriceControl>(null as any);
    }

    /**
     * @param branchNo (optional) 
     * @param dataLogical (optional) 
     * @return OK
     */
    getWebSettings(branchNo?: string | null | undefined, dataLogical?: string | null | undefined): Observable<WebSettings>
    {
        let url_ = this.baseUrl + "/Utility/GetWebSettings?";
        if (branchNo !== undefined && branchNo !== null)
            url_ += "branchNo=" + encodeURIComponent("" + branchNo) + "&";
        if (dataLogical !== undefined && dataLogical !== null)
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebSettings(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebSettings(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebSettings>;
        }));
    }

    protected processGetWebSettings(response: HttpResponseBase): Observable<WebSettings>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebSettings;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebSettings>(null as any);
    }

    /**
     * @return OK
     */
    getWebFeatureAvailability(webDataLogical: string): Observable<WebFeatureResponse>
    {
        let url_ = this.baseUrl + "/Utility/GetWebFeatureAvailability?";
        if (webDataLogical === undefined || webDataLogical === null)
            throw new Error("The parameter 'webDataLogical' must be defined and cannot be null.");
        else
            url_ += "webDataLogical=" + encodeURIComponent("" + webDataLogical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetWebFeatureAvailability(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetWebFeatureAvailability(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebFeatureResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebFeatureResponse>;
        }));
    }

    protected processGetWebFeatureAvailability(response: HttpResponseBase): Observable<WebFeatureResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebFeatureResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebFeatureResponse>(null as any);
    }

    /**
     * @return OK
     */
    writeContactWeb(contact: ContactWeb): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/WriteContactWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWriteContactWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWriteContactWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWriteContactWeb(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteContactWeb(contact: ContactWeb): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/DeleteContactWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contact);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processDeleteContactWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processDeleteContactWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteContactWeb(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    deleteContactsWeb(contacts: ContactWeb[]): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/DeleteContactsWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contacts);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processDeleteContactsWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processDeleteContactsWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteContactsWeb(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    writeServiceWorkOrder(swo: WebSwoDeliveryRequest): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/WriteServiceWorkOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(swo);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWriteServiceWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWriteServiceWorkOrder(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWriteServiceWorkOrder(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    writeManualDelivery(manDelivery: WebSwoDeliveryRequest): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/WriteManualDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(manDelivery);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWriteManualDelivery(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWriteManualDelivery(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWriteManualDelivery(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     * @deprecated
     */
    logErrorWeb(error: string, webDataLogical: string): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/LogErrorWeb?";
        if (error === undefined || error === null)
            throw new Error("The parameter 'error' must be defined and cannot be null.");
        else
            url_ += "error=" + encodeURIComponent("" + error) + "&";
        if (webDataLogical === undefined || webDataLogical === null)
            throw new Error("The parameter 'webDataLogical' must be defined and cannot be null.");
        else
            url_ += "webDataLogical=" + encodeURIComponent("" + webDataLogical) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processLogErrorWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processLogErrorWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLogErrorWeb(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    logErrorWebV2(appWebError: AppWebError): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/LogErrorWebV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appWebError);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processLogErrorWebV2(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processLogErrorWebV2(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLogErrorWebV2(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    logWebAction(webTrackingLog: WebTrackingLog): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/LogWebAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webTrackingLog);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processLogWebAction(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processLogWebAction(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLogWebAction(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getPhoneDescriptions(): Observable<WebSelectionItem[]>
    {
        let url_ = this.baseUrl + "/Utility/GetPhoneDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processGetPhoneDescriptions(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processGetPhoneDescriptions(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<WebSelectionItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebSelectionItem[]>;
        }));
    }

    protected processGetPhoneDescriptions(response: HttpResponseBase): Observable<WebSelectionItem[]>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebSelectionItem[];
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebSelectionItem[]>(null as any);
    }

    /**
     * @return OK
     */
    requestPendingDeliveryEmail(webRequest: WebSwoDeliveryRequest): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/RequestPendingDeliveryEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processRequestPendingDeliveryEmail(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processRequestPendingDeliveryEmail(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRequestPendingDeliveryEmail(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendAutopayEmails(webRequest: WebSwoDeliveryRequest): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/SendAutopayEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendAutopayEmails(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendAutopayEmails(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendAutopayEmails(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendAutopayCancellationEmails(webRequest: WebSwoDeliveryRequest): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/SendAutopayCancellationEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendAutopayCancellationEmails(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendAutopayCancellationEmails(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendAutopayCancellationEmails(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    writeContactNotificationWeb(notificationSettings: WebNotificationSettings): Observable<boolean>
    {
        let url_ = this.baseUrl + "/Utility/WriteContactNotificationWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationSettings);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processWriteContactNotificationWeb(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processWriteContactNotificationWeb(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWriteContactNotificationWeb(response: HttpResponseBase): Observable<boolean>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    sendEmailRequest(webRequest: WebSwoDeliveryRequest): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Utility/SendEmailRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendEmailRequest(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendEmailRequest(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSendEmailRequest(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendEmailTempPassword(webRegistration: WebRegistration, dataLogical: string, isRegister: boolean, baseUrl: string): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Utility/SendEmailTempPassword?";
        if (dataLogical === undefined || dataLogical === null)
            throw new Error("The parameter 'dataLogical' must be defined and cannot be null.");
        else
            url_ += "dataLogical=" + encodeURIComponent("" + dataLogical) + "&";
        if (isRegister === undefined || isRegister === null)
            throw new Error("The parameter 'isRegister' must be defined and cannot be null.");
        else
            url_ += "isRegister=" + encodeURIComponent("" + isRegister) + "&";
        if (baseUrl === undefined || baseUrl === null)
            throw new Error("The parameter 'baseUrl' must be defined and cannot be null.");
        else
            url_ += "baseUrl=" + encodeURIComponent("" + baseUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webRegistration);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendEmailTempPassword(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendEmailTempPassword(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSendEmailTempPassword(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendEmailWriteContract(webContractAgreement: WebContractAgreement): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Utility/SendEmailWriteContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webContractAgreement);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendEmailWriteContract(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendEmailWriteContract(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSendEmailWriteContract(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @return OK
     */
    sendChaseEmailReceipt(chaseOtp: OneTimePaymentRequest): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Utility/SendChaseEmailReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chaseOtp);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendChaseEmailReceipt(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendChaseEmailReceipt(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSendChaseEmailReceipt(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }

    /**
     * @param otp_aPSPayment_application (optional) 
     * @param otp_aPSPayment_sourceNo (optional) 
     * @param otp_aPSPayment_paymentMethod (optional) 
     * @param otp_aPSPayment_branchNo (optional) 
     * @param otp_aPSPayment_dataLogical (optional) 
     * @param otp_aPSPayment_id (optional) 
     * @param otp_aPSPayment_employeeId (optional) 
     * @param otp_aPSPayment_companyName (optional) 
     * @param otp_aPSPayment_nameFirst (optional) 
     * @param otp_aPSPayment_nameLast (optional) 
     * @param otp_aPSPayment_address1 (optional) 
     * @param otp_aPSPayment_address2 (optional) 
     * @param otp_aPSPayment_city (optional) 
     * @param otp_aPSPayment_state (optional) 
     * @param otp_aPSPayment_zip (optional) 
     * @param otp_aPSPayment_countryCode (optional) 
     * @param otp_aPSPayment_cardNo (optional) 
     * @param otp_aPSPayment_securityCode (optional) 
     * @param otp_aPSPayment_cardExprMonth (optional) 
     * @param otp_aPSPayment_cardExprYear (optional) 
     * @param otp_aPSPayment_cardType (optional) 
     * @param otp_aPSPayment_bankAccountNumber (optional) 
     * @param otp_aPSPayment_bankRoutingNumber (optional) 
     * @param otp_aPSPayment_bankName (optional) 
     * @param otp_aPSPayment_bankAccountType (optional) 
     * @param otp_aPSPayment_amount (optional) 
     * @param otp_aPSPayment_message1 (optional) 
     * @param otp_aPSPayment_message2 (optional) 
     * @param otp_aPSPayment_message3 (optional) 
     * @param otp_aPSPayment_totalAmount (optional) 
     * @param otp_aPSPayment_contractAmount (optional) 
     * @param otp_aPSPayment_contractPayment (optional) 
     * @param otp_aPSPayment_budgetPayment (optional) 
     * @param otp_aPSPayment_fromReceipts (optional) 
     * @param otp_aPSPayment_fromSales (optional) 
     * @param otp_aPSPayment_isAutoPay (optional) 
     * @param otp_aPSPayment_isWebPayment (optional) 
     * @param otp_aPSPayment_isProcessImmediatelyPayment (optional) 
     * @param otp_aPSPayment_failed (optional) 
     * @param otp_aPSPayment_isProcessed (optional) 
     * @param otp_aPSPayment_convenienceFee (optional) 
     * @param otp_aPSPayment_convenienceFeeDescription (optional) 
     * @param otp_aPSPayment_convenienceFeeTax (optional) 
     * @param otp_aPSPayment_runCode (optional) 
     * @param otp_aPSPayment_accountNumber (optional) 
     * @param otp_aPSPayment_authCode (optional) 
     * @param otp_aPSPayment_refNo (optional) 
     * @param otp_aPSPayment_respMsg (optional) 
     * @param otp_aPSPayment_errorMsg (optional) 
     * @param otp_aPSPayment_recNo (optional) 
     * @param otp_aPSPayment_autoPayRecNo (optional) 
     * @param otp_aPSPayment_creationDateTime (optional) 
     * @param otp_aPSPayment_successful (optional) 
     * @param otp_aPSPayment_rccVersion (optional) 
     * @param otp_aPSPayment_computerName (optional) 
     * @param otp_aPSPayment_ipAddress (optional) 
     * @param otp_aPSPayment_checkType (optional) 
     * @param otp_aPSPayment_traceNumber (optional) 
     * @param otp_aPSPayment_processedThrough (optional) 
     * @param otp_aPSPayment_processDate (optional) 
     * @param otp_aPSPayment_rowState (optional) 
     * @param otp_aPSPayment_isChecked (optional) 
     * @param otp_aPSPayment_messageId (optional) 
     * @param otp_company_showDelivery (optional) 
     * @param otp_company_showService (optional) 
     * @param otp_company_apsProcessor (optional) 
     * @param otp_company_name (optional) 
     * @param otp_company_phone (optional) 
     * @param otp_company_address (optional) 
     * @param otp_company_webEmail (optional) 
     * @param otp_company_displayEmail (optional) 
     * @param otp_company_corpEmail (optional) 
     * @param otp_company_version (optional) 
     * @param otp_company_versionInt (optional) 
     * @param otp_company_useNewEmailMethod (optional) 
     * @param otp_company_webDisplayCompanyName (optional) 
     * @param otp_company_webDisplayTransactions (optional) 
     * @param otp_company_webDisplayEquipment (optional) 
     * @param otp_company_webApsSignUpAvailable (optional) 
     * @param otp_company_branchNo (optional) 
     * @param otp_accountAmount (optional) 
     * @param otp_budgetAmount (optional) 
     * @param otp_contractAmount (optional) 
     * @param otp_customerEmail (optional) 
     * @return OK
     */
    sendEmailReceipt(otpResponse: any[], otp_aPSPayment_application?: string | null | undefined, otp_aPSPayment_sourceNo?: number | null | undefined, otp_aPSPayment_paymentMethod?: string | null | undefined, otp_aPSPayment_branchNo?: string | null | undefined, otp_aPSPayment_dataLogical?: string | null | undefined, otp_aPSPayment_id?: string | null | undefined, otp_aPSPayment_employeeId?: string | null | undefined, otp_aPSPayment_companyName?: string | null | undefined, otp_aPSPayment_nameFirst?: string | null | undefined, otp_aPSPayment_nameLast?: string | null | undefined, otp_aPSPayment_address1?: string | null | undefined, otp_aPSPayment_address2?: string | null | undefined, otp_aPSPayment_city?: string | null | undefined, otp_aPSPayment_state?: string | null | undefined, otp_aPSPayment_zip?: string | null | undefined, otp_aPSPayment_countryCode?: string | null | undefined, otp_aPSPayment_cardNo?: number | null | undefined, otp_aPSPayment_securityCode?: string | null | undefined, otp_aPSPayment_cardExprMonth?: number | null | undefined, otp_aPSPayment_cardExprYear?: number | null | undefined, otp_aPSPayment_cardType?: string | null | undefined, otp_aPSPayment_bankAccountNumber?: string | null | undefined, otp_aPSPayment_bankRoutingNumber?: number | null | undefined, otp_aPSPayment_bankName?: string | null | undefined, otp_aPSPayment_bankAccountType?: string | null | undefined, otp_aPSPayment_amount?: number | null | undefined, otp_aPSPayment_message1?: string | null | undefined, otp_aPSPayment_message2?: string | null | undefined, otp_aPSPayment_message3?: string | null | undefined, otp_aPSPayment_totalAmount?: number | null | undefined, otp_aPSPayment_contractAmount?: number | null | undefined, otp_aPSPayment_contractPayment?: boolean | null | undefined, otp_aPSPayment_budgetPayment?: boolean | null | undefined, otp_aPSPayment_fromReceipts?: boolean | null | undefined, otp_aPSPayment_fromSales?: boolean | null | undefined, otp_aPSPayment_isAutoPay?: boolean | null | undefined, otp_aPSPayment_isWebPayment?: boolean | null | undefined, otp_aPSPayment_isProcessImmediatelyPayment?: boolean | null | undefined, otp_aPSPayment_failed?: boolean | null | undefined, otp_aPSPayment_isProcessed?: boolean | null | undefined, otp_aPSPayment_convenienceFee?: number | null | undefined, otp_aPSPayment_convenienceFeeDescription?: string | null | undefined, otp_aPSPayment_convenienceFeeTax?: number | null | undefined, otp_aPSPayment_runCode?: number | null | undefined, otp_aPSPayment_accountNumber?: number | null | undefined, otp_aPSPayment_authCode?: string | null | undefined, otp_aPSPayment_refNo?: string | null | undefined, otp_aPSPayment_respMsg?: string | null | undefined, otp_aPSPayment_errorMsg?: string | null | undefined, otp_aPSPayment_recNo?: number | null | undefined, otp_aPSPayment_autoPayRecNo?: number | null | undefined, otp_aPSPayment_creationDateTime?: Date | null | undefined, otp_aPSPayment_successful?: boolean | null | undefined, otp_aPSPayment_rccVersion?: string | null | undefined, otp_aPSPayment_computerName?: string | null | undefined, otp_aPSPayment_ipAddress?: string | null | undefined, otp_aPSPayment_checkType?: number | null | undefined, otp_aPSPayment_traceNumber?: number | null | undefined, otp_aPSPayment_processedThrough?: string | null | undefined, otp_aPSPayment_processDate?: Date | null | undefined, otp_aPSPayment_rowState?: RowState4 | null | undefined, otp_aPSPayment_isChecked?: boolean | null | undefined, otp_aPSPayment_messageId?: string | null | undefined, otp_company_showDelivery?: boolean | null | undefined, otp_company_showService?: boolean | null | undefined, otp_company_apsProcessor?: number | null | undefined, otp_company_name?: string | null | undefined, otp_company_phone?: string | null | undefined, otp_company_address?: string | null | undefined, otp_company_webEmail?: string | null | undefined, otp_company_displayEmail?: string | null | undefined, otp_company_corpEmail?: string | null | undefined, otp_company_version?: string | null | undefined, otp_company_versionInt?: number | null | undefined, otp_company_useNewEmailMethod?: boolean | null | undefined, otp_company_webDisplayCompanyName?: boolean | null | undefined, otp_company_webDisplayTransactions?: boolean | null | undefined, otp_company_webDisplayEquipment?: boolean | null | undefined, otp_company_webApsSignUpAvailable?: boolean | null | undefined, otp_company_branchNo?: number | null | undefined, otp_accountAmount?: number | null | undefined, otp_budgetAmount?: number | null | undefined, otp_contractAmount?: number | null | undefined, otp_customerEmail?: string | null | undefined): Observable<GeneralResponse>
    {
        let url_ = this.baseUrl + "/Utility/SendEmailReceipt?";
        if (otpResponse === undefined || otpResponse === null)
            throw new Error("The parameter 'otpResponse' must be defined and cannot be null.");
        else
            otpResponse && otpResponse.forEach((item, index) =>
            {
                for (let attr in item)
                    if (item.hasOwnProperty(attr))
                    {
                        url_ += "otpResponse[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (otp_aPSPayment_application !== undefined && otp_aPSPayment_application !== null)
            url_ += "otp.aPSPayment.application=" + encodeURIComponent("" + otp_aPSPayment_application) + "&";
        if (otp_aPSPayment_sourceNo !== undefined && otp_aPSPayment_sourceNo !== null)
            url_ += "otp.aPSPayment.sourceNo=" + encodeURIComponent("" + otp_aPSPayment_sourceNo) + "&";
        if (otp_aPSPayment_paymentMethod !== undefined && otp_aPSPayment_paymentMethod !== null)
            url_ += "otp.aPSPayment.paymentMethod=" + encodeURIComponent("" + otp_aPSPayment_paymentMethod) + "&";
        if (otp_aPSPayment_branchNo !== undefined && otp_aPSPayment_branchNo !== null)
            url_ += "otp.aPSPayment.branchNo=" + encodeURIComponent("" + otp_aPSPayment_branchNo) + "&";
        if (otp_aPSPayment_dataLogical !== undefined && otp_aPSPayment_dataLogical !== null)
            url_ += "otp.aPSPayment.dataLogical=" + encodeURIComponent("" + otp_aPSPayment_dataLogical) + "&";
        if (otp_aPSPayment_id !== undefined && otp_aPSPayment_id !== null)
            url_ += "otp.aPSPayment.id=" + encodeURIComponent("" + otp_aPSPayment_id) + "&";
        if (otp_aPSPayment_employeeId !== undefined && otp_aPSPayment_employeeId !== null)
            url_ += "otp.aPSPayment.employeeId=" + encodeURIComponent("" + otp_aPSPayment_employeeId) + "&";
        if (otp_aPSPayment_companyName !== undefined && otp_aPSPayment_companyName !== null)
            url_ += "otp.aPSPayment.companyName=" + encodeURIComponent("" + otp_aPSPayment_companyName) + "&";
        if (otp_aPSPayment_nameFirst !== undefined && otp_aPSPayment_nameFirst !== null)
            url_ += "otp.aPSPayment.nameFirst=" + encodeURIComponent("" + otp_aPSPayment_nameFirst) + "&";
        if (otp_aPSPayment_nameLast !== undefined && otp_aPSPayment_nameLast !== null)
            url_ += "otp.aPSPayment.nameLast=" + encodeURIComponent("" + otp_aPSPayment_nameLast) + "&";
        if (otp_aPSPayment_address1 !== undefined && otp_aPSPayment_address1 !== null)
            url_ += "otp.aPSPayment.address1=" + encodeURIComponent("" + otp_aPSPayment_address1) + "&";
        if (otp_aPSPayment_address2 !== undefined && otp_aPSPayment_address2 !== null)
            url_ += "otp.aPSPayment.address2=" + encodeURIComponent("" + otp_aPSPayment_address2) + "&";
        if (otp_aPSPayment_city !== undefined && otp_aPSPayment_city !== null)
            url_ += "otp.aPSPayment.city=" + encodeURIComponent("" + otp_aPSPayment_city) + "&";
        if (otp_aPSPayment_state !== undefined && otp_aPSPayment_state !== null)
            url_ += "otp.aPSPayment.state=" + encodeURIComponent("" + otp_aPSPayment_state) + "&";
        if (otp_aPSPayment_zip !== undefined && otp_aPSPayment_zip !== null)
            url_ += "otp.aPSPayment.zip=" + encodeURIComponent("" + otp_aPSPayment_zip) + "&";
        if (otp_aPSPayment_countryCode !== undefined && otp_aPSPayment_countryCode !== null)
            url_ += "otp.aPSPayment.countryCode=" + encodeURIComponent("" + otp_aPSPayment_countryCode) + "&";
        if (otp_aPSPayment_cardNo !== undefined && otp_aPSPayment_cardNo !== null)
            url_ += "otp.aPSPayment.cardNo=" + encodeURIComponent("" + otp_aPSPayment_cardNo) + "&";
        if (otp_aPSPayment_securityCode !== undefined && otp_aPSPayment_securityCode !== null)
            url_ += "otp.aPSPayment.securityCode=" + encodeURIComponent("" + otp_aPSPayment_securityCode) + "&";
        if (otp_aPSPayment_cardExprMonth !== undefined && otp_aPSPayment_cardExprMonth !== null)
            url_ += "otp.aPSPayment.cardExprMonth=" + encodeURIComponent("" + otp_aPSPayment_cardExprMonth) + "&";
        if (otp_aPSPayment_cardExprYear !== undefined && otp_aPSPayment_cardExprYear !== null)
            url_ += "otp.aPSPayment.cardExprYear=" + encodeURIComponent("" + otp_aPSPayment_cardExprYear) + "&";
        if (otp_aPSPayment_cardType !== undefined && otp_aPSPayment_cardType !== null)
            url_ += "otp.aPSPayment.cardType=" + encodeURIComponent("" + otp_aPSPayment_cardType) + "&";
        if (otp_aPSPayment_bankAccountNumber !== undefined && otp_aPSPayment_bankAccountNumber !== null)
            url_ += "otp.aPSPayment.bankAccountNumber=" + encodeURIComponent("" + otp_aPSPayment_bankAccountNumber) + "&";
        if (otp_aPSPayment_bankRoutingNumber !== undefined && otp_aPSPayment_bankRoutingNumber !== null)
            url_ += "otp.aPSPayment.bankRoutingNumber=" + encodeURIComponent("" + otp_aPSPayment_bankRoutingNumber) + "&";
        if (otp_aPSPayment_bankName !== undefined && otp_aPSPayment_bankName !== null)
            url_ += "otp.aPSPayment.bankName=" + encodeURIComponent("" + otp_aPSPayment_bankName) + "&";
        if (otp_aPSPayment_bankAccountType !== undefined && otp_aPSPayment_bankAccountType !== null)
            url_ += "otp.aPSPayment.bankAccountType=" + encodeURIComponent("" + otp_aPSPayment_bankAccountType) + "&";
        if (otp_aPSPayment_amount !== undefined && otp_aPSPayment_amount !== null)
            url_ += "otp.aPSPayment.amount=" + encodeURIComponent("" + otp_aPSPayment_amount) + "&";
        if (otp_aPSPayment_message1 !== undefined && otp_aPSPayment_message1 !== null)
            url_ += "otp.aPSPayment.message1=" + encodeURIComponent("" + otp_aPSPayment_message1) + "&";
        if (otp_aPSPayment_message2 !== undefined && otp_aPSPayment_message2 !== null)
            url_ += "otp.aPSPayment.message2=" + encodeURIComponent("" + otp_aPSPayment_message2) + "&";
        if (otp_aPSPayment_message3 !== undefined && otp_aPSPayment_message3 !== null)
            url_ += "otp.aPSPayment.message3=" + encodeURIComponent("" + otp_aPSPayment_message3) + "&";
        if (otp_aPSPayment_totalAmount !== undefined && otp_aPSPayment_totalAmount !== null)
            url_ += "otp.aPSPayment.totalAmount=" + encodeURIComponent("" + otp_aPSPayment_totalAmount) + "&";
        if (otp_aPSPayment_contractAmount !== undefined && otp_aPSPayment_contractAmount !== null)
            url_ += "otp.aPSPayment.contractAmount=" + encodeURIComponent("" + otp_aPSPayment_contractAmount) + "&";
        if (otp_aPSPayment_contractPayment !== undefined && otp_aPSPayment_contractPayment !== null)
            url_ += "otp.aPSPayment.contractPayment=" + encodeURIComponent("" + otp_aPSPayment_contractPayment) + "&";
        if (otp_aPSPayment_budgetPayment !== undefined && otp_aPSPayment_budgetPayment !== null)
            url_ += "otp.aPSPayment.budgetPayment=" + encodeURIComponent("" + otp_aPSPayment_budgetPayment) + "&";
        if (otp_aPSPayment_fromReceipts !== undefined && otp_aPSPayment_fromReceipts !== null)
            url_ += "otp.aPSPayment.fromReceipts=" + encodeURIComponent("" + otp_aPSPayment_fromReceipts) + "&";
        if (otp_aPSPayment_fromSales !== undefined && otp_aPSPayment_fromSales !== null)
            url_ += "otp.aPSPayment.fromSales=" + encodeURIComponent("" + otp_aPSPayment_fromSales) + "&";
        if (otp_aPSPayment_isAutoPay !== undefined && otp_aPSPayment_isAutoPay !== null)
            url_ += "otp.aPSPayment.isAutoPay=" + encodeURIComponent("" + otp_aPSPayment_isAutoPay) + "&";
        if (otp_aPSPayment_isWebPayment !== undefined && otp_aPSPayment_isWebPayment !== null)
            url_ += "otp.aPSPayment.isWebPayment=" + encodeURIComponent("" + otp_aPSPayment_isWebPayment) + "&";
        if (otp_aPSPayment_isProcessImmediatelyPayment !== undefined && otp_aPSPayment_isProcessImmediatelyPayment !== null)
            url_ += "otp.aPSPayment.isProcessImmediatelyPayment=" + encodeURIComponent("" + otp_aPSPayment_isProcessImmediatelyPayment) + "&";
        if (otp_aPSPayment_failed !== undefined && otp_aPSPayment_failed !== null)
            url_ += "otp.aPSPayment.failed=" + encodeURIComponent("" + otp_aPSPayment_failed) + "&";
        if (otp_aPSPayment_isProcessed !== undefined && otp_aPSPayment_isProcessed !== null)
            url_ += "otp.aPSPayment.isProcessed=" + encodeURIComponent("" + otp_aPSPayment_isProcessed) + "&";
        if (otp_aPSPayment_convenienceFee !== undefined && otp_aPSPayment_convenienceFee !== null)
            url_ += "otp.aPSPayment.convenienceFee=" + encodeURIComponent("" + otp_aPSPayment_convenienceFee) + "&";
        if (otp_aPSPayment_convenienceFeeDescription !== undefined && otp_aPSPayment_convenienceFeeDescription !== null)
            url_ += "otp.aPSPayment.convenienceFeeDescription=" + encodeURIComponent("" + otp_aPSPayment_convenienceFeeDescription) + "&";
        if (otp_aPSPayment_convenienceFeeTax !== undefined && otp_aPSPayment_convenienceFeeTax !== null)
            url_ += "otp.aPSPayment.convenienceFeeTax=" + encodeURIComponent("" + otp_aPSPayment_convenienceFeeTax) + "&";
        if (otp_aPSPayment_runCode !== undefined && otp_aPSPayment_runCode !== null)
            url_ += "otp.aPSPayment.runCode=" + encodeURIComponent("" + otp_aPSPayment_runCode) + "&";
        if (otp_aPSPayment_accountNumber !== undefined && otp_aPSPayment_accountNumber !== null)
            url_ += "otp.aPSPayment.accountNumber=" + encodeURIComponent("" + otp_aPSPayment_accountNumber) + "&";
        if (otp_aPSPayment_authCode !== undefined && otp_aPSPayment_authCode !== null)
            url_ += "otp.aPSPayment.authCode=" + encodeURIComponent("" + otp_aPSPayment_authCode) + "&";
        if (otp_aPSPayment_refNo !== undefined && otp_aPSPayment_refNo !== null)
            url_ += "otp.aPSPayment.refNo=" + encodeURIComponent("" + otp_aPSPayment_refNo) + "&";
        if (otp_aPSPayment_respMsg !== undefined && otp_aPSPayment_respMsg !== null)
            url_ += "otp.aPSPayment.respMsg=" + encodeURIComponent("" + otp_aPSPayment_respMsg) + "&";
        if (otp_aPSPayment_errorMsg !== undefined && otp_aPSPayment_errorMsg !== null)
            url_ += "otp.aPSPayment.errorMsg=" + encodeURIComponent("" + otp_aPSPayment_errorMsg) + "&";
        if (otp_aPSPayment_recNo !== undefined && otp_aPSPayment_recNo !== null)
            url_ += "otp.aPSPayment.recNo=" + encodeURIComponent("" + otp_aPSPayment_recNo) + "&";
        if (otp_aPSPayment_autoPayRecNo !== undefined && otp_aPSPayment_autoPayRecNo !== null)
            url_ += "otp.aPSPayment.autoPayRecNo=" + encodeURIComponent("" + otp_aPSPayment_autoPayRecNo) + "&";
        if (otp_aPSPayment_creationDateTime !== undefined && otp_aPSPayment_creationDateTime !== null)
            url_ += "otp.aPSPayment.creationDateTime=" + encodeURIComponent(otp_aPSPayment_creationDateTime ? "" + otp_aPSPayment_creationDateTime.toISOString() : "") + "&";
        if (otp_aPSPayment_successful !== undefined && otp_aPSPayment_successful !== null)
            url_ += "otp.aPSPayment.successful=" + encodeURIComponent("" + otp_aPSPayment_successful) + "&";
        if (otp_aPSPayment_rccVersion !== undefined && otp_aPSPayment_rccVersion !== null)
            url_ += "otp.aPSPayment.rccVersion=" + encodeURIComponent("" + otp_aPSPayment_rccVersion) + "&";
        if (otp_aPSPayment_computerName !== undefined && otp_aPSPayment_computerName !== null)
            url_ += "otp.aPSPayment.computerName=" + encodeURIComponent("" + otp_aPSPayment_computerName) + "&";
        if (otp_aPSPayment_ipAddress !== undefined && otp_aPSPayment_ipAddress !== null)
            url_ += "otp.aPSPayment.ipAddress=" + encodeURIComponent("" + otp_aPSPayment_ipAddress) + "&";
        if (otp_aPSPayment_checkType !== undefined && otp_aPSPayment_checkType !== null)
            url_ += "otp.aPSPayment.checkType=" + encodeURIComponent("" + otp_aPSPayment_checkType) + "&";
        if (otp_aPSPayment_traceNumber !== undefined && otp_aPSPayment_traceNumber !== null)
            url_ += "otp.aPSPayment.traceNumber=" + encodeURIComponent("" + otp_aPSPayment_traceNumber) + "&";
        if (otp_aPSPayment_processedThrough !== undefined && otp_aPSPayment_processedThrough !== null)
            url_ += "otp.aPSPayment.processedThrough=" + encodeURIComponent("" + otp_aPSPayment_processedThrough) + "&";
        if (otp_aPSPayment_processDate !== undefined && otp_aPSPayment_processDate !== null)
            url_ += "otp.aPSPayment.processDate=" + encodeURIComponent(otp_aPSPayment_processDate ? "" + otp_aPSPayment_processDate.toISOString() : "") + "&";
        if (otp_aPSPayment_rowState !== undefined && otp_aPSPayment_rowState !== null)
            url_ += "otp.aPSPayment.rowState=" + encodeURIComponent("" + otp_aPSPayment_rowState) + "&";
        if (otp_aPSPayment_isChecked !== undefined && otp_aPSPayment_isChecked !== null)
            url_ += "otp.aPSPayment.isChecked=" + encodeURIComponent("" + otp_aPSPayment_isChecked) + "&";
        if (otp_aPSPayment_messageId !== undefined && otp_aPSPayment_messageId !== null)
            url_ += "otp.aPSPayment.messageId=" + encodeURIComponent("" + otp_aPSPayment_messageId) + "&";
        if (otp_company_showDelivery !== undefined && otp_company_showDelivery !== null)
            url_ += "otp.company.showDelivery=" + encodeURIComponent("" + otp_company_showDelivery) + "&";
        if (otp_company_showService !== undefined && otp_company_showService !== null)
            url_ += "otp.company.showService=" + encodeURIComponent("" + otp_company_showService) + "&";
        if (otp_company_apsProcessor !== undefined && otp_company_apsProcessor !== null)
            url_ += "otp.company.apsProcessor=" + encodeURIComponent("" + otp_company_apsProcessor) + "&";
        if (otp_company_name !== undefined && otp_company_name !== null)
            url_ += "otp.company.name=" + encodeURIComponent("" + otp_company_name) + "&";
        if (otp_company_phone !== undefined && otp_company_phone !== null)
            url_ += "otp.company.phone=" + encodeURIComponent("" + otp_company_phone) + "&";
        if (otp_company_address !== undefined && otp_company_address !== null)
            url_ += "otp.company.address=" + encodeURIComponent("" + otp_company_address) + "&";
        if (otp_company_webEmail !== undefined && otp_company_webEmail !== null)
            url_ += "otp.company.webEmail=" + encodeURIComponent("" + otp_company_webEmail) + "&";
        if (otp_company_displayEmail !== undefined && otp_company_displayEmail !== null)
            url_ += "otp.company.displayEmail=" + encodeURIComponent("" + otp_company_displayEmail) + "&";
        if (otp_company_corpEmail !== undefined && otp_company_corpEmail !== null)
            url_ += "otp.company.corpEmail=" + encodeURIComponent("" + otp_company_corpEmail) + "&";
        if (otp_company_version !== undefined && otp_company_version !== null)
            url_ += "otp.company.version=" + encodeURIComponent("" + otp_company_version) + "&";
        if (otp_company_versionInt !== undefined && otp_company_versionInt !== null)
            url_ += "otp.company.versionInt=" + encodeURIComponent("" + otp_company_versionInt) + "&";
        if (otp_company_useNewEmailMethod !== undefined && otp_company_useNewEmailMethod !== null)
            url_ += "otp.company.useNewEmailMethod=" + encodeURIComponent("" + otp_company_useNewEmailMethod) + "&";
        if (otp_company_webDisplayCompanyName !== undefined && otp_company_webDisplayCompanyName !== null)
            url_ += "otp.company.webDisplayCompanyName=" + encodeURIComponent("" + otp_company_webDisplayCompanyName) + "&";
        if (otp_company_webDisplayTransactions !== undefined && otp_company_webDisplayTransactions !== null)
            url_ += "otp.company.webDisplayTransactions=" + encodeURIComponent("" + otp_company_webDisplayTransactions) + "&";
        if (otp_company_webDisplayEquipment !== undefined && otp_company_webDisplayEquipment !== null)
            url_ += "otp.company.webDisplayEquipment=" + encodeURIComponent("" + otp_company_webDisplayEquipment) + "&";
        if (otp_company_webApsSignUpAvailable !== undefined && otp_company_webApsSignUpAvailable !== null)
            url_ += "otp.company.webApsSignUpAvailable=" + encodeURIComponent("" + otp_company_webApsSignUpAvailable) + "&";
        if (otp_company_branchNo !== undefined && otp_company_branchNo !== null)
            url_ += "otp.company.branchNo=" + encodeURIComponent("" + otp_company_branchNo) + "&";
        if (otp_accountAmount !== undefined && otp_accountAmount !== null)
            url_ += "otp.accountAmount=" + encodeURIComponent("" + otp_accountAmount) + "&";
        if (otp_budgetAmount !== undefined && otp_budgetAmount !== null)
            url_ += "otp.budgetAmount=" + encodeURIComponent("" + otp_budgetAmount) + "&";
        if (otp_contractAmount !== undefined && otp_contractAmount !== null)
            url_ += "otp.contractAmount=" + encodeURIComponent("" + otp_contractAmount) + "&";
        if (otp_customerEmail !== undefined && otp_customerEmail !== null)
            url_ += "otp.customerEmail=" + encodeURIComponent("" + otp_customerEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) =>
        {
            return this.processSendEmailReceipt(response_);
        })).pipe(_observableCatch((response_: any) =>
        {
            if (response_ instanceof HttpResponseBase)
            {
                try
                {
                    return this.processSendEmailReceipt(response_ as any);
                } catch (e)
                {
                    return _observableThrow(e) as any as Observable<GeneralResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralResponse>;
        }));
    }

    protected processSendEmailReceipt(response: HttpResponseBase): Observable<GeneralResponse>
    {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralResponse;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204)
        {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText =>
            {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralResponse>(null as any);
    }
}

export interface LoginModel
{
    IsCustomer?: boolean | undefined;
    Username?: string | undefined;
    CustID?: string | undefined;
    DataLogical?: string | undefined;
    Password?: string | undefined;
}

export interface Company
{
    WebDisplayTransactions?: boolean | undefined;
    WebDisplayEquipment?: boolean | undefined;
    WebDisplayCompanyName?: boolean | undefined;
    WebSwoDlvs?: boolean | undefined;
    WebSwoOnly?: boolean | undefined;
    WebDlvOnly?: boolean | undefined;
    WebMagtekScanner?: boolean | undefined;
    WebCharts?: boolean | undefined;
    WebNoLegalPymts?: boolean | undefined;
    WebApsSignUpAvailable?: boolean | undefined;
    KeyName?: string | undefined;
    KeyUsrOrPrg?: string | undefined;
    Desc?: string | undefined;
    PrtNo1?: number | undefined;
    PauseBefore?: number | undefined;
    PauseAfter?: number | undefined;
    NtVersion?: number | undefined;
    PasswordReq?: number | undefined;
    SecureOverride?: number | undefined;
    CorpEmail?: string | undefined;
    WebEmail?: string | undefined;
    WebSiteAddr?: string | undefined;
    MailServer?: string | undefined;
    CorpLanguage?: number | undefined;
    CorpDateFormat?: number | undefined;
    MapModule?: number | undefined;
    ImgModule?: number | undefined;
    CalModule?: number | undefined;
    EcomModule?: number | undefined;
    Terabyte?: number | undefined;
    WebHits?: number | undefined;
    BatchMode?: number | undefined;
    ChartModule?: number | undefined;
    CurrRevision?: string | undefined;
    WebinqModule?: number | undefined;
    SmtpUsername?: string | undefined;
    SmtpPassword?: string | undefined;
    SmtpSsl?: number | undefined;
    NextSeq?: number | undefined;
    ApsToken?: string | undefined;
    ApsCpayRecNo?: number | undefined;
    ApsCmstRecNo1?: number | undefined;
    ApsCpayRecNoAlt?: number | undefined;
    ApsCmstRecNoAlt?: number | undefined;
    ApsServer?: number | undefined;
    ApsAvail?: boolean | undefined;
    ApsCardAvailable1?: number | undefined;
    ApsBankAvailable1?: number | undefined;
    ApsCachRecNo1?: number | undefined;
    ApsCachRecNoAlt1?: number | undefined;
    ApsProcessor?: number | undefined;
    Version?: string | undefined;
    DataNumber?: number | undefined;
    DataDateTime?: Date | undefined;
    CorpId?: string | undefined;
    Name?: string | undefined;
    Phone?: string | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    Address3?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    Zip?: string | undefined;
    RunCode?: number | undefined;
    GpsLat?: number | undefined;
    GpsLong?: number | undefined;
    GpsLatNS?: string | undefined;
    GpsLongEW?: string | undefined;
    DecimalGpsLat?: number | undefined;
    DecimalGpsLon?: number | undefined;
    BranchNo?: number | undefined;
    RowState?: CompanyRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface LogicalWithDetail
{
    DataLogical?: string | undefined;
    CompanyDescription?: string | undefined;
}

export interface AvailableTypes
{
    CardTypes?: APSSelectionItem[] | undefined;
    BankTypes?: APSSelectionItem[] | undefined;
}

export interface APSSelectionItem
{
    Type?: string | undefined;
    Description?: string | undefined;
}

export interface APSMaster
{
    RecNo?: number | undefined;
    Appl?: string | undefined;
    SourceNo?: number | undefined;
    PymtMethod?: string | undefined;
    RecordType?: number | undefined;
    ApplId?: string | undefined;
    CoName?: string | undefined;
    NameFirst?: string | undefined;
    NameLast?: string | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    City?: string | undefined;
    St?: string | undefined;
    Zip?: string | undefined;
    CountryCd?: string | undefined;
    TelephoneNo?: number | undefined;
    TelephoneExt?: number | undefined;
    TelephoneCountryAccess?: number | undefined;
    EmailAddr?: string | undefined;
    EmailConfirm?: number | undefined;
    CardExprYear?: number | undefined;
    CardExprMonth?: number | undefined;
    CardNo?: number | undefined;
    CardType?: string | undefined;
    BankType?: string | undefined;
    BankTypeString?: string | undefined;
    CheckType?: number | undefined;
    BankNo?: number | undefined;
    BankAcct?: string | undefined;
    BankName?: string | undefined;
    CoNameE?: string | undefined;
    NameFirstE?: string | undefined;
    NameLastE?: string | undefined;
    Address1E?: string | undefined;
    CityE?: string | undefined;
    BankNameE?: string | undefined;
    TelephoneNoE?: string | undefined;
    Debit?: number | undefined;
    OrigRecNo?: number | undefined;
    RefNo?: string | undefined;
    WebWorkRecord?: number | undefined;
    RefToken?: string | undefined;
    RefProfileId?: string | undefined;
    RefCardType?: string | undefined;
    ScanCode?: number | undefined;
    ScanAcct?: string | undefined;
    Primary?: boolean | undefined;
    SameAsBillingAddr?: boolean | undefined;
    SecurityCode?: string | undefined;
    ForceDay?: number | undefined;
    RunCode?: number | undefined;
    AccountNumber?: number | undefined;
    BranchNo?: string | undefined;
    FromWeb?: boolean | undefined;
    IsEncrypted?: boolean | undefined;
    DateCreated?: Date | undefined;
    CardExprMonthYear?: string | undefined;
    MaskedCardNo?: string | undefined;
    MaskedBankAcct?: string | undefined;
    PrimaryString?: string | undefined;
    ErrCode?: number | undefined;
    ErrMsg?: string | undefined;
    CardTypeString?: string | undefined;
    RowState?: APSMasterRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface OneTimePaymentRequest
{
    APSPayment?: APSPayment | undefined;
    Company?: WebCompany | undefined;
    AccountAmount?: number | undefined;
    BudgetAmount?: number | undefined;
    ContractAmount?: number | undefined;
    CustomerEmail?: string | undefined;
}

export interface APSPayment
{
    Application?: string | undefined;
    SourceNo?: number | undefined;
    PaymentMethod?: string | undefined;
    BranchNo?: string | undefined;
    DataLogical?: string | undefined;
    Id?: string | undefined;
    EmployeeId?: string | undefined;
    CompanyName?: string | undefined;
    NameFirst?: string | undefined;
    NameLast?: string | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    Zip?: string | undefined;
    CountryCode?: string | undefined;
    CardNo?: number | undefined;
    SecurityCode?: string | undefined;
    CardExprMonth?: number | undefined;
    CardExprYear?: number | undefined;
    CardType?: string | undefined;
    BankAccountNumber?: string | undefined;
    BankRoutingNumber?: number | undefined;
    BankName?: string | undefined;
    BankAccountType?: string | undefined;
    Amount?: number | undefined;
    Message1?: string | undefined;
    Message2?: string | undefined;
    Message3?: string | undefined;
    TotalAmount?: number | undefined;
    ContractAmount?: number | undefined;
    ContractPayment?: boolean | undefined;
    BudgetPayment?: boolean | undefined;
    FromReceipts?: boolean | undefined;
    FromSales?: boolean | undefined;
    IsAutoPay?: boolean | undefined;
    IsWebPayment?: boolean | undefined;
    IsProcessImmediatelyPayment?: boolean | undefined;
    Failed?: boolean | undefined;
    IsProcessed?: boolean | undefined;
    ConvenienceFee?: number | undefined;
    ConvenienceFeeDescription?: string | undefined;
    ConvenienceFeeTax?: number | undefined;
    RunCode?: number | undefined;
    AccountNumber?: number | undefined;
    AuthCode?: string | undefined;
    RefNo?: string | undefined;
    RespMsg?: string | undefined;
    ErrorMsg?: string | undefined;
    RecNo?: number | undefined;
    AutoPayRecNo?: number | undefined;
    CreationDateTime?: Date | undefined;
    Successful?: boolean | undefined;
    RccVersion?: string | undefined;
    ComputerName?: string | undefined;
    IpAddress?: string | undefined;
    CheckType?: number | undefined;
    TraceNumber?: number | undefined;
    ProcessedThrough?: string | undefined;
    ProcessDate?: Date | undefined;
    RowState?: APSPaymentRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebCompany
{
    ShowDelivery?: boolean | undefined;
    ShowService?: boolean | undefined;
    ApsProcessor?: number | undefined;
    Name?: string | undefined;
    Phone?: string | undefined;
    Address?: string | undefined;
    WebEmail?: string | undefined;
    DisplayEmail?: string | undefined;
    CorpEmail?: string | undefined;
    Version?: string | undefined;
    VersionInt?: number | undefined;
    UseNewEmailMethod?: boolean | undefined;
    WebDisplayCompanyName?: boolean | undefined;
    WebDisplayTransactions?: boolean | undefined;
    WebDisplayEquipment?: boolean | undefined;
    WebApsSignUpAvailable?: boolean | undefined;
    BranchNo?: number | undefined;
}

export interface APSResponse
{
    APSAvailable?: boolean | undefined;
    APSMessage?: string | undefined;
    APSCompany?: APSCompany | undefined;
    Successful?: boolean | undefined;
    UpdatePayMethod?: boolean | undefined;
    ResponseMsg?: string | undefined;
    ReferenceNumber?: string | undefined;
    RecNo?: number | undefined;
    AutoPayRecNo?: number | undefined;
    ErrorMessage?: string | undefined;
    APSMaster?: APSMaster | undefined;
    APSAutoPay?: APSAutoPay | undefined;
    APSPayment?: APSPayment | undefined;
    APSProcessorInfo?: APSProcessorInfo | undefined;
    APSAutoPayList?: APSAutoPayList[] | undefined;
    APSAutoPays?: APSAutoPay[] | undefined;
    PayMethods?: APSType[] | undefined;
    CardType?: APSType[] | undefined;
    CardTypeAlls?: APSType[] | undefined;
    BankType?: APSType[] | undefined;
    APSMasterList?: APSMaster[] | undefined;
    ConvenienceFeeDescription?: string | undefined;
    ConvenienceFeeAmount?: number | undefined;
    ConvenienceFeeTaxAmount?: number | undefined;
    ResponseStatus?: ResponseStatus | undefined;
}

export interface APSCompany
{
    CpayRecNo?: number | undefined;
    CmstRecNo?: number | undefined;
    CachRecNo?: number | undefined;
    TestServer?: boolean | undefined;
    CompanyName?: string | undefined;
    RowState?: APSCompanyRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface APSAutoPay
{
    RunCode?: number | undefined;
    RecNo?: number | undefined;
    CreateUser?: string | undefined;
    CreateComputer?: string | undefined;
    CreateDatetime?: Date | undefined;
    CreateIpaddr?: string | undefined;
    UpdateUser?: string | undefined;
    UpdateComputer?: string | undefined;
    UpdateDatetime?: Date | undefined;
    UpdateIpaddr?: string | undefined;
    Processed?: boolean | undefined;
    Failed?: boolean | undefined;
    Appl?: string | undefined;
    SourceNo?: number | undefined;
    KeepInfo?: boolean | undefined;
    PymtMethod?: string | undefined;
    InvoiceNo?: string | undefined;
    DueDate?: Date | undefined;
    ApplId?: string | undefined;
    Trans?: string | undefined;
    Amt1?: number | undefined;
    Amt2?: number | undefined;
    Amt3?: number | undefined;
    Amt4?: number | undefined;
    Amt5?: number | undefined;
    Amt6?: number | undefined;
    Amt7?: number | undefined;
    Amt8?: number | undefined;
    Amt9?: number | undefined;
    DiscDt?: Date | undefined;
    DiscAmt?: number | undefined;
    FeeAmt?: number | undefined;
    TotalCharged?: number | undefined;
    ProcessedImmed?: boolean | undefined;
    ForceManual?: boolean | undefined;
    EffDt?: Date | undefined;
    ProcessUser?: string | undefined;
    ProcessComputer?: string | undefined;
    ProcessDatetime?: Date | undefined;
    ProcessedThru?: string | undefined;
    Result?: number | undefined;
    RefNo?: string | undefined;
    AuthCode?: string | undefined;
    RespMsg?: string | undefined;
    Msg1?: string | undefined;
    Msg2?: string | undefined;
    Msg3?: string | undefined;
    SettleDt?: Date | undefined;
    FromReceipts?: boolean | undefined;
    FromSales?: boolean | undefined;
    FromAutopay?: boolean | undefined;
    Contract?: boolean | undefined;
    Budget?: boolean | undefined;
    NonBudget?: boolean | undefined;
    TranType?: string | undefined;
    TranDate?: Date | undefined;
    TranInvcNo?: string | undefined;
    HoldReturn?: boolean | undefined;
    CheckNo?: string | undefined;
    OrigPymtMethod?: string | undefined;
    NsfReturn?: boolean | undefined;
    HoldUntilPosted?: boolean | undefined;
    WebPymt?: boolean | undefined;
    WrkProcessTran?: number | undefined;
    HoldRecover?: number | undefined;
    BranchNo?: string | undefined;
    PymtMethodString?: string | undefined;
    Name?: string | undefined;
    Last4?: number | undefined;
    CreditCardType?: string | undefined;
    ConvenienceFee?: number | undefined;
    RowState?: APSAutoPayRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface APSProcessorInfo
{
    PaymentType?: string | undefined;
    CardType?: string | undefined;
    Processor?: number | undefined;
    Login?: string | undefined;
    Password?: string | undefined;
    Key?: string | undefined;
    Extra?: string | undefined;
    TerminalId?: string | undefined;
    RunCode?: number | undefined;
    BranchNo?: string | undefined;
    ErrorCode?: number | undefined;
    ErrorMessage?: string | undefined;
    RowState?: APSProcessorInfoRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface APSAutoPayList
{
    DueDt?: Date | undefined;
    TotalDue?: number | undefined;
    CardExprDt?: number | undefined;
    CardType?: string | undefined;
    BankNo4?: number | undefined;
    BankAcct4?: string | undefined;
    RunCode?: number | undefined;
    RecNo?: number | undefined;
    CreateUser?: string | undefined;
    CreateComputer?: string | undefined;
    CreateDatetime?: Date | undefined;
    CreateIpaddr?: string | undefined;
    UpdateUser?: string | undefined;
    UpdateComputer?: string | undefined;
    UpdateDatetime?: Date | undefined;
    UpdateIpaddr?: string | undefined;
    Processed?: boolean | undefined;
    Failed?: boolean | undefined;
    Appl?: string | undefined;
    SourceNo?: number | undefined;
    KeepInfo?: boolean | undefined;
    PymtMethod?: string | undefined;
    InvoiceNo?: string | undefined;
    DueDate?: Date | undefined;
    ApplId?: string | undefined;
    Trans?: string | undefined;
    Amt1?: number | undefined;
    Amt2?: number | undefined;
    Amt3?: number | undefined;
    Amt4?: number | undefined;
    Amt5?: number | undefined;
    Amt6?: number | undefined;
    Amt7?: number | undefined;
    Amt8?: number | undefined;
    Amt9?: number | undefined;
    DiscDt?: Date | undefined;
    DiscAmt?: number | undefined;
    FeeAmt?: number | undefined;
    TotalCharged?: number | undefined;
    ProcessedImmed?: boolean | undefined;
    ForceManual?: boolean | undefined;
    EffDt?: Date | undefined;
    ProcessUser?: string | undefined;
    ProcessComputer?: string | undefined;
    ProcessDatetime?: Date | undefined;
    ProcessedThru?: string | undefined;
    Result?: number | undefined;
    RefNo?: string | undefined;
    AuthCode?: string | undefined;
    RespMsg?: string | undefined;
    Msg1?: string | undefined;
    Msg2?: string | undefined;
    Msg3?: string | undefined;
    SettleDt?: Date | undefined;
    FromReceipts?: boolean | undefined;
    FromSales?: boolean | undefined;
    FromAutopay?: boolean | undefined;
    Contract?: boolean | undefined;
    Budget?: boolean | undefined;
    NonBudget?: boolean | undefined;
    TranType?: string | undefined;
    TranDate?: Date | undefined;
    TranInvcNo?: string | undefined;
    HoldReturn?: boolean | undefined;
    CheckNo?: string | undefined;
    OrigPymtMethod?: string | undefined;
    NsfReturn?: boolean | undefined;
    HoldUntilPosted?: boolean | undefined;
    WebPymt?: boolean | undefined;
    WrkProcessTran?: number | undefined;
    HoldRecover?: number | undefined;
    BranchNo?: string | undefined;
    PymtMethodString?: string | undefined;
    Name?: string | undefined;
    Last4?: number | undefined;
    CreditCardType?: string | undefined;
    ConvenienceFee?: number | undefined;
    RowState?: APSAutoPayListRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface APSType
{
    Type?: string | undefined;
    Description?: string | undefined;
    RowState?: APSTypeRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface ResponseStatus
{
    ErrorCode?: string | undefined;
    Message?: string | undefined;
    StackTrace?: string | undefined;
    Errors?: string[] | undefined;
    Title?: string | undefined;
}

export interface GeneralResponse
{
    Result?: boolean | undefined;
    StringValue?: string | undefined;
    DecimalValue?: number | undefined;
    ListOfStrings?: string[] | undefined;
    DateTimeValue?: Date | undefined;
    IntegerValue?: number | undefined;
    InterfaceSettings?: InterfaceSettings | undefined;
    DictionaryValues?: { [key: string]: boolean; } | undefined;
    ResponseStatus?: ResponseStatus | undefined;
}

export interface InterfaceSettings
{
    QBOnlineIsActive?: boolean | undefined;
    QBDesktopSettings?: QBDesktopSettings | undefined;
    AgTraxSettings?: AgTraxSettings | undefined;
    Sage50CloudSettings?: Sage50CloudSettings | undefined;
    Sage50DesktopSettings?: Sage50DesktopSettings | undefined;
    HighRadiusSettings?: HighRadiusSettings | undefined;
    SalesforceSettings?: SalesforceSettings | undefined;
    DefaultSettings?: InterfaceDefaultsSettings | undefined;
    PowerBISettings?: InterfacePowerBISettings | undefined;
    ExportGLEntriesSettings?: InterfaceExportGLEntriesSettings | undefined;
    SageIntacctSettings?: SageIntacctSettings | undefined;
    P3PropaneSettings?: P3PropaneSettings | undefined;
    CavagnaSettings?: CavagnaSettings | undefined;
}

export interface QBDesktopSettings
{
    IsActive?: boolean | undefined;
    QBFilePath?: string | undefined;
}

export interface AgTraxSettings
{
    IsActive?: boolean | undefined;
    IsContractsActive?: boolean | undefined;
    UserId?: string | undefined;
    UserPassword?: string | undefined;
    ProviderId?: string | undefined;
    ProviderPassword?: string | undefined;
    AgTraxUrlAddress?: string | undefined;
    IsLocationInterfaceFieldActive?: boolean | undefined;
}

export interface Sage50CloudSettings
{
    IsActive?: boolean | undefined;
    BaseUrl?: string | undefined;
    RedirectUrl?: string | undefined;
    AccessToken?: string | undefined;
    AccessTokenExpiresOn?: Date | undefined;
    RefreshToken?: string | undefined;
    RefreshTokenExpiresOn?: Date | undefined;
    AppEnvironment?: string | undefined;
    RequestedById?: string | undefined;
}

export interface Sage50DesktopSettings
{
    IsActive?: boolean | undefined;
}

export interface HighRadiusSettings
{
    IsActive?: boolean | undefined;
    HighRadiusFolderPath?: string | undefined;
}

export interface SalesforceSettings
{
    IsActive?: boolean | undefined;
    CreatedOn?: Date | undefined;
    CreatedBy?: string | undefined;
    ModifiedOn?: Date | undefined;
    ModifiedBy?: string | undefined;
    RowState?: SalesforceSettingsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface InterfaceDefaultsSettings
{
    CustomerStartCode?: string | undefined;
    CorpId?: string | undefined;
    Branch?: string | undefined;
    TotalHeatCapacity?: number | undefined;
}

export interface InterfacePowerBISettings
{
    IsActive?: boolean | undefined;
    CustHubUrl?: string | undefined;
}

export interface InterfaceExportGLEntriesSettings
{
    IsActive?: boolean | undefined;
    ExportByDivision?: boolean | undefined;
    ExportGLFolderPath?: string | undefined;
}

export interface SageIntacctSettings
{
    IsActive?: boolean | undefined;
    UrlAddress?: string | undefined;
    CompanyId?: string | undefined;
    SenderId?: string | undefined;
    SenderPassword?: string | undefined;
    UserId?: string | undefined;
    UserPassword?: string | undefined;
    EntityId?: string | undefined;
    LocationId?: string | undefined;
    SageIntacctPartner?: SageIntacctSettingsSageIntacctPartner | undefined;
    LocationIdVisibility?: SageIntacctSettingsLocationIdVisibility | undefined;
    SendEmailWhenPostErrors?: boolean | undefined;
    SendErrorTo?: string | undefined;
}

export interface P3PropaneSettings
{
    IsActive?: boolean | undefined;
    BranchNo?: number | undefined;
    CompanyId?: string | undefined;
    UserName?: string | undefined;
    Password?: string | undefined;
    ServiceUrl?: string | undefined;
    ExternalUrl?: string | undefined;
    UseMultiBranchForP3?: boolean | undefined;
    UseRunCodeForP3?: boolean | undefined;
}

export interface CavagnaSettings
{
    IsActive?: boolean | undefined;
    Username?: string | undefined;
    Password?: string | undefined;
    CavagnaChargeOption?: CavagnaSettingsCavagnaChargeOption | undefined;
}

export interface ChaseResponse
{
    code?: string | undefined;
    message?: string | undefined;
    name?: string | undefined;
    mPAN?: string | undefined;
    type?: string | undefined;
    exp?: string | undefined;
    AVSMatch?: string | undefined;
    CVVMatch?: string | undefined;
    TxnGUID?: string | undefined;
    ApprovalCode?: string | undefined;
    transType?: string | undefined;
    profileProcStatus?: string | undefined;
    profileProcStatusMsg?: string | undefined;
    customerRefNum?: string | undefined;
    Verbose_Request?: string | undefined;
    hostedSecureID?: string | undefined;
    hostedSecureAPIToken?: string | undefined;
    collectAddress?: string | undefined;
    required?: string | undefined;
    account_verification?: string | undefined;
    trans_type?: string | undefined;
    hosted_tokenize?: string | undefined;
    payment_type?: string | undefined;
    allowed_types?: string | undefined;
    customer_address?: string | undefined;
    customer_city?: string | undefined;
    customer_state?: string | undefined;
    customer_postal_code?: string | undefined;
    customer_country?: string | undefined;
    uIDTrans?: string | undefined;
    uID?: string | undefined;
    order_id?: string | undefined;
    total_amt?: number | undefined;
    ip_address?: string | undefined;
    user_agent?: string | undefined;
    CRE_Tokenize?: string | undefined;
    customer_lastname?: string | undefined;
    customer_firstname?: string | undefined;
}

export interface OneTimePaymentResponse
{
    AmountPaid?: number | undefined;
    PaymentAccountType?: string | undefined;
    RefNumber?: string | undefined;
}

export interface PaymentReceiptItem
{
    PaymentResponseList?: OneTimePaymentResponse[] | undefined;
    PaymentRequest?: OneTimePaymentRequest | undefined;
}

export interface AddAPSRequestOfCreditCardInfo
{
    Item?: CreditCardInfo | undefined;
    CustId?: string | undefined;
    BranchNo?: string | undefined;
    SourceNo?: number | undefined;
}

export interface CreditCardInfo
{
    Primary?: boolean | undefined;
    Type?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    NameOnCard?: string | undefined;
    Number?: string | undefined;
    ExpirationMonth?: number | undefined;
    ExpirationYear?: number | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    CountryCode?: string | undefined;
    Zip?: string | undefined;
    RunCode?: number | undefined;
    AccountNumber?: string | undefined;
}

export interface RemoveAPSItemRequest
{
    RecNo?: number | undefined;
    SourceNo?: number | undefined;
    BranchNo?: string | undefined;
    CardType?: string | undefined;
    PymtMethod?: string | undefined;
    RefProfileId?: string | undefined;
    RefToken?: string | undefined;
}

export interface AddAPSRequestOfBankInfo
{
    Item?: BankInfo | undefined;
    CustId?: string | undefined;
    BranchNo?: string | undefined;
    SourceNo?: number | undefined;
}

export interface BankInfo
{
    Primary?: boolean | undefined;
    CompanyName?: string | undefined;
    NameFirst?: string | undefined;
    NameLast?: string | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    CountryCode?: string | undefined;
    Zip?: string | undefined;
    RoutingNumber?: string | undefined;
    AccountType?: string | undefined;
    AccountNumber?: string | undefined;
    Business?: boolean | undefined;
    BankName?: string | undefined;
    RunCode?: number | undefined;
}

export interface AutoPaySettings
{
    AutoPaySettingsId?: number | undefined;
    DataLogical?: string | undefined;
    BranchNo?: string | undefined;
    IsAutoPayActive?: boolean | undefined;
    DefaultExcludeBalanceFrom?: number | undefined;
    DefaultExcludeBalanceThrough?: number | undefined;
    IsWarnUsersRunCodeActive?: boolean | undefined;
    BankAccountProcessorName?: AutoPaySettingsBankAccountProcessorName | undefined;
    CreditCardProcessorName?: AutoPaySettingsCreditCardProcessorName | undefined;
    PaymentTypes?: AutoPayPaymentTypeInfo[] | undefined;
    RowState?: AutoPaySettingsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface AutoPayPaymentTypeInfo
{
    IsAccepted?: boolean | undefined;
    PaymentType?: AutoPayPaymentTypeInfoPaymentType | undefined;
    ReadableExtraFeeType?: string | undefined;
    ExtraFeeOption?: AutoPayPaymentTypeInfoExtraFeeOption | undefined;
    AreExtraFeesEnabled?: boolean | undefined;
    ExtraFeeValueType?: AutoPayPaymentTypeInfoExtraFeeValueType | undefined;
    ExtraFeeAmount?: number | undefined;
    RowState?: AutoPayPaymentTypeInfoRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface AppStartup
{
    Valid?: boolean | undefined;
    Message?: string | undefined;
    Version?: string | undefined;
    CompanyInterfaces?: CompanyInterfaces | undefined;
    GeneralSettings?: GeneralSettings | undefined;
    DispatchManagerSettings?: DispatchManagerSettings | undefined;
    ModuleSettings?: ModuleSettings | undefined;
    UserSettings?: User | undefined;
    APSAvailable?: boolean | undefined;
    APSMessage?: string | undefined;
    APSCompany?: APSCompany | undefined;
    Successful?: boolean | undefined;
    UpdatePayMethod?: boolean | undefined;
    ResponseMsg?: string | undefined;
    ReferenceNumber?: string | undefined;
    RecNo?: number | undefined;
    ErrorMessage?: string | undefined;
    APSMaster?: APSMaster | undefined;
    APSAutoPay?: APSAutoPay | undefined;
    APSPayment?: APSPayment | undefined;
    APSProcessorInfo?: APSProcessorInfo | undefined;
    APSAutoPayList?: APSAutoPayList[] | undefined;
    APSAutoPays?: APSAutoPay[] | undefined;
    PayMethodsByBranch?: { [key: string]: APSType[]; } | undefined;
    CardTypeByBranch?: { [key: string]: APSType[]; } | undefined;
    CardTypeAllsByBranch?: { [key: string]: APSType[]; } | undefined;
    BankTypeByBranch?: { [key: string]: APSType[]; } | undefined;
    APSMasterList?: APSMaster[] | undefined;
    ConvenienceFeeDescription?: string | undefined;
    ConvenienceFeeAmount?: number | undefined;
    ConvenienceFeeTaxAmount?: number | undefined;
    Countries?: CountryMaster[] | undefined;
    CompanyBase?: CompanyBase | undefined;
    IsCorpIdJPENE?: boolean | undefined;
    IsCorpIdNotJPENE?: boolean | undefined;
    WebApiVersion?: string | undefined;
    LicensingServerBaseUrlAddress?: string | undefined;
    LicensingServerCredentials?: string | undefined;
    AvailableDownloads?: SelectionItem[] | undefined;
    IsForgotPasswordEnabled?: boolean | undefined;
}

export interface CompanyInterfaces
{
    IsFixedAssetsActive?: boolean | undefined;
    IsFixedAssetsInterfaced?: boolean | undefined;
    IsPayrollActive?: boolean | undefined;
    IsPayrollInterfaced?: boolean | undefined;
    IsAPSClassicActive?: boolean | undefined;
    IsInventoryActive?: boolean | undefined;
    IsFuelInventoryInterfaced?: boolean | undefined;
    IsGLActive?: boolean | undefined;
    IsFuelGLInterfaced?: boolean | undefined;
    IsAPActive?: boolean | undefined;
    IsFuelAPInterfaced?: boolean | undefined;
    IsReplicationActive?: boolean | undefined;
    IsPatronageActive?: boolean | undefined;
    IsBranchesActive?: boolean | undefined;
    IsCityFromZipUppercase?: boolean | undefined;
    IsArchiveAvailable?: boolean | undefined;
    IsECommerceActive?: boolean | undefined;
    IsWarehouseActive?: boolean | undefined;
    IsFifoInventory?: boolean | undefined;
    IsFuelSql?: boolean | undefined;
    IsInventorySql?: boolean | undefined;
    IsTrackFileOpenCloseActive?: boolean | undefined;
    IsWebActive?: boolean | undefined;
    IsApsActiveByBranch?: { [key: string]: boolean; } | undefined;
    IsACHSetupByBranch?: { [key: string]: boolean; } | undefined;
    IsConvenienceFeeActiveByBranch?: { [key: string]: boolean; } | undefined;
    IsConvenienceFeeActive?: boolean | undefined;
    IsContractLocationActiveByBranch?: { [key: string]: boolean; } | undefined;
    IsClusterRoutesActiveByBranch?: { [key: string]: boolean; } | undefined;
    IsSMSNotificationsActive?: boolean | undefined;
    IsSMTPNotificationsActive?: boolean | undefined;
}

export interface GeneralSettings
{
    RccDirectory?: string | undefined;
    DataFilePath?: string | undefined;
    TrackFileOpenClose?: boolean | undefined;
    SavePersistenceDataText?: boolean | undefined;
    OpenClassicWindowsInDebug?: boolean | undefined;
    PCMilerKey?: string | undefined;
    PCMilerBaseURL?: string | undefined;
    MapDistanceUnits?: boolean | undefined;
    BingMapKey?: string | undefined;
    WhatsRunningRefreshMinutes?: number | undefined;
    WhatsRunningFlushMinutes?: number | undefined;
    AllowRccDataCollection?: boolean | undefined;
    GenerateStatementsNewIsEnabled?: boolean | undefined;
    GenerateLeasesIsEnabled?: boolean | undefined;
    SalesPostNewIsEnabled?: boolean | undefined;
    CashReceiptsPostNewIsEnabled?: boolean | undefined;
    IsAddressValidateActive?: boolean | undefined;
    UspsConsumerKey?: string | undefined;
    UspsConsumerSecret?: string | undefined;
    SalesUploadNewIsEnabled?: boolean | undefined;
    MonthYearEndNewIsEnabled?: boolean | undefined;
    ProcessAutoPaymentsNewIsEnabled?: boolean | undefined;
    GlobalPriceCodeChangeNewIsEnabled?: boolean | undefined;
    MeterEntryIsEnabled?: boolean | undefined;
    IsTankMonitorLocationTypeEnabled?: boolean | undefined;
    GlobalLocationVarianceChangeIsEnabled?: boolean | undefined;
    CollectionsNewIsEnabled?: boolean | undefined;
    RowState?: GeneralSettingsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface DispatchManagerSettings
{
    IsPcMilerMappingEnabled?: boolean | undefined;
    IsDMMappingEnabled?: boolean | undefined;
    BingMapKey?: string | undefined;
    IsBingKeyPopulated?: boolean | undefined;
    RowState?: DispatchManagerSettingsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface ModuleSettings
{
    IsAPActive?: boolean | undefined;
    IsGLActive?: boolean | undefined;
    ActiveGLBranches?: BranchListItem[] | undefined;
    IsInventoryActive?: boolean | undefined;
    RowState?: ModuleSettingsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface User
{
    KeyUsrOrPrg?: string | undefined;
    KeyName?: string | undefined;
    Description?: string | undefined;
    PrntNo?: number | undefined;
    UserDefsPrnDedicated?: number | undefined;
    UserDefsForegroundColor?: number | undefined;
    UserDefsBackgroundColor?: number | undefined;
    UserDefsFieldColor?: number | undefined;
    UserDefsSystemColor?: number | undefined;
    UserDefsHiLiteColor?: number | undefined;
    UserDefsLanguage?: number | undefined;
    UserDefsInitMode?: number | undefined;
    UserDefsListMode?: string | undefined;
    UserDefsInitFunction?: number | undefined;
    UserDefsAdministrator?: number | undefined;
    UserDefsUserPassword?: string | undefined;
    UserDefsStartMenu?: string | undefined;
    UserDefsEmail?: string | undefined;
    UserDefsDisableListEdit?: number | undefined;
    UserDefsUserLevel?: number | undefined;
    UserDefsPasswordMode?: number | undefined;
    UserDefsFormsControl?: string | undefined;
    UserDefsBarColor?: number | undefined;
    UserDefsLtrColor?: number | undefined;
    UserDefsBarRed?: number | undefined;
    UserDefsBarGreen?: number | undefined;
    UserDefsBarBlue?: number | undefined;
    UserDefsLtrRed?: number | undefined;
    UserDefsLtrGreen?: number | undefined;
    UserDefsLtrBlue?: number | undefined;
    UserDefsWebLogins?: number | undefined;
    UserDefsWebAttempts?: number | undefined;
    UserDefsBranchFrom?: number | undefined;
    UserDefsBranchThru?: number | undefined;
    UserDefsUserBatchMode?: number | undefined;
    UserDefsWindowsLook?: number | undefined;
    UserDefsDymo?: number | undefined;
    UserDefsMappingAvailable?: number | undefined;
    RowState?: UserRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface CountryMaster
{
    CountryId?: number | undefined;
    Name?: string | undefined;
    ISOAbbreviation2?: string | undefined;
    ISOAbbreviation3?: string | undefined;
    CountryCode?: number | undefined;
    PhoneDigits?: number | undefined;
    PhoneFormat?: string | undefined;
    SortOrder?: number | undefined;
    IsActive?: boolean | undefined;
    CreatedOn?: Date | undefined;
    CreatedBy?: string | undefined;
    ModifiedOn?: Date | undefined;
    ModifiedBy?: string | undefined;
    StatesProvinces?: StateProvinceMaster[] | undefined;
    RowState?: CountryMasterRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface CompanyBase
{
    CorpId?: string | undefined;
    Name?: string | undefined;
    Phone?: string | undefined;
    Address1?: string | undefined;
    Address2?: string | undefined;
    Address3?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    Zip?: string | undefined;
    RunCode?: number | undefined;
    GpsLat?: number | undefined;
    GpsLong?: number | undefined;
    GpsLatNS?: string | undefined;
    GpsLongEW?: string | undefined;
    DecimalGpsLat?: number | undefined;
    DecimalGpsLon?: number | undefined;
    BranchNo?: number | undefined;
    RowState?: CompanyBaseRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface SelectionItem
{
    Msg?: string | undefined;
    Msg2?: string | undefined;
    MsgVal?: string | undefined;
    MsgValNum?: number | undefined;
    IsItemEnabled?: boolean | undefined;
    RowState?: SelectionItemRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface BranchListItem
{
    Id?: string | undefined;
    IsSelected?: boolean | undefined;
    Region?: string | undefined;
    Name?: string | undefined;
    BranchDirectory?: string | undefined;
    GLDivision?: string | undefined;
    RowState?: BranchListItemRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface StateProvinceMaster
{
    StateProvinceId?: number | undefined;
    CountryId?: number | undefined;
    CountryName?: string | undefined;
    CountryIsActive?: boolean | undefined;
    Name?: string | undefined;
    Abbreviation?: string | undefined;
    SortOrder?: number | undefined;
    IsActive?: boolean | undefined;
    CreatedOn?: Date | undefined;
    CreatedBy?: string | undefined;
    ModifiedOn?: Date | undefined;
    ModifiedBy?: string | undefined;
    RowState?: StateProvinceMasterRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface Contract
{
    ActFlag?: string | undefined;
    ActiveInactive?: string | undefined;
    Category?: string | undefined;
    DepMode?: string | undefined;
    DepRemain?: number | undefined;
    DepTotal?: number | undefined;
    IgnoreTerms?: number | undefined;
    AllowExtraChg?: number | undefined;
    PSCat?: string | undefined;
    PSGLAcct?: string | undefined;
    ApplyRate?: number | undefined;
    Active?: boolean | undefined;
    Record?: string | undefined;
    Type?: string | undefined;
    DepCat?: string | undefined;
    DepGL?: string | undefined;
    MinPrice?: number | undefined;
    MaxPrice?: number | undefined;
    MinQty?: number | undefined;
    MaxQty?: number | undefined;
    HasLocations?: boolean | undefined;
    Locations?: number[] | undefined;
    MultiLocationsDisplay?: string | undefined;
    MultiLocationsDisplayTooltip?: string | undefined;
    OriginalRecord?: string | undefined;
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    CustID?: string | undefined;
    Loc?: number | undefined;
    ContractNo?: string | undefined;
    CompDate?: Date | undefined;
    EffDate?: Date | undefined;
    PriceCon?: number | undefined;
    UnitsCon?: number | undefined;
    UnitsRemain?: number | undefined;
    UnitsUsed?: number | undefined;
    PriceDisplay?: number | undefined;
    ConBal?: number | undefined;
    PriceCode?: number | undefined;
    RowState?: ContractRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebContract
{
    CustID?: string | undefined;
    BranchCustIdKey?: string | undefined;
    ContractNo?: string | undefined;
    EffDate?: Date | undefined;
    CompDate?: Date | undefined;
    PriceCon?: number | undefined;
    ConBal?: number | undefined;
    UnitsCon?: number | undefined;
    UnitsRemain?: number | undefined;
    UnitsUsed?: number | undefined;
    Loc?: number | undefined;
    Active?: boolean | undefined;
    PriceDisplay?: number | undefined;
}

export interface ContractWeb
{
    LocationAddress?: string | undefined;
    Active?: boolean | undefined;
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    CustID?: string | undefined;
    Loc?: number | undefined;
    ContractNo?: string | undefined;
    CompDate?: Date | undefined;
    EffDate?: Date | undefined;
    PriceCon?: number | undefined;
    UnitsCon?: number | undefined;
    UnitsRemain?: number | undefined;
    UnitsUsed?: number | undefined;
    PriceDisplay?: number | undefined;
    ConBal?: number | undefined;
    PriceCode?: number | undefined;
    RowState?: ContractWebRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface ContractLetter
{
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    BranchCustId?: string | undefined;
    AccountNumber?: number | undefined;
    RunCode?: number | undefined;
    CommercialOrResidential?: string | undefined;
    Category?: string | undefined;
    Location?: number | undefined;
    HistoryGallons?: number | undefined;
    DeliveryType?: string | undefined;
    CurrentBalance?: number | undefined;
    TruckCharge?: number | undefined;
    FullPrebuyGallons?: number | undefined;
    FullPrebuyCashPrice?: number | undefined;
    FullPrebuyCreditPrice?: number | undefined;
    FullPrebuyCashAmountDue?: number | undefined;
    FullPrebuyCreditAmountDue?: number | undefined;
    InstallPrebuyGallons?: number | undefined;
    InstallPrebuyCashPrice?: number | undefined;
    InstallPrebuyCreditPrice?: number | undefined;
    InstallPrebuyCashAmountDue?: number | undefined;
    InstallPrebuyCreditAmtDue?: number | undefined;
    InstallPrebuyCashPymt1?: number | undefined;
    InstallPrebuyCashPymt2?: number | undefined;
    InstallPrebuyCashPymt3?: number | undefined;
    InstallPrebuyCreditPymt1?: number | undefined;
    InstallPrebuyCreditPymt2?: number | undefined;
    InstallPrebuyCreditPymt3?: number | undefined;
    LockedGallons?: number | undefined;
    LockedPrice?: number | undefined;
    LockedAmtInvcPrice?: number | undefined;
    LockedAmtDown?: number | undefined;
    LockedEstimatedTotal?: number | undefined;
    BudgetGallons?: number | undefined;
    BudgetPrice?: number | undefined;
    BudgetCapPrice?: number | undefined;
    BudgetMonthlyPayment?: number | undefined;
    BudgetEstimatedTotal?: number | undefined;
    FullPrebuyType?: string | undefined;
    InstallPrebuyType?: string | undefined;
    LockedType?: string | undefined;
    BudgetType?: string | undefined;
    LocationCapacity?: number | undefined;
    LocationAddress?: string | undefined;
    RowState?: ContractLetterRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebContractLetter
{
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    BranchCustId?: string | undefined;
    AccountNumber?: number | undefined;
    Location?: number | undefined;
    LocationCapacity?: number | undefined;
    FullPrebuyGallons?: number | undefined;
    FullPrebuyCashPrice?: number | undefined;
    IsAvailable?: boolean | undefined;
    LocationAddress?: string | undefined;
}

export interface WebContractAgreement
{
    Contracts?: ContractLetter[] | undefined;
    CustomerEmail?: string | undefined;
    CustomerName?: string | undefined;
    Company?: WebCompany | undefined;
}

export interface ContractLetterResponse
{
    HasMoreRecords?: boolean | undefined;
    Items?: ContractLetter[] | undefined;
    Item?: ContractLetter | undefined;
    SelectionItems?: SelectionItem[] | undefined;
    Successful?: boolean | undefined;
    ResponseMsg?: string | undefined;
    ErrorMessage?: string | undefined;
    ResponseStatus?: ResponseStatus | undefined;
}

export interface WebCustomer
{
    CustId?: string | undefined;
    BranchCustId?: string | undefined;
    Name?: string | undefined;
    AcctNo?: number | undefined;
    CreditLimit?: number | undefined;
    Addr1?: string | undefined;
    Addr2?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    Zip?: string | undefined;
    ApsSourceNo?: number | undefined;
    BranchNo?: string | undefined;
    IsActiveVisibility?: boolean | undefined;
    AcctStatSameAsCod?: boolean | undefined;
    AcctStatSameAsLegal?: boolean | undefined;
    AcctStatDesc?: string | undefined;
    AcctStatColor?: string | undefined;
    AcctStatVisibility?: boolean | undefined;
    AcctStat?: number | undefined;
    AutoPayForceDay?: number | undefined;
    PayMethod?: string | undefined;
    IsCustomerEnrolledInAutoPay?: boolean | undefined;
    CommercialCust?: number | undefined;
    RunCode?: number | undefined;
    BudBal?: number | undefined;
    ContractBal?: number | undefined;
    ContractBudget?: number | undefined;
    LastSalesDate?: Date | undefined;
    LastPymtDate?: Date | undefined;
    TempWebPassword?: number | undefined;
    WebLockoutDateTime?: Date | undefined;
    WebFailedLoginAttempts?: number | undefined;
    Password?: string | undefined;
    Contacts?: WebCustomerContact[] | undefined;
    StartDate?: Date | undefined;
    UnpaidFc?: number | undefined;
    NewFc?: number | undefined;
    IsBudget?: boolean | undefined;
    NonBudBal?: number | undefined;
    AcctStatAllowTicketOrSwo?: boolean | undefined;
}

export interface WebCustomerContact
{
    Name?: string | undefined;
    Phone?: string | undefined;
    Email?: string | undefined;
}

export interface AdvancedSearchOptions
{
    CustomerCustId?: boolean | undefined;
    CustomerCustIdStartsWith?: boolean | undefined;
    CustomerAccountNo?: boolean | undefined;
    CustomerName?: boolean | undefined;
    CustomerAddress?: boolean | undefined;
    CustomerPhone?: boolean | undefined;
    CustomerEmail?: boolean | undefined;
    LocName?: boolean | undefined;
    LocAddress?: boolean | undefined;
    EquipmentId?: boolean | undefined;
    PaymentAmount?: boolean | undefined;
    CheckNumber?: boolean | undefined;
    ReferenceNumber?: boolean | undefined;
    IncludeInactive?: boolean | undefined;
    IncludeTempCustomers?: boolean | undefined;
    SelectedCategory?: AdvancedSearchOptionsSelectedCategory | undefined;
    SelectedSortBy?: AdvancedSearchOptionsSelectedSortBy | undefined;
    BranchNo?: string | undefined;
    LocationNo?: number | undefined;
    IncludeObsoleteEquipment?: boolean | undefined;
    BranchesToSearch?: BranchListItem[] | undefined;
    CustIdSearchString?: string | undefined;
    AccountNoSearchString?: string | undefined;
    NameSearchString?: string | undefined;
    AddressSearchString?: string | undefined;
    CommentSearchString?: string | undefined;
    EmailSearchString?: string | undefined;
    EntireRecordSearchString?: string | undefined;
    PhoneSearchString?: string | undefined;
    LocNameSearchString?: string | undefined;
    LocAddressSearchString?: string | undefined;
    LocPhoneSearchString?: string | undefined;
    LocEntireRecordSearchString?: string | undefined;
    EmployeeUsername?: string | undefined;
    SearchFor?: string | undefined;
    IsInitialized?: boolean | undefined;
    RowState?: AdvancedSearchOptionsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebCustomerComment
{
    CustomerComment1?: string | undefined;
    CustomerComment2?: string | undefined;
    CustomerHasComment?: boolean | undefined;
    CustomerCommentDate?: Date | undefined;
}

export interface ContactWeb
{
    Seq?: number | undefined;
    Key?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    PhoneDesc?: string | undefined;
    PhoneCountryCode?: number | undefined;
    PhoneNumber?: number | undefined;
    PhoneExt?: number | undefined;
    Type?: string | undefined;
    Email?: string | undefined;
    ApplCode?: string | undefined;
    AllowEmailMsg?: boolean | undefined;
    AllowPhoneTextMsg?: boolean | undefined;
    NotificationOptions?: string | undefined;
    DefaultInvoice?: boolean | undefined;
    DefaultStatements?: boolean | undefined;
    DefaultLetters?: boolean | undefined;
}

export interface Contact
{
    Type?: string | undefined;
    TypeDescription?: string | undefined;
    PhoneFullDescription?: string | undefined;
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    Name?: string | undefined;
    Phone?: string | undefined;
    PhoneType?: ContactPhoneType | undefined;
    PhoneDescription?: string | undefined;
    PhoneCountryCode?: number | undefined;
    Email?: string | undefined;
    Detail?: string | undefined;
    DefaultInvoice?: boolean | undefined;
    DefaultStatements?: boolean | undefined;
    DefaultLetters?: boolean | undefined;
    EmailOptions?: string | undefined;
    ApplCode?: string | undefined;
    ApplCodeDescription?: string | undefined;
    Key?: string | undefined;
    CustId?: string | undefined;
    Loc?: number | undefined;
    VendorId?: string | undefined;
    Seq?: number | undefined;
    NewSeq?: number | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    PhoneNumber?: number | undefined;
    PhoneExt?: number | undefined;
    PhoneDesc?: string | undefined;
    RepliedStop?: boolean | undefined;
    UnreadSmsMessages?: number | undefined;
    SmsMessages?: CommunicationResultItem[] | undefined;
    EmailInvc?: number | undefined;
    EmailStmt?: number | undefined;
    EmailLtr?: number | undefined;
    ApplCodeDesc?: string | undefined;
    Record?: string | undefined;
    PhoneTypeInt?: number | undefined;
    AllowPhoneTextMsg?: boolean | undefined;
    AllowEmailMsg?: boolean | undefined;
    LastTimeMessagedDateTime?: string | undefined;
    NotificationOptions?: string | undefined;
    RowState?: ContactRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface CommunicationResultItem
{
    Id?: number | undefined;
    CommunicationType?: string | undefined;
    DataLogical?: string | undefined;
    IsSuccessful?: boolean | undefined;
    IsEmail?: boolean | undefined;
    IsSMS?: boolean | undefined;
    CustomerId?: string | undefined;
    CustomerName?: string | undefined;
    RunCode?: number | undefined;
    Branch?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    LocationNo?: number | undefined;
    ContactType?: string | undefined;
    TypeDescription?: string | undefined;
    Email?: string | undefined;
    Phone?: string | undefined;
    EmailSubject?: string | undefined;
    EmailMessage?: string | undefined;
    EmailHtmlMessage?: string | undefined;
    SMSMessage?: string | undefined;
    Attachments?: ByteAttachment[] | undefined;
    IsEmailChecked?: boolean | undefined;
    IsEmailEnabled?: boolean | undefined;
    IsEmailValid?: boolean | undefined;
    IsPhoneChecked?: boolean | undefined;
    IsPhoneEnabled?: boolean | undefined;
    FailedMessageFixed?: boolean | undefined;
    StatusDescription?: string | undefined;
    CommunicationTypeDescription?: string | undefined;
    InboundMessage?: boolean | undefined;
    ReadStatus?: boolean | undefined;
    LastReadMessage?: string | undefined;
    StartNotifications?: boolean | undefined;
    StartNotificationsWatermark?: boolean | undefined;
    StopNotifications?: boolean | undefined;
    StopNotificationsWatermark?: boolean | undefined;
    RefreshAllUsersMessages?: boolean | undefined;
    Twilio_SMSStatus?: string | undefined;
    Twilio_DateSent?: Date | undefined;
    Twilio_DateUpdated?: Date | undefined;
    Twilio_DateCreated?: Date | undefined;
    Twilio_Body?: string | undefined;
    Twilio_ApiVersion?: string | undefined;
    Twilio_AccountSid?: string | undefined;
    Twilio_ErrorMessage?: string | undefined;
    Twilio_From?: string | undefined;
    Twilio_MessagingServiceSid?: string | undefined;
    Twilio_NumMedia?: string | undefined;
    Twilio_NumSegments?: string | undefined;
    Twilio_Price?: number | undefined;
    Twilio_PriceUnit?: string | undefined;
    Twilio_Sid?: string | undefined;
    Twilio_ErrorCode?: number | undefined;
    Twilio_SubresourceUris?: string | undefined;
    Twilio_To?: string | undefined;
    Twilio_Uri?: string | undefined;
    Twilio_Direction?: string | undefined;
    ExMessage?: string | undefined;
    ExStackTrace?: string | undefined;
    ExErrorsListStr?: string | undefined;
    FirstViewedBy?: string | undefined;
    CreatedOn?: Date | undefined;
    CreatedBy?: string | undefined;
    RowState?: CommunicationResultItemRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface ByteAttachment
{
    Name?: string | undefined;
    Data?: string | undefined;
}

export interface CustomerAgingVariables
{
    CurrBucket?: number | undefined;
    Over30Bucket?: number | undefined;
    Over60Bucket?: number | undefined;
    Over90Bucket?: number | undefined;
    Over120Bucket?: number | undefined;
    Over30BucketDescription?: string | undefined;
    Over60BucketDescription?: string | undefined;
    Over90BucketDescription?: string | undefined;
    Over120BucketDescription?: string | undefined;
    Pending?: number | undefined;
    PendingAmount?: number | undefined;
    PendingAmountNB?: number | undefined;
    InvcPending?: number | undefined;
    BankPending?: number | undefined;
    FinChrg?: number | undefined;
    AgingDiscDate?: string | undefined;
    AgeCredits?: string | undefined;
    StmtMode?: number | undefined;
    PendingTF?: number | undefined;
    IncludeBank?: number | undefined;
    PendingApply?: number | undefined;
    ContractBal?: number | undefined;
    RegularBal?: number | undefined;
    DiscAvail?: number | undefined;
    GetTotBal?: number | undefined;
    TotRegBal?: number | undefined;
    TotConBal?: number | undefined;
    BalDue?: number | undefined;
    BalDueWithDisc?: number | undefined;
    BalDueWithoutHeldAmount?: number | undefined;
    ActualBal?: number | undefined;
    BudgetBal?: number | undefined;
    BudgetCurrent?: number | undefined;
    BudgetOver30?: number | undefined;
    BudgetOver60?: number | undefined;
    BudgetOver90?: number | undefined;
    BudgetOver120?: number | undefined;
    CreditAvailable?: number | undefined;
    ContractCreditAvailable?: number | undefined;
    PendingContractAmount?: number | undefined;
    IsFcInCurrent?: boolean | undefined;
    IsAllStatementSkip?: boolean | undefined;
    Transactions?: AgedTrialBalanceTransaction[] | undefined;
    HeldAmountBucket?: number | undefined;
    BranchCustId?: string | undefined;
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    Name?: string | undefined;
    AcctNo?: number | undefined;
    Addr1?: string | undefined;
    OriginalRecord?: string | undefined;
    Addr1Visibility?: CustomerAgingVariablesAddr1Visibility | undefined;
    Addr2?: string | undefined;
    Addr2Visibility?: CustomerAgingVariablesAddr2Visibility | undefined;
    FullAddress?: string | undefined;
    CityStateZip?: string | undefined;
    City?: string | undefined;
    State?: string | undefined;
    Zip?: string | undefined;
    CountryCode?: string | undefined;
    RunCode?: number | undefined;
    AcctType?: number | undefined;
    AcctTypeDescription?: string | undefined;
    CommercialCust?: number | undefined;
    RowState?: CustomerAgingVariablesRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface AgedTrialBalanceTransaction
{
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    InvoiceNo?: string | undefined;
    RecType?: number | undefined;
    RecId?: number | undefined;
    InvoiceDate?: Date | undefined;
    DiscountDate?: Date | undefined;
    Amount?: number | undefined;
    CurrBucket?: number | undefined;
    FinChrgAmount?: number | undefined;
    Over30Bucket?: number | undefined;
    Over60Bucket?: number | undefined;
    Over90Bucket?: number | undefined;
    Over120Bucket?: number | undefined;
    ContractBal?: number | undefined;
    NonContractBal?: number | undefined;
    ContractCreditAvailable?: number | undefined;
    Contract?: number | undefined;
    NonBudget?: boolean | undefined;
    RowState?: AgedTrialBalanceTransactionRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface History
{
    TrxDate?: Date | undefined;
    Type?: string | undefined;
    Date?: Date | undefined;
    BCSeq?: string | undefined;
    BC?: string | undefined;
    Seq?: number | undefined;
    Budget?: string | undefined;
    Category?: string | undefined;
    SlType?: string | undefined;
    CheckNo?: string | undefined;
    Contract?: string | undefined;
    ContractNo?: string | undefined;
    IsContractDeposit?: boolean | undefined;
    Deposit?: string | undefined;
    GlAcct?: string | undefined;
    Install?: string | undefined;
    InventoryNo?: string | undefined;
    OrigRefNo?: string | undefined;
    IsOrigRefNoDifferentFromRefNo?: boolean | undefined;
    InvWarehouse?: number | undefined;
    Qty?: number | undefined;
    SaleType?: string | undefined;
    SalespsnNo?: number | undefined;
    TaxClass?: string | undefined;
    TaxGroup?: string | undefined;
    TaxType?: string | undefined;
    CostTotal?: number | undefined;
    PriceTotal?: number | undefined;
    Truck?: number | undefined;
    OrigInvcDate?: Date | undefined;
    InvoiceTime?: string | undefined;
    CreatedTime?: string | undefined;
    CreatedDate?: Date | undefined;
    User?: string | undefined;
    Desc?: string | undefined;
    Units?: string | undefined;
    QtyInventory?: number | undefined;
    Warehouse?: string | undefined;
    DaysElapsed?: number | undefined;
    DdElapsed?: number | undefined;
    DdRegion?: number | undefined;
    DdType?: string | undefined;
    DtlSlsNo?: number | undefined;
    EstPctAtFill?: number | undefined;
    DisregardDelivery?: number | undefined;
    BConstUse?: number | undefined;
    PctAtFill?: number | undefined;
    PerOfFill?: number | undefined;
    PdCode?: number | undefined;
    PrevPerFill?: number | undefined;
    QtyNotDd?: number | undefined;
    TotHeatCap?: number | undefined;
    SortCode?: string | undefined;
    CcType?: string | undefined;
    NonBudget?: number | undefined;
    NonBudgetDisplay?: string | undefined;
    PayMethod?: string | undefined;
    BegOdom?: number | undefined;
    EndOdom?: number | undefined;
    MtrRegion?: number | undefined;
    CustOrder?: string | undefined;
    VirtualUsage?: number | undefined;
    DepositBilled?: number | undefined;
    PatronYear?: number | undefined;
    PatronUsed?: number | undefined;
    PatronSaleRate?: number | undefined;
    PatronUnitRate?: number | undefined;
    FuelAssist?: number | undefined;
    RefNo?: string | undefined;
    Tran?: string | undefined;
    DelDate?: Date | undefined;
    PostDate?: Date | undefined;
    Delivery?: number | undefined;
    PostPd?: number | undefined;
    Loc?: number | undefined;
    UnitPrice?: number | undefined;
    PymtAmt?: number | undefined;
    SaleAmt?: number | undefined;
    Batch?: string | undefined;
    OrigBatchNum?: number | undefined;
    Note?: string | undefined;
    RunningBalance?: number | undefined;
    ContractLoc?: string | undefined;
    InvHasSerialNo?: boolean | undefined;
    DetailItemCount?: number | undefined;
    TransactionOrigin?: string | undefined;
    QtyBkord?: number | undefined;
    PatronOverride?: boolean | undefined;
    SwoDeleted?: boolean | undefined;
    DlvDeleted?: boolean | undefined;
    IsSms?: boolean | undefined;
    IsEmail?: boolean | undefined;
    IsCommunication?: boolean | undefined;
    LocEstimatedPercent?: number | undefined;
    LocEstimatedNextDelivery?: Date | undefined;
    LocDdCurrKFact?: number | undefined;
    LocBConstUse?: number | undefined;
    LocSummerConstUse?: number | undefined;
    LocQualityOfFit?: number | undefined;
    LocDelTicket?: string | undefined;
    HadMatchingForecastingHistory?: boolean | undefined;
    Record?: string | undefined;
    OriginalRecord?: string | undefined;
    IsExpanded?: boolean | undefined;
    EventDate?: Date | undefined;
    Description?: string | undefined;
    MyEventType?: HistoryMyEventType | undefined;
    Key?: string | undefined;
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    RowState?: HistoryRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebCustomerAgingVariables
{
    BalDueWithDisc?: number | undefined;
    CurrBucket?: number | undefined;
    Over30Bucket?: number | undefined;
    Over60Bucket?: number | undefined;
    Over90Bucket?: number | undefined;
    Over120Bucket?: number | undefined;
    Pending?: number | undefined;
    FinChrg?: number | undefined;
    BudgetCurrent?: number | undefined;
    BudgetOver30?: number | undefined;
    BudgetOver60?: number | undefined;
    BudgetOver90?: number | undefined;
    BudgetOver120?: number | undefined;
    DisplayBalance?: number | undefined;
    DisplayBalanceText?: string | undefined;
    Over30BucketDescription?: string | undefined;
    Over60BucketDescription?: string | undefined;
    Over90BucketDescription?: string | undefined;
    Over120BucketDescription?: string | undefined;
    Over30BucketColorHex?: string | undefined;
    Over60BucketColorHex?: string | undefined;
    Over90BucketColorHex?: string | undefined;
    Over120BucketColorHex?: string | undefined;
    CurrentBucketColorHex?: string | undefined;
    DisplayBalanceColorHex?: string | undefined;
    IsAccountPastDue?: boolean | undefined;
}

export interface CustomerPasswordUpdate
{
    BranchCustId?: string | undefined;
    AccountNumber?: number | undefined;
    NewPassword?: string | undefined;
    OldPassword?: string | undefined;
}

export interface PasswordHistoryPayload
{
    BranchNo?: string | undefined;
    CustomerKey?: string | undefined;
    Password?: string | undefined;
    DataLogical?: string | undefined;
    WebDataLogical?: string | undefined;
    CorpId?: string | undefined;
    CustomerId?: number | undefined;
}

export interface RegisterCustomerV2Result
{
    RegisterCustomerEnum?: RegisterCustomerV2ResultRegisterCustomerEnum | undefined;
    Emails?: string[] | undefined;
    Email?: string | undefined;
}

export interface TempPasswordRequest
{
    DataLogical?: string | undefined;
    CustId?: string | undefined;
    CorpId?: string | undefined;
    Email?: string | undefined;
}

export interface RegisterCustomerCommand
{
    CorpIdDataLogical?: string | undefined;
    CustId?: string | undefined;
    AcctNo?: number | undefined;
    LastName?: string | undefined;
    Email?: string | undefined;
    IsReset?: boolean | undefined;
}

export interface LoginModelV2
{
    IsCustomer?: boolean | undefined;
    Username?: string | undefined;
    CorpId?: string | undefined;
    WebDataLogical?: string | undefined;
    Password?: string | undefined;
}

export interface EmployeeInfo
{
    UserName?: string | undefined;
    PhoneNumber?: string | undefined;
    Email?: string | undefined;
}

export interface TempPasswordOrVerificationCodeRequest
{
    WebDataLogical?: string | undefined;
    CustId?: string | undefined;
    CorpId?: string | undefined;
    Email?: string | undefined;
    PhoneNumber?: string | undefined;
}

export interface Equipment
{
    EqmtInv?: number | undefined;
    InvNo?: string | undefined;
    Comment?: string | undefined;
    BillLseTo?: string | undefined;
    CycPaid?: number | undefined;
    LeaseCat?: string | undefined;
    LeaseLastBilled?: Date | undefined;
    LeaseNo?: number | undefined;
    LeasePC?: string | undefined;
    LeasePdCycle?: number | undefined;
    LeaseStart?: Date | undefined;
    LeaseTaxClass?: string | undefined;
    Leased?: number | undefined;
    OwnCat?: string | undefined;
    Sn?: string | undefined;
    AltCode?: number | undefined;
    Btus?: number | undefined;
    CurrDate?: Date | undefined;
    CurrReading?: number | undefined;
    LowPressure?: string | undefined;
    MeterQty?: string | undefined;
    MeterRead?: string | undefined;
    MeterEst?: string | undefined;
    Multiplier?: number | undefined;
    Pressure?: number | undefined;
    PrevDate?: Date | undefined;
    PrevReading?: number | undefined;
    QuantityUsed?: number | undefined;
    CertDate?: Date | undefined;
    CertCycle?: number | undefined;
    EqLife?: number | undefined;
    RedTagDate?: Date | undefined;
    DatePaint?: Date | undefined;
    CntyCode?: string | undefined;
    RemoteSensorCode?: string | undefined;
    SalePrice?: number | undefined;
    LinkedToEqmt?: string | undefined;
    SerialNoSalesKey?: string | undefined;
    MtrRegion?: number | undefined;
    BatteryLevel?: number | undefined;
    Vin?: string | undefined;
    TradeIn?: string | undefined;
    ListPrice?: number | undefined;
    PaidBoot?: number | undefined;
    LicPlate?: string | undefined;
    LicExpDate?: Date | undefined;
    Color?: string | undefined;
    PurchDate?: Date | undefined;
    PurchPrice?: number | undefined;
    OdomMkh?: string | undefined;
    StartOdom?: number | undefined;
    GroupType?: string | undefined;
    VendorId?: string | undefined;
    PartNo?: string | undefined;
    PurchOrderNo?: string | undefined;
    Record?: string | undefined;
    OriginalRecord?: string | undefined;
    SwoRef?: string | undefined;
    SaleRef?: string | undefined;
    XferBranchNo?: string | undefined;
    XferCust?: string | undefined;
    XferLoc?: number | undefined;
    CustNameXfer?: string | undefined;
    UndergroundTankDisplay?: string | undefined;
    StatusDisplay?: string | undefined;
    LeasePCDisplay?: string | undefined;
    IsEquipMeterType?: boolean | undefined;
    IsUndergroundEnabled?: boolean | undefined;
    IsRemoteSensorEnabled?: boolean | undefined;
    MeterEstCB?: boolean | undefined;
    LowPressureCB?: boolean | undefined;
    SnCB?: boolean | undefined;
    UserDefinedIsDirty?: boolean | undefined;
    StringDescriptions?: EquipmentStringDescriptions | undefined;
    TotalLocationCapacity?: number | undefined;
    Own?: string | undefined;
    OwnDisplay?: string | undefined;
    InstallDate?: Date | undefined;
    LeaseAmt?: number | undefined;
    LeaseStartDate?: Date | undefined;
    LeaseLinkTo?: string | undefined;
    LeaseSn?: boolean | undefined;
    LeasePDCycle?: number | undefined;
    County?: string | undefined;
    LeaseTC?: string | undefined;
    LeaseBillTo?: string | undefined;
    IsRental?: boolean | undefined;
    RentalGroupHeader?: string | undefined;
    LeaseSetInstallDate?: boolean | undefined;
    Status?: string | undefined;
    StatusVisibility?: EquipmentStatusVisibility | undefined;
    NextLeaseBillDate?: Date | undefined;
    DaysFromNextBill?: number | undefined;
    CkOutDate?: Date | undefined;
    NextCkDate?: Date | undefined;
    DaysFromNextCk?: number | undefined;
    IsSystemCheck?: boolean | undefined;
    UndergroundTank?: number | undefined;
    LocDesc?: string | undefined;
    CustName?: string | undefined;
    TypeDesc?: string | undefined;
    TypeValue?: string | undefined;
    TypeValueDisplay?: string | undefined;
    LocCap?: number | undefined;
    Digits?: number | undefined;
    LocationStatus?: string | undefined;
    MfrDate?: Date | undefined;
    Id?: string | undefined;
    CustIdLoc?: string | undefined;
    BranchNoCustKey?: string | undefined;
    CustId?: string | undefined;
    Loc?: number | undefined;
    Desc?: string | undefined;
    Type?: string | undefined;
    Cap?: number | undefined;
    Model?: string | undefined;
    Mfr?: string | undefined;
    BranchNo?: string | undefined;
    RowState?: EquipmentRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface EquipmentStringDescriptions
{
    TypeDescription?: string | undefined;
    AltCodeDescription?: string | undefined;
    MeterQuantityDescription?: string | undefined;
    StatusDescription?: string | undefined;
    RowState?: EquipmentStringDescriptionsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebEquipment
{
    Id?: string | undefined;
    Desc?: string | undefined;
    Type?: string | undefined;
    InstallDate?: Date | undefined;
    Loc?: number | undefined;
    LocDesc?: string | undefined;
    OwnDisplay?: string | undefined;
    Cap?: number | undefined;
    Leased?: number | undefined;
}

export interface EquipmentListItem
{
    TotalLocationCapacity?: number | undefined;
    Own?: string | undefined;
    OwnDisplay?: string | undefined;
    InstallDate?: Date | undefined;
    Leased?: boolean | undefined;
    LeaseAmt?: number | undefined;
    LeaseStartDate?: Date | undefined;
    LeaseLinkTo?: string | undefined;
    LeaseSn?: boolean | undefined;
    LeaseNo?: number | undefined;
    LeasePC?: string | undefined;
    LeasePDCycle?: number | undefined;
    County?: string | undefined;
    LeaseCat?: string | undefined;
    LeaseTC?: string | undefined;
    LeaseBillTo?: string | undefined;
    IsRental?: boolean | undefined;
    RentalGroupHeader?: string | undefined;
    LeaseSetInstallDate?: boolean | undefined;
    Status?: string | undefined;
    StatusVisibility?: EquipmentListItemStatusVisibility | undefined;
    NextLeaseBillDate?: Date | undefined;
    DaysFromNextBill?: number | undefined;
    CkOutDate?: Date | undefined;
    NextCkDate?: Date | undefined;
    DaysFromNextCk?: number | undefined;
    IsSystemCheck?: boolean | undefined;
    UndergroundTank?: number | undefined;
    LocDesc?: string | undefined;
    CustName?: string | undefined;
    TypeDesc?: string | undefined;
    TypeValue?: string | undefined;
    TypeValueDisplay?: string | undefined;
    LocCap?: number | undefined;
    Digits?: number | undefined;
    MeterRead?: boolean | undefined;
    LocationStatus?: string | undefined;
    MfrDate?: Date | undefined;
    Id?: string | undefined;
    CustIdLoc?: string | undefined;
    BranchNoCustKey?: string | undefined;
    CustId?: string | undefined;
    Loc?: number | undefined;
    Desc?: string | undefined;
    Type?: string | undefined;
    Cap?: number | undefined;
    Model?: string | undefined;
    Mfr?: string | undefined;
    BranchNo?: string | undefined;
    RowState?: EquipmentListItemRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebRecentActivity
{
    Date?: Date | undefined;
    Type?: string | undefined;
    Description?: string | undefined;
    Desc?: string | undefined;
    RefNo?: string | undefined;
    Tran?: string | undefined;
    CheckNo?: string | undefined;
}

export interface WebTransaction
{
    Date?: Date | undefined;
    RefNo?: string | undefined;
    Type?: string | undefined;
    Qty?: number | undefined;
    CheckNo?: string | undefined;
    Desc?: string | undefined;
    SaleAmt?: number | undefined;
    UnitPrice?: number | undefined;
    PriceTotal?: number | undefined;
    Loc?: number | undefined;
    SaleType?: string | undefined;
    Category?: string | undefined;
    InventoryNo?: string | undefined;
    Tran?: string | undefined;
    DetailItemCount?: number | undefined;
    NoteText?: string | undefined;
    readonly IsPayment?: boolean | undefined;
    readonly IsNoteItem?: boolean | undefined;
}

export interface WebImageInfoRequest
{
    CustId?: string | undefined;
    BranchNo?: string | undefined;
    SearchTexts?: string[] | undefined;
}

export interface ImagingResponse
{
    DatabaseItems?: PrintwatcherDbConnectionInfo[] | undefined;
    DataBaseInfo?: DataBaseInfo | undefined;
    AXSystemDataBaseInfo?: DataBaseInfo | undefined;
    CustImageDocumentList?: ArchiveDocument[] | undefined;
    ImagingFolderPath?: string | undefined;
    ImagingFolderPathFileName?: string | undefined;
    NonExceptionErrorMessage?: string | undefined;
    AXFolderFound?: number | undefined;
    axUserProfile?: PrintWatcherAxInfo | undefined;
    TransferSucceeded?: boolean | undefined;
    FolderItems?: SelectionItem[] | undefined;
    TreeViewItems?: ArchiveMenuItem[] | undefined;
    TreeViewItem?: ArchiveMenuItem | undefined;
    ExistingSubfolderFound?: boolean | undefined;
    ExistingTabFound?: boolean | undefined;
    DeleteSuccessful?: boolean | undefined;
    InvalidFileNames?: PrintWatcherReportRecord[] | undefined;
    DocTableInsertSuccessful?: boolean | undefined;
    ResponseStatus?: ResponseStatus | undefined;
}

export interface PrintwatcherDbConnectionInfo
{
    DbName?: string | undefined;
    DbConnString?: string | undefined;
    DbImagePath?: string | undefined;
}

export interface DataBaseInfo
{
    UserName?: string | undefined;
    PassWord?: string | undefined;
    DataSource?: string | undefined;
    BranchNo?: string | undefined;
    DataBaseName?: string | undefined;
    RowState?: DataBaseInfoRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface ArchiveDocument
{
    DocumentKey?: number | undefined;
    DocumentName?: string | undefined;
    DateArchived?: Date | undefined;
    DocumentPath?: string | undefined;
    DocumentFilename?: string | undefined;
    DocumentExtension?: string | undefined;
    DocumentFilesize?: number | undefined;
    RemainUntil?: Date | undefined;
    FileCabinetKey?: number | undefined;
    FileCabinetName?: string | undefined;
    DrawerKey?: number | undefined;
    DrawerName?: string | undefined;
    FolderKey?: number | undefined;
    FolderName?: string | undefined;
    SubFolderKey?: number | undefined;
    SubFolderName?: string | undefined;
    TabKey?: number | undefined;
    TabName?: string | undefined;
    CustomerName?: string | undefined;
    CustomerId?: string | undefined;
    LocationId?: number | undefined;
    LocationName?: string | undefined;
    DataBaseInfo?: DataBaseInfo | undefined;
    FullImagingPath?: string | undefined;
    RowState?: ArchiveDocumentRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface PrintWatcherAxInfo
{
    SystemUserWindowsName?: string | undefined;
    SystemUserIdentity?: number | undefined;
}

export interface ArchiveMenuItem
{
    Type?: string | undefined;
    ParentText?: string | undefined;
    CustomerAccountNo?: number | undefined;
    IsCustomer?: boolean | undefined;
    FolderCount?: number | undefined;
    Text?: string | undefined;
    SubTexts?: string | undefined;
    HasSubMenuItems?: boolean | undefined;
    SubMenuItems?: ArchiveMenuItem[] | undefined;
    IsSelected?: boolean | undefined;
    IsHitTestVisible?: boolean | undefined;
    CannotReselectIfSelected?: boolean | undefined;
    IsVisible?: boolean | undefined;
    ItemVisibility?: ArchiveMenuItemItemVisibility | undefined;
    IsExpanded?: boolean | undefined;
    IsEnabled?: boolean | undefined;
    SubfolderKey?: number | undefined;
    TabKey?: number | undefined;
    CabinetKey?: number | undefined;
    FolderKey?: number | undefined;
    DrawerKey?: number | undefined;
    RowState?: ArchiveMenuItemRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface PrintWatcherReportRecord
{
    MonthsToRetain?: number | undefined;
    ArchiveStorageName?: string | undefined;
    AccountId?: string | undefined;
    PageCount?: number | undefined;
    Cabinet?: string | undefined;
    Drawer?: string | undefined;
    Permanent?: string | undefined;
    IndexField1?: string | undefined;
    IndexField2?: string | undefined;
    IndexField3?: string | undefined;
    IndexField4?: string | undefined;
    IndexField5?: string | undefined;
    IndexField6?: string | undefined;
    IndexField7?: string | undefined;
    IndexField8?: string | undefined;
    IndexField9?: string | undefined;
    IndexField10?: string | undefined;
    NewFolderName?: string | undefined;
    FileName?: string | undefined;
    FileExtension?: string | undefined;
    FullFileName?: string | undefined;
    Folder?: string | undefined;
    Subfolder?: string | undefined;
    Tab?: string | undefined;
    DocumentName?: string | undefined;
    RenameFileName?: string | undefined;
    RenameFileNameDoesNotExist?: boolean | undefined;
    RenameFileNameIsValid?: boolean | undefined;
    SubfolderKey?: number | undefined;
    TabKey?: number | undefined;
    CabinetKey?: number | undefined;
    FolderKey?: number | undefined;
    DrawerKey?: number | undefined;
    RowState?: PrintWatcherReportRecordRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface LocationListItem
{
    FullAddress?: string | undefined;
    FullAddressOneLine?: string | undefined;
    AltFullAddress?: string | undefined;
    LocationUsageDesc?: string | undefined;
    PersonnelId?: number | undefined;
    TaxGroup?: string | undefined;
    TaxClass?: string | undefined;
    LocationDescription?: string | undefined;
    VehicleId?: number | undefined;
    MaxQty?: number | undefined;
    MinPct?: number | undefined;
    PoNumber?: string | undefined;
    IsEnabled?: boolean | undefined;
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    Loc?: number | undefined;
    DelAdr1?: string | undefined;
    DelAdr2?: string | undefined;
    DelAdr3?: string | undefined;
    DelAdr4?: string | undefined;
    DeliveryInstructions?: string | undefined;
    Type?: string | undefined;
    TypeDescription?: string | undefined;
    Cat?: string | undefined;
    CatDesc?: string | undefined;
    AltAdr1?: string | undefined;
    AltAdr2?: string | undefined;
    AltAdr3?: string | undefined;
    AltCity?: string | undefined;
    AltState?: string | undefined;
    AltZip?: string | undefined;
    CountryCode?: string | undefined;
    TotalHeatCapacity?: number | undefined;
    DdRegion?: number | undefined;
    DdType?: string | undefined;
    Dd2Type?: string | undefined;
    RouteSeq?: number | undefined;
    LocUsageDesc?: string | undefined;
    Inactive?: boolean | undefined;
    AltAdr1Visibility?: LocationListItemAltAdr1Visibility | undefined;
    AltAdr2Visibility?: LocationListItemAltAdr2Visibility | undefined;
    AltAdr3Visibility?: LocationListItemAltAdr3Visibility | undefined;
    AltCityStateZipVisibility?: LocationListItemAltCityStateZipVisibility | undefined;
    AltCityStateZip?: string | undefined;
    CharactersRemaining?: number | undefined;
    RowState?: LocationListItemRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface Location
{
    SameAsBillingAddr?: number | undefined;
    Driver?: number | undefined;
    DriverName?: string | undefined;
    TaxGroup?: string | undefined;
    TaxGroupDesc?: string | undefined;
    TaxClass?: string | undefined;
    TaxClassDesc?: string | undefined;
    TermsCode?: number | undefined;
    TermsCodeDesc?: string | undefined;
    Metered?: string | undefined;
    RouteSeqDesc?: string | undefined;
    RawLatitude?: number | undefined;
    RawLongitude?: number | undefined;
    GpsLong?: number | undefined;
    GpsLongEw?: string | undefined;
    GpsLat?: number | undefined;
    GpsLatNs?: string | undefined;
    Latitude?: string | undefined;
    Longitude?: string | undefined;
    Contract?: string | undefined;
    InvTransfer?: string | undefined;
    LocUsageDesc1?: string | undefined;
    LocUsageDesc2?: string | undefined;
    LocUsageDesc3?: string | undefined;
    LocUsageDesc4?: string | undefined;
    LocUsageDesc5?: string | undefined;
    LocUsageDesc6?: string | undefined;
    LocUsageDesc7?: string | undefined;
    LocUsageDesc8?: string | undefined;
    LocUsageDesc9?: string | undefined;
    LocUsageDesc10?: string | undefined;
    PriceAdj?: number | undefined;
    PriceCode?: number | undefined;
    Price?: number | undefined;
    Qty?: number | undefined;
    FuelSales?: number | undefined;
    NonfuelSales?: number | undefined;
    QtyLyr?: number | undefined;
    FuelSalesLyr?: number | undefined;
    NonfuelSalesLyr?: number | undefined;
    QtyLy2?: number | undefined;
    FuelSalesLy2?: number | undefined;
    NonfuelSalesLy2?: number | undefined;
    DelTicket?: string | undefined;
    SveDelTicket?: string | undefined;
    DnldExtndTkt?: string | undefined;
    DnldLeaveTkt?: string | undefined;
    DnldNoCopies?: number | undefined;
    SignatureRequired?: number | undefined;
    AllowExtraCharge?: number | undefined;
    CorpId?: string | undefined;
    DailyRteSun?: number | undefined;
    DailyRteMon?: number | undefined;
    DailyRteTue?: number | undefined;
    DailyRteWed?: number | undefined;
    DailyRteThu?: number | undefined;
    DailyRteFri?: number | undefined;
    DailyRteSat?: number | undefined;
    ActiveDailyRoutes?: number[] | undefined;
    LockPrice?: number | undefined;
    LockDate?: Date | undefined;
    TotalPrice?: number | undefined;
    LockKey?: number | undefined;
    PoNumber?: string | undefined;
    CommisSlsprsn?: number | undefined;
    CommisStartDate?: Date | undefined;
    VirtualUsage?: number | undefined;
    Temperature?: number | undefined;
    LastDeliveryDate?: Date | undefined;
    LastQtyUsed?: number | undefined;
    LastPctFill?: number | undefined;
    MaxPerOfFill?: number | undefined;
    MinPerOfFill?: number | undefined;
    HistLimitDate?: Date | undefined;
    TchkLastDate?: Date | undefined;
    TchkLastTime?: Date | undefined;
    TchkAuto?: string | undefined;
    TchkCycle?: number | undefined;
    TchkLastPct?: number | undefined;
    TchkLastHist?: string | undefined;
    DdCurrKFact?: number | undefined;
    QtyPerDDCurrDisplay?: number | undefined;
    QualityOfFit?: number | undefined;
    MRecalcEnable?: number | undefined;
    DdLastKFact?: number | undefined;
    QtyPerDDLastDisplay?: number | undefined;
    LastBConst?: number | undefined;
    BConstUse?: number | undefined;
    BConstUseDisplay?: number | undefined;
    SummerConstUse?: number | undefined;
    KfRecalc?: number | undefined;
    KfSConstCycle?: number | undefined;
    KfWConstCycle?: number | undefined;
    KfLastCycle?: number | undefined;
    KfLastKfDate?: Date | undefined;
    KfNextKfDate?: Date | undefined;
    FdSchedCode?: string | undefined;
    FdScheduleCodeHasValue?: boolean | undefined;
    FdSchedFlip?: string | undefined;
    FdDlvDay?: number | undefined;
    FcSchedCode?: string | undefined;
    LocCode?: string | undefined;
    ScalePrice?: boolean | undefined;
    ScalePriceType?: number | undefined;
    IsCylinder?: boolean | undefined;
    EstimatedNextDelivery?: Date | undefined;
    EstimatedPercent?: number | undefined;
    EstimatedPercentDate?: Date | undefined;
    OriginalRecord?: string | undefined;
    Cat1?: string | undefined;
    CatDesc1?: string | undefined;
    Price1?: number | undefined;
    PrcCode1?: number | undefined;
    Var1?: number | undefined;
    LockPrice1?: number | undefined;
    LockDate1?: Date | undefined;
    TotalPrice1?: number | undefined;
    Cat2?: string | undefined;
    CatDesc2?: string | undefined;
    Price2?: number | undefined;
    PrcCode2?: number | undefined;
    Var2?: number | undefined;
    LockPrice2?: number | undefined;
    TotalPrice2?: number | undefined;
    LockDate2?: Date | undefined;
    Cat3?: string | undefined;
    CatDesc3?: string | undefined;
    Price3?: number | undefined;
    PrcCode3?: number | undefined;
    Var3?: number | undefined;
    LockPrice3?: number | undefined;
    LockDate3?: Date | undefined;
    TotalPrice3?: number | undefined;
    Cat4?: string | undefined;
    CatDesc4?: string | undefined;
    Price4?: number | undefined;
    PrcCode4?: number | undefined;
    Var4?: number | undefined;
    LockPrice4?: number | undefined;
    LockDate4?: Date | undefined;
    TotalPrice4?: number | undefined;
    Cat5?: string | undefined;
    CatDesc5?: string | undefined;
    Price5?: number | undefined;
    PrcCode5?: number | undefined;
    Var5?: number | undefined;
    LockPrice5?: number | undefined;
    LockDate5?: Date | undefined;
    TotalPrice5?: number | undefined;
    EstimatedFillAmount?: number | undefined;
    Units?: string | undefined;
    FWWK1_6?: string | undefined;
    FWWK7_12?: string | undefined;
    FWWK13_18?: string | undefined;
    FWWK19_24?: string | undefined;
    FWWK25_30?: string | undefined;
    FWWK31_36?: string | undefined;
    FWWK37_42?: string | undefined;
    FWWK43_48?: string | undefined;
    FWWK49_53?: string | undefined;
    IsYard?: boolean | undefined;
    IgnoreContractPrice?: boolean | undefined;
    GLDivision?: string | undefined;
    InterfaceField?: string | undefined;
    LastDeliveryWasOverride?: boolean | undefined;
    MeterLockCode?: string | undefined;
    NgRegion?: number | undefined;
    StartCode?: string | undefined;
    EndCode?: string | undefined;
    EndDate?: Date | undefined;
    LocationTankType?: LocationTankType | undefined;
    IsWillCallLocType?: boolean | undefined;
    Contacts?: Contact[] | undefined;
    SalesforceLocationId?: string | undefined;
    FCManualDeliveriesDeleted?: boolean | undefined;
    FCManualDeliveriesGenerated?: boolean | undefined;
    FCManualDeliveriesModified?: boolean | undefined;
    TchkAutoBool?: boolean | undefined;
    DeliveryCompleteQty?: number | undefined;
    DeliveryCompleteAmt?: number | undefined;
    ServiceDate?: Date | undefined;
    DeliveryPromiseDate?: Date | undefined;
    ServiceCompleteDate?: Date | undefined;
    NextDeliveryDate?: Date | undefined;
    DaysUntilNextDelivery?: string | undefined;
    DaysSinceLastDeliveryInteger?: number | undefined;
    EstimatedRunOutDate?: Date | undefined;
    DaysUntilRunOut?: string | undefined;
    NextServiceWorkOrderDate?: Date | undefined;
    DaysUntilNextSWO?: string | undefined;
    LastServiceWorkOrderDate?: Date | undefined;
    DaysSinceLastSWO?: string | undefined;
    FullAddress?: string | undefined;
    IsAddressFullyFilledOut?: boolean | undefined;
    Contact1PhoneName?: string | undefined;
    Contact2PhoneName?: string | undefined;
    DelTicketDisplay?: string | undefined;
    IsLockedPrice?: boolean | undefined;
    IsContractPrice?: boolean | undefined;
    IsLocationPrice?: boolean | undefined;
    FWYearSchedule?: string | undefined;
    LocationPriceLabel?: string | undefined;
    LocationTypeDescription?: string | undefined;
    LocUsageDescDisplay?: string | undefined;
    DeliveryTicketTypeDescription?: string | undefined;
    AreClusteredLocationsValid?: boolean | undefined;
    ClusteredLocationsInvalidReason?: LocationClusteredLocationsInvalidReason | undefined;
    ClusteredLocations?: LocationListItem[] | undefined;
    OrderCount?: number | undefined;
    DecimalGpsLat?: number | undefined;
    DecimalGpsLon?: number | undefined;
    DoesTankMonitorHaveSignalError?: boolean | undefined;
    StringDescriptions?: LocationStringDescriptions | undefined;
    BranchCustIdKey?: string | undefined;
    BranchNo?: string | undefined;
    CustId?: string | undefined;
    Loc?: number | undefined;
    DelAdr1?: string | undefined;
    DelAdr2?: string | undefined;
    DelAdr3?: string | undefined;
    DelAdr4?: string | undefined;
    DeliveryInstructions?: string | undefined;
    Type?: string | undefined;
    TypeDescription?: string | undefined;
    Cat?: string | undefined;
    CatDesc?: string | undefined;
    AltAdr1?: string | undefined;
    AltAdr2?: string | undefined;
    AltAdr3?: string | undefined;
    AltCity?: string | undefined;
    AltState?: string | undefined;
    AltZip?: string | undefined;
    CountryCode?: string | undefined;
    TotalHeatCapacity?: number | undefined;
    DdRegion?: number | undefined;
    DdType?: string | undefined;
    Dd2Type?: string | undefined;
    RouteSeq?: number | undefined;
    LocUsageDesc?: string | undefined;
    Inactive?: boolean | undefined;
    AltAdr1Visibility?: LocationAltAdr1Visibility | undefined;
    AltAdr2Visibility?: LocationAltAdr2Visibility | undefined;
    AltAdr3Visibility?: LocationAltAdr3Visibility | undefined;
    AltCityStateZipVisibility?: LocationAltCityStateZipVisibility | undefined;
    AltCityStateZip?: string | undefined;
    CharactersRemaining?: number | undefined;
    RowState?: LocationRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface LocationStringDescriptions
{
    DriverName?: string | undefined;
    TaxGroupDescription?: string | undefined;
    TaxClassDescription?: string | undefined;
    PriceCodeDescription?: string | undefined;
    TermsCodeDescription?: string | undefined;
    DeliveryTicketStatusDescription?: string | undefined;
    CatDesc?: string | undefined;
    RowState?: LocationStringDescriptionsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebLocation
{
    CatDesc?: string | undefined;
    Category?: string | undefined;
    DaysSinceLastSWO?: string | undefined;
    DaysUntilNextDelivery?: string | undefined;
    DaysUntilNextSWO?: string | undefined;
    DelTicket?: string | undefined;
    EstimatedNextDelivery?: Date | undefined;
    EstimatedPercent?: number | undefined;
    TankType?: WebLocationTankType | undefined;
    FuelSales?: number | undefined;
    FuelSalesLyr?: number | undefined;
    FullAddress?: string | undefined;
    LastDeliveryDate?: Date | undefined;
    Loc?: number | undefined;
    LocUsageDesc?: string | undefined;
    TypeDescription?: string | undefined;
    LocationTypeDescription?: string | undefined;
    MaxPerOfFill?: number | undefined;
    NextDeliveryDate?: Date | undefined;
    Qty?: number | undefined;
    QtyLyr?: number | undefined;
    TotalHeatCapacity?: number | undefined;
    Units?: string | undefined;
    AltAdr1?: string | undefined;
    AltCity?: string | undefined;
    AltState?: string | undefined;
    AltZip?: string | undefined;
    LocationPriceLabel?: string | undefined;
    Price?: number | undefined;
    TchkAutoBool?: boolean | undefined;
    DeliveryInstructions?: string | undefined;
    RouteSeqDesc?: string | undefined;
    DeliveryTicketTypeDescription?: string | undefined;
    Inactive?: boolean | undefined;
}

export interface WebPriceCalculator
{
    BranchCustId?: string | undefined;
    LocationId?: number | undefined;
    Category?: string | undefined;
    QuantityTotal?: number | undefined;
    EstimatedPercent?: number | undefined;
    LocationPrice?: number | undefined;
    Taxes?: number | undefined;
    OtherCharges?: number | undefined;
    TotalAmount?: number | undefined;
    Field?: number | undefined;
}

export interface UsState
{
    Name?: string | undefined;
    Abbreviation?: string | undefined;
}

export interface PriceControl
{
    PriceCode?: number | undefined;
    ScaleType?: number | undefined;
    HistoryOption?: number | undefined;
    PriceDate?: Date | undefined;
    Qty?: number | undefined;
    Price?: number | undefined;
    PriceDisplay?: number | undefined;
    PercentOver?: number | undefined;
    DollarOver?: number | undefined;
    MinimumDollar?: number | undefined;
    PriceLimit?: number | undefined;
    BaseCharge?: number | undefined;
    BaseVolumeDays?: number | undefined;
    PriceType?: string | undefined;
    PriceDesc?: string | undefined;
    Record?: string | undefined;
    OriginalRecord?: string | undefined;
    RowState?: PriceControlRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebSettings
{
    UseRCCMailServer?: boolean | undefined;
    RequireEstimatePercent?: boolean | undefined;
    ThemeName?: string | undefined;
    Announcement?: string | undefined;
    DeliveryDisclaimer?: string | undefined;
    DeliveryDisclaimerText?: string | undefined;
    SWODisclaimer?: string | undefined;
    SWODisclaimerText?: string | undefined;
    RestrictDeliveryForCODFromWeb?: boolean | undefined;
    DeliveryForCODFromWebMessage?: string | undefined;
    UseDefaultRestrictCODMessage?: boolean | undefined;
    RestrictPaymentRequiredDelivery?: boolean | undefined;
    RestrictPaymentRequiredMessage?: string | undefined;
    UseDefaultRestrictPaymentRequiredMessage?: boolean | undefined;
    IsLocationPriceEnabledWeb?: boolean | undefined;
    AreEstimatedPercentsEnabled?: boolean | undefined;
    AreContractsEnabled?: boolean | undefined;
    AreLYRandYTDVisible?: boolean | undefined;
    IsPriceCalculatorEnabled?: boolean | undefined;
    IsPriceCalculatorAmountsLockEnabled?: boolean | undefined;
    IsPaymentRequiredForCODDelivery?: boolean | undefined;
    PaymentRequiredForCODDeliveryMessage?: string | undefined;
    UseDefaultPaymentRequiredForCODDeliveryMessage?: boolean | undefined;
    AreThresholdAmountsForDeliveryEnabled?: boolean | undefined;
    MinDeliveryAmount?: number | undefined;
    MaxDeliveryAmount?: number | undefined;
    AreContactsEditable?: boolean | undefined;
    IsImagingEnabled?: boolean | undefined;
    IsInvoiceViewingEnabled?: boolean | undefined;
    IsStatementViewingEnabled?: boolean | undefined;
    IsLetterViewingEnabled?: boolean | undefined;
    IsAppEmployeeOnly?: boolean | undefined;
    IsEmployeeMFARequired?: boolean | undefined;
    WebEmail?: string | undefined;
    RowState?: WebSettingsRowState | undefined;
    IsChecked?: boolean | undefined;
    MessageId?: string | undefined;
}

export interface WebFeatureResponse
{
    IsNewCustomerSearchAvailable?: boolean | undefined;
    IsCustomerCommentAvailable?: boolean | undefined;
    IsCNAMTableAvailable?: boolean | undefined;
}

export interface WebSwoDeliveryRequest
{
    CustId?: string | undefined;
    BranchNo?: string | undefined;
    Message?: string | undefined;
    Contact?: string | undefined;
    Loc?: number | undefined;
    Date?: Date | undefined;
    ActionDate?: Date | undefined;
    Phone?: string | undefined;
    ContactEmail?: string | undefined;
    TankLevel?: number | undefined;
    RequestType?: string | undefined;
    TotalAmount?: number | undefined;
    QuantityTotal?: number | undefined;
    LocationPrice?: number | undefined;
    Customer?: WebCustomer | undefined;
    Company?: WebCompany | undefined;
    Location?: WebLocation | undefined;
}

export interface AppWebError
{
    ErrorDateTimeUTC?: Date | undefined;
    CorpId?: string | undefined;
    CustomerId?: string | undefined;
    DataLogical?: string | undefined;
    RcciVersion?: string | undefined;
    ClientVersion?: string | undefined;
    ApiVersion?: string | undefined;
    UserAgent?: string | undefined;
    MobilePlatform?: string | undefined;
    DeviceVersion?: string | undefined;
    DeviceInfo?: string | undefined;
    IsWeb?: boolean | undefined;
    Unhandled?: boolean | undefined;
    ErrorMessage?: string | undefined;
}

export interface WebTrackingLog
{
    DateTimeUTC?: Date | undefined;
    DataLogical?: string | undefined;
    CorpId?: string | undefined;
    LogType?: string | undefined;
    CustomerId?: string | undefined;
    EmployeeId?: string | undefined;
    ApiVersion?: string | undefined;
    CalledFrom?: string | undefined;
    Data?: string | undefined;
    UserAgent?: string | undefined;
    MobilePlatform?: string | undefined;
    DeviceVersion?: string | undefined;
    DeviceInfo?: string | undefined;
    IPAddress?: string | undefined;
    IsWeb?: boolean | undefined;
    ClientVersion?: string | undefined;
}

export interface WebSelectionItem
{
    Message?: string | undefined;
    Value?: number | undefined;
}

export interface WebNotificationSettings
{
    Customer?: WebCustomer | undefined;
    Company?: WebCompany | undefined;
    Contact?: ContactWeb | undefined;
}

export interface WebRegistration
{
    CustId?: string | undefined;
    AccountNo?: number | undefined;
    CustomerEmail?: string | undefined;
    TemporaryPassword?: string | undefined;
}

export enum RowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum RowState2
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum BankAccountProcessorName
{
    Unassigned = 0,
    Authorize = 1,
    Tiger = 2,
    Qualpay = 3,
    GoEmerchant = 4,
    Basys = 5,
    Frontstream = 6,
}

export enum CreditCardProcessorName
{
    Unassigned = 0,
    Authorize = 1,
    Tiger = 2,
    Qualpay = 3,
    GoEmerchant = 4,
    Basys = 5,
    Frontstream = 6,
}

export enum RowState3
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum NotesOption
{
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum RowState4
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum CompanyRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSMasterRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSPaymentRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSCompanyRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSAutoPayRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSProcessorInfoRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSAutoPayListRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum APSTypeRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum SalesforceSettingsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum SageIntacctSettingsSageIntacctPartner
{
    SWK = 0,
    G3 = 1,
}

export enum SageIntacctSettingsLocationIdVisibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum CavagnaSettingsCavagnaChargeOption
{
    Gallons = 0,
    CubicFeet = 1,
}

export enum AutoPaySettingsBankAccountProcessorName
{
    Unassigned = 0,
    Authorize = 1,
    Tiger = 2,
    Qualpay = 3,
    GoEmerchant = 4,
    Basys = 5,
    Frontstream = 6,
}

export enum AutoPaySettingsCreditCardProcessorName
{
    Unassigned = 0,
    Authorize = 1,
    Tiger = 2,
    Qualpay = 3,
    GoEmerchant = 4,
    Basys = 5,
    Frontstream = 6,
}

export enum AutoPaySettingsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum AutoPayPaymentTypeInfoPaymentType
{
    BankAccount = 0,
    Mastercard = 1,
    Visa = 2,
    Discover = 3,
    AmericanExpress = 4,
}

export enum AutoPayPaymentTypeInfoExtraFeeOption
{
    No = 0,
    Yes = 1,
    WebOnly = 2,
    StoreOnly = 3,
}

export enum AutoPayPaymentTypeInfoExtraFeeValueType
{
    Amount = 0,
    Percent = 1,
}

export enum AutoPayPaymentTypeInfoRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum GeneralSettingsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum DispatchManagerSettingsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ModuleSettingsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum UserRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum CountryMasterRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum CompanyBaseRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum SelectionItemRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum BranchListItemRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum StateProvinceMasterRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ContractRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ContractWebRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ContractLetterRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum AdvancedSearchOptionsSelectedCategory
{
    AllCategories = 0,
}

export enum AdvancedSearchOptionsSelectedSortBy
{
    CustomerName = 0,
    CustomerNameDesc = 1,
    AccountNumber = 2,
    AccountNumberDesc = 3,
    CustId = 4,
    CustIdDesc = 5,
}

export enum AdvancedSearchOptionsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ContactPhoneType
{
    Home = 0,
    Cell = 1,
}

export enum ContactRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum CommunicationResultItemRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum CustomerAgingVariablesAddr1Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum CustomerAgingVariablesAddr2Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum CustomerAgingVariablesRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum AgedTrialBalanceTransactionRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum HistoryMyEventType
{
    Sale = 0,
    Payment = 1,
    Charge = 2,
    Adjustment = 3,
    Correspondence = 4,
    Note = 5,
    Delivery = 6,
    ActionItem = 7,
    Reminder = 8,
    ToDo = 9,
}

export enum HistoryRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum RegisterCustomerV2ResultRegisterCustomerEnum
{
    AlreadyRegistered = 0,
    NoEmailAvailable = 1,
    CheckEmail = 2,
    ChooseEmail = 3,
    Restricted = 4,
    Error = 999,
}

export enum EquipmentStatusVisibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum EquipmentRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum EquipmentStringDescriptionsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum EquipmentListItemStatusVisibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum EquipmentListItemRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum DataBaseInfoRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ArchiveDocumentRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum ArchiveMenuItemItemVisibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum ArchiveMenuItemRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum PrintWatcherReportRecordRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum LocationListItemAltAdr1Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationListItemAltAdr2Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationListItemAltAdr3Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationListItemAltCityStateZipVisibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationListItemRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum LocationTankType
{
    Propane = 0,
    FuelOil = 1,
    Unknown = 2,
    Meter = 3,
    NonFuel = 4,
}

export enum LocationClusteredLocationsInvalidReason
{
    None = 0,
    FDSchedCodeWithDailyRoutesSet = 1,
    TooManyLocationsInCluster = 2,
}

export enum LocationAltAdr1Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationAltAdr2Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationAltAdr3Visibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationAltCityStateZipVisibility
{
    Visible = 0,
    Hidden = 1,
    Collapsed = 2,
}

export enum LocationRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum LocationStringDescriptionsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum WebLocationTankType
{
    Propane = 0,
    FuelOil = 1,
    Unknown = 2,
    Meter = 3,
    NonFuel = 4,
}

export enum PriceControlRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export enum WebSettingsRowState
{
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3,
}

export class ApiException extends Error
{
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any)
    {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException
    {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any>
{
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string>
{
    return new Observable<string>((observer: any) =>
    {
        if (!blob)
        {
            observer.next("");
            observer.complete();
        } else
        {
            let reader = new FileReader();
            reader.onload = event =>
            {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}